export default {
    "corporate": "कॉर्पोरेट प्रोग्राम",
    "onboarding": {
        "goal_desc": "आप अपनी एक्टिविटी को ट्रैक करने के लिए %{customPoints} कमाएंगे और अपने गोल पूरे करने के लिए बोनस %{customPoints} कमाएंगे। शुरू करने का समय आ गया है! आप किसी भी समय 3 पर्सनल गोल एक्टिव रख सकते हैं।",
        "sample_task": {
            "modalActivityTitle": "3 गहरी साँसे",
            "rewards_featured_title": "फ़ीचर्ड",
            "rewards_partners_title": "पार्टनर्स",
            "header_description": "आप अपनी एक्टिविटी को ट्रैक करके और टास्क, गोल्स और चैलेंजेस को पूरा करके %{customPoints} कमाएंगे।",
            "icon_text": "गहरी साँस को ट्रैक करने के लिए {icon} पर टैप करें।",
            "activityName": "गहरी साँस लें",
            "activityUnit": "साँस लें"
        },
        "lets_get_started": "चलिये शुरू करते है!",
        "start_description": "आप अपनी एक्टिविटी को ट्रैक करके और टास्क, गोल्स और चैलेंजेस को पूरा करके %{customPoints} कमाएंगे।",
        "complete_and_earn": "पूरा करें और कमाएं",
        "did_it": "मैंने यह कर लिया!",
        "task_complete": "टास्क पूरा हुआ!",
        "breath_sample_task": "एक्टिविटी ट्रैकिंग के बारे में एक क्विक ट्यूटोरियल लें",
        "track_a_sample_activity": "सैंपल एक्टिविटी को ट्रैक करें",
        "nice": "बहुत बढ़िया!",
        "nice_one": "बहुत बढ़िया!",
        "nice_subtext_1": "आपने %{points} %{customPoints} कमाए है।",
        "nice_subtext_2": "%{customPoints} कमाने से आपको अपना लेवल बढ़ाने में मदद मिलेगी। हर बार जब आप एक लेवल ऊपर जाते हैं, तो आपको %{reward_currency} मिलेगा, जिसे बेहतरीन ऑफ़र के लिए रिडीम किया जा सकता है।",
        "nice_subtext_3": "जब आप ज़्यादा टास्क पूरे करेंगे, एक्टिविटी को ट्रैक करेंगे, तथा गोल्स और चैलेंजेस पूरे करेंगे तो आपको ज़्यादा पॉइंट्स मिलेंगे।",
        "progress_subtitle": "आपके %{customPoints} और प्रोग्रेस हर %{frequency} पर रीसेट हो जाते हैं।",
        "skip_for_now": "अभी के लिए स्किप करें",
        "loadingText": "जब तक हम आपका वेलबीइंग स्कोर कैलकुलेट करते हैं, तब तक थोड़ा इंतज़ार करें।",
        "goal_title": "पर्सनलाइज़ गोल सेट करें",
        "swipe_for_more": "ज़्यादा देखने के लिए स्वाइप करें",
        "skip_goals": "मेरा गोल सेट करना अभी के लिए पूरा हो चुका है।",
        "complete_profile": "",
        "level": "लेवल",
        "finish_onboarding_action": "कृपया पहले ऑनबोर्डिंग पूरी करें",
        "vital_stats": {
            "height_ft": "ऊंचाई फीट में",
            "height_in": "ऊंचाई इंच में"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "आपकी गोपनियता महत्वपूर्ण हैं"
        },
        "levels": {
            "title": "कामयाबियाँ और रिवॉर्ड",
            "tableTitle": "कामयाबी"
        },
        "initialScreen": {
            "title": "%{programName} में आपका स्वागत है, %{username}!",
            "getRewarded": "%{rewardName} रिवॉर्ड पाएं",
            "completeAgainst": "अपने सहकर्मियों के साथ मुक़ाबला करें",
            "earnPoints": "हेल्थ की एक्टिविटीज़ से पॉइंट्स कमाएं",
            "levelUp": "लेवल आगे बढ़ाएं और बैज अनलॉक करें"
        },
        "starterGoals": {
            "title": "गोल चुनें",
            "subtitle": "एक नई वेलबीइंग आदत के साथ अपनी खुशहाली का सफ़र शुरू करें।"
        }
    },
    "healthkit_not_available": "Apple Health से कनेक्ट करने में असमर्थ। Health ऐप में, सोर्सेज़ के तहत, सुनिश्चित करें कि आपके पास स्टेप्स के लिए मिनिमम इनेबल की गई परमिशन है और कम से कम 1 स्टेप ट्रैक किया गया है।",
    "changeCover": "फ़ोटो बदलें",
    "joiningCommunityToast": {
        "success": {
            "message": "आपने सफलतापूर्वक %{name} को जॉइन कर लिया है",
            "title": "कम्युनिटी को जॉइन करें"
        }
    },
    "achievement_starts_date": "शुरू होता है: %{date}",
    "editChallenge": "%{challengeName} को एडिट करें",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "5 एक्टिविटीज़ तक चुनें",
            "title": "आप क्या करना चाहेंगे?",
            "noActivityTitle": "एक्टिविटीज़ जोड़ी जा रही है",
            "noActivityMessage": "कम से कम एक एक्टिविटी या कैटेगरी चुनें।",
            "categoryItemDescription": "%{category} कैटेगरी की सभी एक्टिविटीज़",
            "addActivityTitle": "आप हर %{period} में %{activity} के कितने %{unit} करना चाहते हैं?",
            "addCategoryQuantityTitle": "आप %{category} कैटेगरी में कितने %{customPoints} कमाना चाहते हैं?",
            "subtitleCategories": "एक कैटेगरी चुनें। उस कैटेगरी की सभी एक्टिविटीज़ गोल में योगदान देंगी।",
            "subtitleWithActivities": "%{max} में से %{num} एक्टिविटी चुनी गई",
            "selectCategoryMessage": "कैटेगरी की सभी एक्टिविटीज़ को चुना जाएगा और पहले से चुनी गई एक्टिविटीज़ को खारिज कर दिया जाएगा।",
            "addActivityTitleTotal": "आप %{period} में कितनी %{activity} करना चाहते हैं?"
        },
        "inviteDepartments": {
            "title": "डिपार्टमेंट \/ डिवीजन को इन्वाइट करें"
        },
        "inviteRegions": {
            "title": "क्षेत्रों को इन्वाइट करें"
        },
        "createInvitation": {
            "selectMore": "कृपया कम से कम 2 %{entity} को चुनें!"
        },
        "visibility": {
            "title": "विज़िबिलिटी",
            "description": "सभी %{programName} यूज़र्स टीम चैलेंजेस को ढूंढ सकते है और जॉइन कर सकते हैं।"
        },
        "highest": {
            "name": "जिसके पास सबसे ज़्यादा %{customPoints} होंगे, वह जीत जाएगा",
            "description": "कोई सीमा नहीं, सबसे ज़्यादा %{customPoints} वाले को पहला स्थान मिलता है"
        },
        "compete": {
            "individual": "पर्सनल रूप से मुक़ाबला करें",
            "team": "टीम के रूप में मुक़ाबला करें"
        },
        "unitType": {
            "title": "चुनें कि आप अपना गोल कैसे पूरा करेंगे",
            "subtitle": "एक्टिविटीज़ या कैटेगरी में से चुनें"
        },
        "category": {
            "name": "किसी कैटेगरी की सभी एक्टिविटीज़",
            "description": "उदाहरण के लिए, 'मूव' में किसी भी एक्टिविटी को ट्रैक करें",
            "title": "कैटेगरी चुनें",
            "subtitle": "आप किस कैटेगरी से एक्टिविटीज़ को ट्रैक करेंगे?"
        },
        "activities": {
            "name": "चुनी हुई एक्टिविटीज़",
            "description": "उदाहरण के लिए, साइकिल चलाने जैसी खास एक्टिविटी को ट्रैक करें",
            "title": "एक्टिविटीज़ पसंद करें",
            "subtitle": "हम एक ही एक्टिविटी पर फ़ोकस करना रेकमेंड करते हैं लेकिन आप 5 तक जोड़ सकते हैं",
            "maxModalTitle": "मैक्सिमम एक्टिविटीज़ चुनी गई",
            "maxModalDescription": "आप ज़्यादा से ज़्यादा 5 एक्टिविटीज़ जोड़ सकते हैं। अपनी 5 चुनी हुई एक्टिविटीज़ के साथ आगे बढ़ने के लिए स्वीकार करें पर टैप करें या बदलाव करने के लिए एडिट करें पर टैप करें।",
            "warningModalTitle": "बहुत मुश्किल",
            "warningModalDescription": "आपने इस गोल में हर अवधि में पूरी करने के लिए बहुत सी एक्टिविटीज़ रखी हैं। क्या आप वाकई इतना मुश्किल भरा गोल सेट करना चाहते हैं?",
            "requiredPoints": "%{period} %{challengeType} को पूरा करना जरूरी है",
            "noActivitiesModalTitle": "एक्टिविटीज़ जोड़ी जा रही है",
            "noActivitiesModalDescription": "कम से कम एक एक्टिविटी चुनें।"
        },
        "categoryQuantity": {
            "title": "अपना %{customPoints} का गोल सेट करें",
            "subtitle": "आप हर %{period} में %{category} से कितने %{customPoints} कमाना चाहते हैं?",
            "subtitleTotal": "आप %{category} %{period} से कितने %{customPoints} कमाना चाहते हैं?",
            "text": "एक गाइडलाइंस के अनुसार, 30 मिनट की मध्यम एक्टिविटी लगभग 105% %{customPoints} के बराबर है",
            "noQuantityModalTitle": "मात्रा",
            "noQuantityModalDescription": "वैल्यू दाखिल करें",
            "defaultCategoryTitle": "हाल की कैटेगरी"
        },
        "cancel": {
            "title": "चैलेंज बनाना कैंसिल करें",
            "message": "क्या आप वाकई चैलेंज बनाना कैंसिल करना चाहते हैं?"
        },
        "createNew": "नया चैलेंज बनाएं",
        "chooseChallengeTitle": "कोई चैलेंज चुनें या अपना खुद का चैलेंज बनाएं",
        "createOwn": {
            "title": "मेरा खुद का बनाएं"
        },
        "frequency": {
            "title": "आप अपने गोल को कितनी बार पूरा करेंगे?",
            "subtitle": "रोज़ के गोल्स अच्छी आदतें बनाने में मददगार होते हैं"
        },
        "startAndDuration": {
            "title": "शुरू होने की तारीख और अवधि चुनें",
            "subtitle": "",
            "noFieldsTitle": "शुरू होने की तारीख और अवधि",
            "noFieldsMessage": "कृपया शुरू होने की तारीख और अवधि भरें"
        },
        "finalize": {
            "title": "अपने नए गोल को रिव्यू करें",
            "subtitle": "",
            "noFieldsTitle": "नाम और निर्देश",
            "noFieldsMessage": "कृपया नाम और निर्देश भरें",
            "name": "मेरा %{frequency} %{names} गोल",
            "instructionCategory": "सभी %{category} एक्टिविटीज़ से %{points} %{customPoints} %{frequency} कमाएं",
            "instructionActivities": "%{items} %{frequency} ट्रैक करें और %{points} %{customPoints} %{pointsFrequency} कमाएं",
            "instructionCompetitionCategory": "इस कॉम्पिटिशन को जीतने के लिए सभी %{category} एक्टिविटीज़ से अधिकतम %{customPoints} हासिल करें",
            "instructionCompetitionActivities": "इस कॉम्पिटिशन को जीतने के लिए %{items} से अधिकतम %{customPoints} हासिल करें",
            "namePlaceholder": "अपने कॉम्पिटिशन को नाम दें",
            "titleChallenge": "अपने चैलेंज को आखिरी रूप दें"
        },
        "dailyDescription": "उदाहरण के लिए, हर दिन 8 गिलास पानी पियें",
        "weeklyDescription": "उदाहरण के लिए, हर हफ़्ते 150 मिनट पैदल चलें",
        "monthlyDescription": "उदाहरण के लिए, हर महीने 150 kms दौड़ें",
        "totalDescription": "उदाहरण के लिए, कुल 10,000 kms साइकिल चलाएं",
        "title": "खुद को चैलेंज दें या दूसरों को?",
        "navigatorTitle": "चैलेंज बनाएं",
        "me": {
            "name": "सिर्फ़ मैं",
            "description": "पर्सनल गोल के साथ खुद को चैलेंज दें"
        },
        "others": {
            "name": "दूसरों के साथ मुक़ाबला करें",
            "description": "पर्सनल रूप से या टीम के रूप में मुक़ाबला करें"
        },
        "one": {
            "name": "पर्सनल रूप से",
            "description": "दूसरे यूज़र्स के साथ पर्सनल रूप से मुक़ाबला करें"
        },
        "team": {
            "name": "एक टीम के रूप में",
            "description": "दूसरी टीमों के साथ एक टीम के रूप में मुक़ाबला करें"
        },
        "company": {
            "name": "कंपनी चैलेंज",
            "description": "स्पेशल कॉम्पिटिशन बनाएं"
        },
        "adminItemTitle": "एक एडमिनिस्ट्रेटर के रूप में, आप बना सकते हैं",
        "userOrTeamTitle": "पर्सनल रूप से या टीम के रूप में मुक़ाबला करें?",
        "target": {
            "name": "पूरा करने के लिए एक टार्गेट सेट करें",
            "description": "चैलेंज जिसकी एक ऊपरी सीमा है"
        },
        "typeTitle": "%{challengeType} प्रकार चुनें",
        "teamSizeTitle": "हर टीम के लिए साइज़ चुनें",
        "teamSizeSubtitle": "टीम का मिनिमम साइज़ %{min} और मैक्सिमम साइज़ %{max} है। आपकी टीम के %{customPoints} टीम के सभी मेंबर्स के एवरेज होते हैं और आप %{customPoints} सिर्फ़ तभी कमा सकते हैं जब आपकी टीम मेंबर्स की मिनिमम संख्या पूरी कर लेते हैं।",
        "teamSize": {
            "noFieldsTitle": "मिनिमम और मैक्सिमम",
            "noFieldsMessage": "किसी टीम के लिए मिनिमम और मैक्सिमम मेंबर्स की संख्या चुनें"
        },
        "companyChallengeTitle": "कंपनी चैलेंज",
        "companyChallengeSubtitle": "आप एक एडमिन हैं। आप डिपार्टमेंटल और दूसरे प्रकार के चैलेंज सेट कर सकते हैं",
        "chooseDepartmentTitle": "मुक़ाबला करने के लिए डिपार्टमेंट \/ डिविजन चुनें",
        "chooseRegionTitle": "मुक़ाबला करने के लिए क्षेत्र चुनें",
        "goToChallenge": "मेरे चैलेंज पर जाएं",
        "additional": {
            "title": "चैलेंज को बनाया गया",
            "subtitle": "चलिये शुरू करते है! दूसरों को जॉइन करने के लिए इन्वाइट करें",
            "makePublicName": "इसे पब्लिक बनाएं",
            "makePublicDescription": "कोई भी जॉइन कर सकता है",
            "toDirectoryName": "चैलेंज डायरेक्ट्री में सबमिट करें",
            "toDirectoryDescription": "लोग ऐसा ही एक बना सकते हैं",
            "inviteTitle": "चैलेंज के लिए इन्वाइट करें",
            "titleGoal": "गोल बना दिया गया!"
        },
        "quantityMinimum": {
            "message": "मिनिमम जरूरी मात्रा %{quantity} है",
            "title": "अपर्याप्त मात्रा"
        },
        "toast": {
            "success": "आपका %{challengeType} बना दिया गया है।"
        },
        "goToGoal": "मेरे गोल पर जाएं",
        "navigatorTitleGoal": "गोल बनाएं",
        "quantityError": {
            "wholeNumber": "एक पूर्ण संख्या होनी चाहिए",
            "greaterThanZero": "0 से ज़्यादा होना जरूरी है"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "आपके वेलबीइंग स्कोर की गिनती वेलबीइंग सर्वे में आपके द्वारा दिए गए जवाबों की तुलना आपके जैसे ही उम्र और लिंग कैटेगरी के लाखों दूसरे लोगों के जवाबों से करके की जाती है। आपका स्कोर बताता है कि आप उनकी तुलना में किस रैंक पर हैं। आपका स्कोर ऐप में दाखिल किए गए आपके चलने, खाने और महसूस करने के बर्तावों में होने वाले बदलावों के अनुसार हर महीने अपने आप ही अपडेट हो जाएगा। अपनी हेल्थ को बेहतर बनाने के लिए लगातार गोल सेट करना और सकारात्मक उपाय करना आपकी हेल्थ के स्कोर को बढ़ाने में मदद कर सकता है।",
            "excellent": "आपकी हेल्थ स्कोर आपकी उम्र और लिंग के 85% लोगों से बेहतर है।",
            "very_good": "आपकी हेल्थ स्कोर आपकी उम्र और लिंग के 70-84% लोगों से बेहतर है।",
            "good": "आपका हेल्थ स्कोर आपकी उम्र और लिंग के 51-69% लोगों से बेहतर है।",
            "fair": "आपका हेल्थ स्कोर आपकी उम्र और लिंग के 31-50% लोगों से बेहतर है।",
            "poor": "आपका हेल्थ स्कोर आपकी उम्र और लिंग के 70% लोगों से कम है। लेकिन हेल्थ का ख्याल रखने की शुरुआत कभी भी की जा सकती है। हमारे प्लेटफ़ॉर्म का फ़ायदा उठाएं और अपनी हेल्थ को बेहतर करने की दिशा में आगे बढ़ें!",
            "overall_result": "कुल मिलाकर, आपका वेलबीइंग स्कोर %{status} है।",
            "category_result": "कुल मिलाकर, आपका {category} स्कोर {string} है।",
            "goals": "आप बिना गोल के जीत नहीं सकते। 3 पर्सनल गोल सेट करें और उन्हें हासिल करने के लिए कोशिश करें। समय के साथ-साथ जब आप अपनी जीवनशैली में बदलाव करेंगे तो आप देखेंगे कि आपका स्कोर बढ़ रहा है।"
        },
        "reminder": {
            "title": "अब आपके वेलबीइंग सर्वे को अपडेट करने का समय आ गया है!",
            "updateAnswers": "मेरे जवाबों को अपडेट करें"
        },
        "lastUpdated": "आखिरी बार %{date} को अपडेट हुआ",
        "scoreDescription": {
            "part1": "आपका स्कोर है",
            "part2": "का स्कोर",
            "belowAverage": "एवरेज से कम",
            "aboveAverage": "एवरेज से ज़्यादा",
            "part3": "दूसरों के लिए आपकी उम्र और लिंग।"
        },
        "improveScore": {
            "description": "आपका स्कोर आपके वेलबीइंग सर्वे के जवाबों और ट्रैक की गई एक्टिविटी के आधार पर कैलकुलेट किया जाता है। आप अपने सर्वे के जवाबों को अपडेट कर सकते हैं या सुधार के लिए नए गोल्स सेट कर सकते हैं।",
            "desc1": "आपका स्कोर अब और ज़्यादा नहीं बढ़ सकता! अपने रूटीन को दिलचस्प बनाए रखने के लिए, अपनी साधारण काबिलियत से परे टार्गेट के साथ खुद को चैलेंज दें, और मोटिवेट रहने के लिए दूसरों को आपके साथ मुक़ाबला करने के लिए इन्वाइट करें।",
            "desc2": "अगर आप लेवल को बढ़ाने के लिए सेट हैं, तो चैलेंज को बढ़ाने का समय भी आ गया है। अपनी साधारण क्षमता से परे टार्गेट के साथ खुद को चैलेंज दें, और  मोटिवेट रहने के लिए दूसरों को खुद के साथ मुक़ाबला करने के लिए इन्वाइट करें।",
            "desc3": "खुद को जवाबदेह बनाए रखने और मोटिवेशन बनाए रखने के लिए पर्सनल गोल्स सेट करें और पब्लिक चैलेंजेस बनाएं। आप ऐसे टार्गेट जो हासिल हो सकें और छोटी समय-सीमा चुनें - हम 1 हफ़्ता रेकमेंड करते हैं।",
            "desc4": "हर दिन एक्टिव रहना बहुत जरूरी है। अगर आपके रोज़ के रूटीन में ज़्यादा एक्टिविटी नहीं है, तो अपनी काबिलियत और दिलचस्पियों से मेल खाने वाले छोटे गोल्स से शुरुआत करें। आप हासिल हो सके ऐसे टार्गेट और छोटी समय-सीमा चुनना सुनिश्चित करें - हम 1 हफ़्ता रेकमेंड करते हैं।"
        },
        "recommendedGoals": "रेकमेंड किए गए गोल",
        "recommendedDescription": {
            "desc1": "सेट करें",
            "desc2": "3 गोल्स तक",
            "desc3": "अपनी वेलबीइंग को बेहतर बनाने पर फ़ोकस करने के लिए. आपके पास अभी है"
        },
        "categoryScore": "आपका %{category} स्कोर है",
        "learnMore": "ज़्यादा जानें",
        "youAreSet": "आप सेट है!",
        "goalSetting": "गोल सेट करना",
        "attention": "%{category} स्कोर उपलब्ध नहीं है।",
        "move": {
            "error": "आपके जवाबों के आधार पर आपका मूव स्कोर उपलब्ध नहीं है।"
        },
        "eat": {
            "error": "आपने बताया कि एक हेल्थ केयर प्रोफेशनल ने आपको बताया है कि आपको टाइप 2 डायबिटीज है और यह कंट्रोल से बाहर है।"
        },
        "feel": {
            "error": "आपके जवाबों के आधार पर आपका फील स्कोर उपलब्ध नहीं है।"
        },
        "survey": {
            "requiredField": "* यह फ़ील्ड जरूरी है"
        },
        "score_info_title": "मेरे स्कोर का क्या मतलब है",
        "company_average_info": "मेरी कंपनी में एवरेज",
        "demographic_average_info": "मेरे डेमोग्राफिक में एवरेज",
        "score": "वेलबीइंग स्कोर",
        "table": {
            "what_it_means": "इसका क्या मतलब है",
            "score": "स्कोर"
        },
        "updated": "अपडेट किया गया",
        "label": {
            "excellent": "लाजवाब",
            "very_good": "बहुत अच्छा",
            "good": "अच्छा",
            "fair": "सामान्य",
            "poor": "खराब"
        },
        "activity": {
            "eat": "ईट एक्टिविटी 1, ईट एक्टिविटी 2, ईट एक्टिविटी 3",
            "move": "मूव एक्टिविटी 1, मूव एक्टिविटी 2, मूव एक्टिविटी 3",
            "feel": "फील एक्टिविटी 1, फील एक्टिविटी 2, फील एक्टिविटी 3"
        },
        "score_info_screen": "मेरा स्कोर कैसे कैलकुलेट किया जाता है?",
        "details": "जानकारी",
        "activities": "एक्टिविटीज़",
        "improveCategoryScore": "मेरे %{category} स्कोर में सुधार करें",
        "meaning": {
            "heading": "स्कोर की गिनती"
        },
        "score_button": {
            "meaning": "इस स्कोर का क्या मतलब है?"
        },
        "improve": "रेकमेंड किए गए गोल देखें",
        "score_text": {
            "demographic": "आपकी उम्र और लिंग के लिए एवरेज स्कोर है",
            "company": "और आपकी कंपनी का एवरेज स्कोर है"
        },
        "scoreHigher": "की एवरेज से ज़्यादा",
        "scoreLower": "की एवरेज से कम",
        "settedGoals": {
            "noGoals": "कोई गोल सेट नहीं किए",
            "one": "1 गोल सेट किया",
            "n": "%{count} गोल सेट किए गए"
        },
        "yourScoreIsPoor": "आपका %{category} स्कोर खराब है",
        "unlock": {
            "title": "अपने वेलबीइंग स्कोर अनलॉक करें",
            "description": "यह जानने के लिए एक छोटी प्रश्नावली पूरी करें कि आपकी ओवरऑल हेल्थ आपके डेमोग्राफिक ग्रुप के दूसरे लोगों की तुलना में कैसी है।"
        },
        "browseAndSet": "आप अपने मौजूदा गोल्स पूरे होने के बाद नए गोल्स ब्राउज़ और सेट कर सकते हैं।",
        "excellent": {
            "desc1": "बहुत ही असाधारण हेल्थी जीवनशैली",
            "desc2": "हेल्थ का बहुत कम जोखिम"
        },
        "veryGood": {
            "desc1": "बहुत ही हेल्थी जीवनशैली",
            "desc2": "हेल्थ का कम जोखिम"
        },
        "good": {
            "desc1": "हेल्थी जीवनशैली",
            "desc2": "हेल्थ का एवरेज जोखिम"
        },
        "fair": {
            "desc1": "कुछ हद तक हेल्थी जीवनशैली",
            "desc2": "सामान्य से ज़्यादा हेल्थ का जोखिम"
        },
        "poor": {
            "desc1": "हेल्थ का ज़्यादा जोखिम",
            "desc2": "हर दिन ज़्यादा चलना-फिरना रेकमेंड किया जाता है",
            "desc3": "हर दिन ज़्यादा चलना-फिरना जरूरी है"
        },
        "calculateScore": {
            "description": "जब आप वेलबीइंग सर्वे पूरा करते हैं, तो आपके जवाबों का विश्लेषण आपकी उम्र और लिंग के लोगों के साथ अरबों डेटा वैरिएबल्स का इस्तेमाल करके किया जाता है। कैलकुलेशन में %{programName} में आपके द्वारा ट्रैक की गई एक्टिविटी को भी शामिल किया जाता है।\n\nआपकी हेल्थ स्कोर नियमित रूप से अपडेट होता है ताकि आप समय के साथ इसमें होने वाले बदलावों को देख सकें।"
        },
        "improveYourScore": "अपने स्कोर में सुधार करना"
    },
    "challengerCount": "%{num} चैलेंजर",
    "team_name": "टीम का नाम",
    "syncingDeviceToast": {
        "danger": {
            "message": "उफ़... हमें %{name} को सिंक करने में समस्या हुई। कृपया दोबारा कोशिश करें।",
            "title": "सिंक करें"
        },
        "success": {
            "title": "सिंक करें",
            "message": "%{name} को सफलतापूर्वक सिंक किया गया। आपकी एक्टिविटीज़ अब अप-टू-डेट हैं।"
        }
    },
    "allCompanyMembers": "कंपनी के सभी मेंबर",
    "allCompanyMembersTeam": "कंपनी के सभी मेंबर (टीम)",
    "successfullyRedeemedItemForConfirmation": "आपने इस आइटम को सफलतापूर्वक रिडीम कर लिया है और %{email} पर कन्फ़र्मेशन ईमेल भेज दिया गया है।",
    "no_all_events_placeholder": "ऐसा लगता है कि इस समय जॉइन करने के लिए कोई इवेंट उपलब्ध नहीं है। आप कोई इवेंट क्यों नहीं बनाते?",
    "confirmDeleteAccount": "अपने अकाउंट से जुड़ा ईमेल एड्रेस दाखिल करके डिलीट करना कन्फ़र्म करें",
    "deleteAccount": "अकाउंट डिलीट करें",
    "linkAccounts": "लिंक किए गए अकाउंट मैनेज करें",
    "titleSlug": {
        "icon_reward_text": "योग्य मेंबर्स के लिए हमारे पार्टनर्स के साथ खरीदारी करके या अपने एक्स्ट्रा कवर का इस्तेमाल करके मेंबर्स चॉइस एडवांटेज डेंटिस्ट के पास चेक-अप कराकर और ज़्यादा पॉइंट्स कमाना आसान है।",
        "icon_move_text": "बेहतर नींद लेने या सब्जियां खाने जैसे हर रोज के हेल्थ के विकल्पों की ट्रैकिंग करने से आपको Live Better पॉइंट्स मिल सकते हैं।",
        "icon_redeem_text": "Live Better उन Medibank मेंबर को रिवॉर्ड देता है जिनके पास अपने हेल्थ की देखभाल के लिए अस्पताल या एक्स्ट्रा कवर है।",
        "icon_phone_text": "साइन अप करें और हेल्थ और तंदुरुस्ती के गिफ़्ट कार्ड या अपने वेलबीइंग कवर पर बचत करने जैसे रिवॉर्ड पाने के लिए सेट हो जाएं।",
        "wellness": "हेल्थ की दुनिया में आपका स्वागत है",
        "goals": "अपने गोल हासिल करें",
        "devices": "ट्रैक पर बने रहें",
        "challenges": "चैलेंजेस बनाएं",
        "celebrate": "सोशल वेलनेस",
        "habits": "हेल्थी आदतें बनाएं",
        "joinChallenge": "चैलेंज को जॉइन करें",
        "getSocial": "लोगों से जुड़ें",
        "reward": "अच्छी जिंदगी जीने के लिए रिवॉर्ड पाएं।",
        "move": "चलें, खाएं और बेहतर महसूस करें।",
        "phone": "बेहतर ज़िन्दगी जियें, बेहतर महसूस करें।"
    },
    "viewProgress": {
        "goal": "गोल की प्रोग्रेस देखें",
        "challenge": "चैलेंज की प्रोग्रेस देखें",
        "progress": "प्रोग्रेस देखें"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "यह जानकारी दाखिल करना वैकल्पिक है, और आपके अपने फ़ायदे के लिए है और आपके लिए प्राइवेट है।"
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} बोनस %{customPoints} इस इवेंट के लिए उपलब्ध हैं!"
        },
        "modal": {
            "paragraph1": "इस इवेंट में भाग लेने से आपको बोनस %{pointsName} मिलेगा।",
            "paragraph2": "सभी बोनस %{pointsName} इवेंट पूरा होने के बाद दिए जाते हैं। जिन इवेंट में आप भाग नहीं लेते हैं, उनके लिए आपको बोनस क्रेडिट नहीं मिलेंगे।"
        }
    },
    "EAP": {
        "contactInfo": "संपर्क जानकारी",
        "doLater": "मैं इसे बाद में करूंगा",
        "tellMore": "मुझे और ज़्यादा बताएं",
        "contactMe": "मुझसे कॉन्टेक्ट करें",
        "title": "कर्मचारी और परिवार सहायता प्रोग्राम",
        "reachGoal": {
            "title": "मदद उपलब्ध है",
            "description": "%{providerName} द्वारा दिया जाने वाला आपका कर्मचारी और परिवार सहायता प्रोग्राम (EFAP), आपके वेलबीइंग के गोल्स को हासिल करने में आपकी मदद करने के लिए अलग-अलग तरह की हेल्थ की कोचिंग सर्विसेज़ देता है।\n\nक्या आप चाहते हैं कि %{providerName} आपसे और ज़्यादा जानकारी के लिए कॉन्टेक्ट करे?"
        },
        "privacyPolicy": "%{provider} गोपनीयता नीति"
    },
    "HRIS": {
        "disclaimer": "यह जानकारी ऑटोमैटिक रूप से सेट की जाती है और इसे बदला नहीं जा सकता"
    },
    "settingGoals": {
        "description": "एक ही समय में 3 रेकमेंड किए गए गोल्स पर फ़ोकस करने से आपकी सफलता की संभावना बढ़ जाएगी।",
        "title": {
            "one": "आपने 1 गोल सेट किया है"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "अकाउंट पहले से ही किसी दूसरे यूज़र से लिंक किया हुआ है",
            "lastAccountMessage": "क्या आप वाकई अपना आखिरी लिंक किया हुआ अकाउंट हटाना चाहते हैं? एक बार हटा दिए जाने के बाद आपको ईमेल एड्रेस %{email} और नए पासवर्ड के साथ लॉग इन करना पड़ेगा।",
            "unlinkCorpAccountMessage": "क्या आप वाकई अपना कॉर्पोरेट लिंक किया हुआ अकाउंट हटाना चाहते हैं? एक बार हटा दिए जाने के बाद आपको ईमेल एड्रेस %{email} से दोबारा लॉग इन करना पड़ेगा।",
            "alreadyLinked": "अकाउंट पहले से ही लिंक किया हुआ है",
            "unlinkMessage": "क्या आप वाकई लिंक किया गया अकाउंट हटाना चाहते हैं?"
        },
        "sso": {
            "emailNotVerified": "आपका ईमेल वेरिफ़ाई नहीं किया गया है"
        },
        "signIn": {
            "dontHaveAccount": "क्या आपके पास अकाउंट नहीं है?",
            "enterPIN": "अपनी कंपनी का प्रोग्राम आइडेंटिफिकेशन नंबर दाखिल करें",
            "dontKnowPIN": "अपना PIN नहीं जानते?",
            "pin": "PIN",
            "register": "रजिस्टर करें",
            "pinDescription": "अगर आप अपने ऑर्गनाइज़ेशन के यूनिक प्रोग्राम आइडेंटिफिकेशन नंबर (PIN) के बारे में अनिश्चित हैं, तो अपने प्रोग्राम एडमिनिस्ट्रेटर से कॉन्टेक्ट करें। अगर आपके पास PIN है और आपको अगले स्टेप पर आगे बढ़ने में परेशानी हो रही है, तो support@sproutatwork.com पर कॉन्टेक्ट करें।",
            "keepMeTooltip": "आपकी आसानी के लिए, जब यह बॉक्स चेक किया जाता है तो आपका सेशन 30 दिनों तक मान्य रहेगा। शेयर्ड डिवाइस पर, हम रेकमेंड करते हैं कि आप इस बॉक्स को अनचेक करें और जब आपका काम पूरा जो जाएं तब साइन आउट करें।"
        },
        "signUp": {
            "backToLogin": "लॉगिन पर वापस जाएं",
            "termsOfService": "सेवा की शर्तें",
            "privacyPolicy": "गोपनीयता नीति"
        },
        "createYourAccount": "अपना अकाउंट बनाएं",
        "setYourDetails": "अपनी जानकारी सेट करें",
        "ModaHybridLogin": {
            "noAccessDashboard": "क्या आपके पास मेंबर डैशबोर्ड की एक्सेस नहीं है?",
            "signUpSSOButton": "Moda मेंबर डैशबोर्ड के ज़रिये साइन अप करें",
            "noAccessDashboardWeb": "अगर आपके पास मेंबर डैशबोर्ड का एक्सेस नहीं है, तो नीचे अपने ईमेल और पासवर्ड से लॉग इन करें।",
            "loginSSOButton": "Moda मेंबर डैशबोर्ड के ज़रिये लॉग इन करें"
        }
    },
    "entityHasBeenDeleted": "%{name} को एडिट कर दिया गया है",
    "track_challenge": {
        "message": {
            "manually": "मैन्युअल तरीके से ट्रैक करें",
            "automatically": "%{appOrDeviceName} के साथ ऑटोमैटिक तरीके से ट्रैक किया गया",
            "manuallyOrConnect": "मैन्युअल रूप से ट्रैक करें या कोई ऐप या डिवाइस कनेक्ट करें",
            "manuallyAndBy": "%{appOrDeviceName} के साथ मैन्युअल और ऑटोमैटिक तरीके से ट्रैक करें",
            "reconnectDevice": "डिवाइस जरूरी है। कृपया अपना डिवाइस दोबारा कनेक्ट करें",
            "manualAndAuto": "मैन्युअल और ऑटोमैटिक तरीके से ट्रैक करें",
            "trackedAutomatically": "ऑटोमैटिक तरीके से ट्रैक किया गया"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "साइन अप करने में असमर्थ",
            "message": "पार्टनर से यूज़र की जानकारी निकालने में असमर्थ। कृपया बाद में दोबारा कोशिश करें।"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "इस %{goalName} के लिए एक ऐप या डिवाइस जरूरी है।",
            "subTitle": "कृपया ऐप या डिवाइस कनेक्ट करें"
        }
    },
    "descriptionSlug": {
        "wellness": "हेल्थ की कम्युनिटी को जॉइन करें जो आपको गोल सेट करने, जुड़ने और सही रास्ते पर बने रहने में मदद करती है।",
        "goals": "हमें बताएं कि आप किस दिशा में काम कर रहे हैं। हम आपको रेकमेंड किए गए गोल्स के साथ वहां पहुंचने में मदद करेंगे।",
        "devices": "अपने फ़िटनेस डिवाइस को सिंक करें या अपनी एक्टिविटीज़ को लॉग करें और अपनी हेल्थ के गोल्स को ट्रैक पर रखें।",
        "challenges": "कुछ फ्रेंडली कॉम्पिटिशन शुरू करें। एक चैलेंज बनाएँ और दूसरों को भी इस मजे में शामिल होने के लिए इन्वाइट करें।",
        "celebrate": "सहकर्मियों के साथ जुड़े रहें और अपनी कामयाबियों का जश्न साथ मिलकर मनाएं।",
        "habits": "पॉइंट्स कमाने के लिए हेल्थ की एक्टिविटीज़ को ट्रैक करें। तेज़ी से पॉइंट्स कमाने के लिए अपने फ़ोन या पहनने योग्य डिवाइस से लिंक करें।",
        "joinChallenge": "फ्रेंडली कॉम्पिटिशन में हिस्सा लें और देखें कि तुम अपने साथियों से कितने आगे हो।",
        "getSocial": "सहकर्मियों के साथ जुड़े रहें और अपनी कामयाबियों का जश्न साथ मिलकर मनाएं।",
        "reward_text": "डेली एक्टिविटीज़ और पर्सनल चैलेंजेस को पूरा करने के लिए पॉइंट्स कमाएं।",
        "move_text": "चाहें वह ब्लॉक के चारों ओर टहलना हो, पांच मिनट का ध्यान या हेल्थी खाने की बात हो, आपको रिवॉर्ड दिया जाएगा।",
        "phone_text": "अपने कवर पर डिस्काउंट और बेहतरीन ऑफ़र्स के लिए अपने पॉइंट्स का इस्तेमाल करें, चुनाव आपका है।",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "फ़ीचर इनेबल नहीं किया गया है",
        "checkAppVersion": {
            "message": "ऐसा लगता है कि आपका ऐप पुराना हो गया है। कृपया लेटेस्ट अपडेट इंस्टॉल करें।",
            "button": "%{appName} को अपडेट करें"
        },
        "noConnection": {
            "title": "कोई नेटवर्क कनेक्शन नहीं है",
            "description": "ऐसा लगता है कि आप इंटरनेट से कनेक्ट नहीं हैं। जब तक आपके पास कनेक्शन नहीं होगा, आप एप्लिकेशन का सही से इस्तेमाल नहीं कर पाएंगे।",
            "button": "दोबारा कोशिश करें"
        },
        "uploadPhotoText": "आपके %{entityType} के लिए फ़ोटो जोड़ें",
        "entities": {
            "community": "कम्युनिटी",
            "event": "इवेंट",
            "team": "टीम",
            "goal": "गोल",
            "challenge": "चैलेंज",
            "competition": "कॉम्पिटिशन"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "लॉग इन करने में असमर्थ",
            "resetPasswordHeading": "पासवर्ड रीसेट करना जरूरी है"
        },
        "signup": {
            "corporateOrOther": "क्या आप Medibank के मेंबर नहीं हैं? या किसी कॉर्पोरेट प्रोग्राम का हिस्सा नहीं हैं?",
            "sign_up_here": "यहाँ साइन अप करें",
            "errorHeading": "साइन अप करने में असमर्थ",
            "areYouMedibankMember": "क्या आप एक Medibank मेंबर है?",
            "isMedibankMember": "मैं मेंबर हूं",
            "isNotMedibankMember": "मैं मेंबर नहीं हूं"
        },
        "bpidExists": "दिया गया ईमेल पहले से ही एक Live Better यूज़र के साथ जुड़ा हुआ है, ईमेल यूनिक होना चाहिए।",
        "generalError": "सर्विस फिलहाल उपलब्ध नहीं है"
    },
    "rewardsNoAvailableProducts": "इस समय कोई प्रॉडक्ट उपलब्ध नहीं है।",
    "endedGoal": {
        "timeToTrack": {
            "yes": "आपके पास अभी भी ट्रैक करने का समय है!",
            "no": "आपका %{type} समाप्त हो गया है"
        },
        "grace": "आपका %{type} शायद समाप्त हो गया होगा, लेकिन आपके पास किसी भी भूली हुई एक्टिविटी को ट्रैक करने के लिए %{n} %{text} है",
        "notGrace": {
            "goal": "अपना गोल पूरा करने पर बधाई हो! अपनी हेल्थ के साथ सही दिशा में बने रहने के लिए एक नया गोल सेट करके अपने शानदार काम को जारी रखें।",
            "competition": "चैलेंज पूरा करने पर बधाई हो! किसी दूसरे चैलेंज को जॉइन करके या अपना खुद का चैलेंज बनाकर अपनी प्रोग्रेस बनाए रखें।"
        }
    },
    "appDeviceModal": {
        "defaultMessage": "अपने डिवाइस या ऐप को कनेक्ट करें और बिना किसी रुकावट के ट्रैकिंग को एंजॉय करें। आपका प्रमाणीकरण हमारे टेक्नोलॉजी पार्टनर \"Sprout\" को आपके %{appDeviceTitle} अकाउंट से आपका डेटा सुरक्षित रूप से ट्रांसफर करने की इजाज़त देता है।"
    },
    "noTransactionsMessage": "ऐसा लगता है कि आपने कोई ट्रांजैक्शन नहीं किया है।",
    "noRedemptionsMessage": "ऐसा लगता है कि आपने अभी तक कोई रिडेम्पशन नहीं किया है।",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "आप पर्सनल रूप से या टीम के रूप में चैलेंजेस में मुक़ाबला कर सकते हैं",
            "prompt": "इस समय जॉइन करने के लिए कोई चैलेंज उपलब्ध नहीं है। आप कोई चैलेंज क्यों नहीं बनाते?"
        },
        "createChallengeButton": "चैलेंज बनाएं"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "इवेंट्स सिर्फ़ इन्वाइट भेजे गए लोगों के लिए या किसी भी व्यक्ति के लिए खुले हो सकते है।",
            "button": "इवेंट बनाएं"
        },
        "emptyEventsMessage": "इस समय जॉइन करने के लिए कोई इवेंट्स उपलब्ध नहीं है। आप कोई इवेंट क्यों नहीं बनाते?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Wellbeing",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "आपके पास कोई गोल सेट नहीं है!",
            "descriptionNoSet": "कुछ गोल्स सेट करके अपने वेलबीइंग स्कोर को बेहतर बनाएं। जल्दी से रेकमेंड किए गए गोल के साथ शुरुआत करें, कैटलॉग से चुनें या अपना खुद का गोल बनाएं।",
            "descriptionSet": "आप हमारे द्वारा आपके लिए रेकमेंड किए गए गोल्स में से कोई एक गोल सेट कर सकते हैं, पूरी लिस्ट ब्राउज़ कर सकते हैं, या अपना खुद का गोल बना सकते हैं।",
            "action_text": "नया गोल सेट करें",
            "heading_singular": "आप 1 और गोल सेट कर सकते हैं",
            "heading_plural": "आप %{number} ज़्यादा गोल्स सेट कर सकते हैं"
        },
        "heading": "पर्सनल गोल्स",
        "single": "पर्सनल गोल"
    },
    "settingGoal": {
        "yourGoal": "आपके %{units}",
        "yourGoalDescription": "आप सही रास्ते पर हैं! नीचे दिए गए %{units} सेट कर दिए जाएंगे और तुरंत शुरू हो जाएंगे।",
        "selectedGoals": "चुने गए गोल्स",
        "recommendedDescription": {
            "maximumSet": "आपने मैक्सिमम संख्या में गोल्स सेट कर लिए हैं। आप अपने मौजूदा गोल्स पूरे होने के बाद नए गोल्स ब्राउज़ और सेट कर सकते हैं।",
            "maximumSetTitle": "आपके %{count} गोल्स सेट कर दिये है"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "एक्टिविटी हटा दी गई है",
            "info": "कुछ गलत हुआ। कृपया दोबारा कोशिश करें।",
            "danger": "कुछ गलत हुआ। कृपया दोबारा कोशिश करें।"
        },
        "plural": {
            "success": "एक्टिविटीज़ हटा दी गई है",
            "info": "कुछ गलत हुआ। कृपया दोबारा कोशिश करें।",
            "danger": "कुछ गलत हुआ। कृपया दोबारा कोशिश करें।"
        },
        "success": "एक्टिविटी हटा दी गई है",
        "info": "एक्टिविटी हटाई नहीं गई। कृपया दोबारा कोशिश करें।",
        "danger": "एक्टिविटी हटाई नहीं गई। कृपया दोबारा कोशिश करें।"
    },
    "participants": "सहभागी",
    "members": "मेंबर(र्स)",
    "timeSittingInformationOld": "गाइडलाइंस में नीचे दिये गए सुझाव दिए गए हैं:\n- लंबे समय तक बैठे रहने के समय को कम से कम करें।\n- जितना संभव हो सके लंबे समय तक बैठे रहने की अवधि को कम करें।",
    "timeSittingInformation": {
        "title": "को रेकमेंड की गई गाइडलाइंस:",
        "list": "- लंबे समय तक बैठे रहने के समय को कम से कम करें।\n- जितना संभव हो सके लंबे समय तक बैठे रहने की अवधि को कम करें।"
    },
    "activityLevelInformationOld": "रेकमेंड की गई गाइडलाइंस:\n- हर हफ़्ते ज़्यादातर, लगभग सभी दिन एक्टिव रहना।\n- हर हफ़्ते 150 मिनट से ज़्यादा मध्यम तीव्रता वाली शारीरिक एक्टिविटी करना।\n- हर हफ़्ते कम से कम 2 दिन मसल स्ट्रेचिंग एक्टिविटीज़ करना।",
    "activityLevelInformation": {
        "title": "रेकमेंड की गई गाइडलाइंस:",
        "list": "- हर हफ़्ते ज़्यादातर, लगभग सभी दिन एक्टिव रहना।\n- हर हफ़्ते 150 मिनट से ज़्यादा मध्यम तीव्रता वाली शारीरिक एक्टिविटी करना।\n- हर हफ़्ते कम से कम 2 दिन मसल स्ट्रेचिंग एक्टिविटीज़ करना।"
    },
    "viewGuidelines": "गाइडलाइंस देखें",
    "corporateAccountLink": {
        "verification": {
            "title": "अपना वर्क ईमेल एड्रेस वेरिफ़ाई करें",
            "description": "लिंकिंग प्रोसेस को सफलतापूर्वक पूरा करने के लिए आपको अपना वर्क ईमेल एड्रेस वेरिफ़ाई करना होगा। कृपया यहाँ भेजे गए निर्देश फॉलो करें:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "दोस्तों और परिवार को ढूंढें",
        "findFriends&Family": "दोस्तों और परिवार को ढूंढें",
        "tapToAddFriendsAndFamily": "दोस्तों और परिवार में जोड़ने के लिए टैप करें",
        "addedFriendsAndFamily": "दोस्तों और परिवार में जोड़ा गया",
        "whoYouAreLookingFor": "आप जिसे खोज रहे हैं वह व्यक्ति आपको दिखाई नहीं दे रहा?",
        "inviteWithEmail": "ईमेल द्वारा इन्वाइट करें",
        "sentInvitations": "इन्विटेशन भेजा गया",
        "foundPerson": "हमें यह व्यक्ति मैच हो रहे ईमेल से मिला",
        "youAreBoth": "आप दोनों %{entityName} में हैं",
        "youAreBothMore": "आप दोनों %{entityName}, +%{n} और में हैं",
        "noFriendsAndFamilyAdded": "ऐसा लगता है कि आपने अभी तक किसी दोस्त या परिवार को नहीं जोड़ा है।",
        "sendInvitation": "इन्विटेशन भेजें",
        "youHaveNoSentInvitations": "आपने कोई इन्विटेशन नहीं भेजा है",
        "toast": {
            "success_title": "इन्विटेशन भेजा गया",
            "success_description": "%{invite_email} को उनके इनबॉक्स में इन्विटेशन दिखाई देगा",
            "danger_title": "इन्विटेशन असफल रहा",
            "danger_description": "कृपया बाद में दोबारा कोशिश करें।"
        },
        "email": {
            "invalid_email": "कृपया एक मान्य ईमेल एड्रेस दाखिल करें"
        },
        "inviteOthers": "दूसरों को इन्वाइट करें",
        "searchForSomeone": "किसी को खोजें",
        "searchForOthersToInvite": "इन्वाइट करने के लिए दूसरे लोगों को खोजें",
        "programNameOnly": {
            "title": "सिर्फ़ %{programName}",
            "description": "यह %{entityType} सिर्फ़ उन लोगों के लिए उपलब्ध है जो %{programName} का हिस्सा हैं"
        },
        "domainCannotBeUsed": "इस डोमेन का इस्तेमाल %{programName} के साथ नहीं किया जा सकता",
        "actionSearchByEmail": "जिसे आप ढूंढ रहे हैं अगर आपको वह व्यक्ति नहीं मिल रहा है तो ईमेल द्वारा इन्वाइट करें",
        "send": "भेजें",
        "addEmailToList": "ईमेल को लिस्ट में जोड़ें",
        "toBeSent": "भेजे जाने वाले इन्विटेशन",
        "noInvitationsToBeSent": "कोई इन्विटेशन नहीं",
        "removeEmailConfirmation": "क्या आप वाकई इस ईमेल को लिस्ट से हटाना चाहते हैं?",
        "yes": "हाँ",
        "no": "नहीं",
        "foundByEmail": "हमें यह व्यक्ति मैच हो रहे ईमेल से मिला",
        "addToFriendsAndFamily": "दोस्तों और परिवार में जोड़ें",
        "alreadyAddedEmail": "आपने पहले ही इस ईमेल को लिस्ट में जोड़ लिया है"
    },
    "pointsCurrencyAdditionalInfo": "आपके %{points_name} और लेवल हर %{period} में नए सिरे से शुरू होते हैं। आपकी सभी ट्रैक की गई एक्टिविटीज़ उस अवधि में आपके ओवरऑल लेवल में योगदान करती हैं।",
    "rankLabel": "रैंक",
    "leaderboards": {
        "loadingLabel": "लीडरबोर्ड लोड किए जा रहे है... इसमें कुछ मिनट लग सकते हैं - ऐसा लगता है कि हर कोई एक्टिव हो गया है!"
    },
    "feeds": {
        "emptyListHomePage": "अभी दिखाने के लिए कोई पोस्ट नहीं है। ज़्यादा पोस्ट दिखाने के लिए स्ट्रीम को एडजस्ट करने की कोशिश करें।",
        "viewingPostsFrom": "से पोस्ट देख रहे है",
        "postActivity": "अपनी एक्टिविटीज़ के बारे में कमेंट या फ़ोटो जोड़ें!",
        "indicatorLoader": {
            "defaultTitle": "रिफ्रेश किया जा रहा है...",
            "successfulLoadedTitle": "सिंक और रिफ्रेश किया गया..."
        },
        "inapropriateTextError": {
            "message": "आपके मैसेज का कंटेंट अनुचित हो सकता है। कृपया ज़्यादा फ्रेंडली भाषा का इस्तेमाल करने की कोशिश करें।"
        },
        "postImageError": {
            "title": "माफ़ करें, हम इसे पोस्ट नहीं कर सकते",
            "message": "आपके द्वारा जोड़ी गई इमेज अनुचित हो सकती है। कृपया कोई दूसरी इमेज ट्राई करें।"
        }
    },
    "syncModal": {
        "connect": {
            "title": "%{name} से कनेक्ट किया जा रहा है",
            "description": "अपने %{name} डेटा को अपने अकाउंट के साथ कनेक्ट करने के लिए नीचे दिये गए स्टेप्स को पूरा करें:",
            "firstStep": "%{storeName} से %{appName} मोबाइल एप्लिकेशन डाउनलोड और इंस्टॉल करें",
            "fourthStep": "%{name} से कनेक्ट करने के लिए चुनें",
            "fifthStep": "प्रॉम्प्ट किए जाने पर, %{appName} के साथ सिंक करने के लिए हेल्थ मेट्रिक्स को चुनें और 'हो गया' दबाएं",
            "additionalInfo": "कृपया ध्यान दें कि Health ऐप से सिंक को ट्रिगर करने के लिए, %{appName} को खोला जाना जरूरी है। हालांकि आपको ऐप को खुला रखने की जरूरत नहीं है, लेकिन सिंक को पूरा होने और आपकी एक्टिविटी लॉग में दिखाई देने में एक घंटा लग सकता है।"
        },
        "title": "%{name} को सिंक किया जा रहा है",
        "description": "अपने %{name} डेटा को अपने अकाउंट के साथ सिंक करने के लिए नीचे दिये गए स्टेप्स को पूरा करें:",
        "steps": {
            "one": "अपने फ़ोन पर अपने %{appName} ऐप में साइन इन करें",
            "two": "अपनी प्रोफ़ाइल में ऐप्स और डिवाइसिस सेक्शन खोलें",
            "three": "%{name} के पास सिंक बटन दबाएँ",
            "iPhone": "अपने iPhone पर अपने %{appName} ऐप में साइन इन करें"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "वर्क अकाउंट",
            "message": "अकाउंट को सफलतापूर्वक कनेक्ट किया गया"
        },
        "danger": {
            "message": "अकाउंट को कनेक्ट करते समय एरर आया"
        },
        "conflict": {
            "message": "अकाउंट पहले से ही किसी दूसरे यूज़र से लिंक किया हुआ है"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "वर्क अकाउंट",
            "message": "अकाउंट को सफलतापूर्वक डिसकनेक्ट किया गया"
        },
        "danger": {
            "title": "अकाउंट्स को लिंक करें",
            "message": "अकाउंट को डिसकनेक्ट करते समय एरर आया"
        }
    },
    "earnMoreWithPartners": "पार्टनर के साथ और ज़्यादा कमाएं",
    "connectPartnersToEarnByShopping": "अपने अकाउंट्स को कनेक्ट करें और %{program_name} पार्टनर्स के साथ शॉपिंग करके ज़्यादा %{unit_type} कमाएं।",
    "viewAllPartners": "सभी पार्टनर्स को देखें",
    "myPartnerMemberships": "मेरी पार्टनर मेंबरशिप",
    "linkAccount": "मेंबरशिप लिंक करें",
    "linkToPartner": "पार्टनर से लिंक करें",
    "linkingError": "आपका अकाउंट लिंक करने में समस्या हुई। कृपया दोबारा कोशिश करें।",
    "linkPending": "लिंक पेंडिंग",
    "unlinkAccount": "अकाउंट को अनलिंक करें",
    "linkedToPartnerName": "%{partner_name} के साथ लिंक किया गया",
    "linked": "लिंक किया गया",
    "permission": {
        "facebookTitle": "Facebook से साइन अप करें",
        "googleTitle": "Google से साइन अप करें",
        "facebookDescription": "Facebook से साइन अप करते समय आपको हमारे टेक्नोलॉजी पार्टनर \"Sprout\" को आपकी पहचान एक्सेस करने और अपना %{programName} अकाउंट बनाने की परमिशन देनी होगी।",
        "googleDescription": "Google से साइन अप करते समय आपको हमारे टेक्नोलॉजी पार्टनर \"Sprout\" को आपकी पहचान एक्सेस करने और अपना %{programName} अकाउंट बनाने की परमिशन देनी होगी।",
        "camera": {
            "title": "कैमरा एक्सेस",
            "description": "फ़ोटो लेने के लिए कैमरा एक्सेस की जरूरत होती है। iPhone सेटिंग्स में, %{appName} पर टैप करें और कैमरा चालू करें।\n\nकृपया ध्यान दें कि आप कोई भी सेव नहीं किए गए बदलावों को खो सकते हैं।"
        },
        "notNow": "अभी नहीं",
        "openSettings": "सेटिंग्स खोलें",
        "photos": {
            "title": "कृपया फोटो एक्सेस की इजाज़त दें",
            "description": "इससे आप अपनी लाइब्रेरी से फ़ोटो शेयर कर सकते हैं और फ़ोटो को अपने कैमरा रोल में सेव कर सकते हैं। iPhone सेटिंग्स में, %{appName} पर टैप करें और फ़ोटो को 'पढ़ें और लिखें' पर स्विच करें।\n\nकृपया ध्यान दें कि आप कोई भी सेव नहीं किए गए बदलावों को खो सकते हैं।"
        }
    },
    "firstNameContainsSpecialChar": "आपके पहले नाम में सिर्फ़ अंग्रेजी अक्षर, हाइफ़न - और अपोस्ट्रोफी हो सकते हैं",
    "lastNameContainsSpecialChar": "आपके आखिरी नाम में सिर्फ़ अंग्रेजी अक्षर, हाइफ़न - और अपोस्ट्रोफी ' हो सकते हैं",
    "goToPartnerSite": "पार्टनर साइट पर जाएं",
    "noPartnersFound": "कोई पार्टनर नहीं मिले",
    "noLinkedPartners": "कोई लिंक किए गए पार्टनर नहीं",
    "noPartnersInCategory": "कैटेगरी में कोई पार्टनर नहीं",
    "partnerAccountPendingVerification": "अकाउंट वेरिफ़िकेशन पेंडिंग",
    "shopWithPartner": "पार्टनर से ख़रीदारी करें",
    "shopWithPartnerName": "%{partner_name} के साथ शेयर करें",
    "linkToPartnerName": "%{partner_name} से लिंक करें",
    "earnPartnerMembershipIdentifier": "मेंबरशिप आइडेंटिफ़ायर",
    "earnPartnerAccountPendingAddLink": "आपकी मेंबरशिप लिंक की जा रही है और इसे पूरा होने में कई दिन लग सकते हैं।",
    "earnPartnerAccountPendingRemoveLink": "आपकी मेंबरशिप अनलिंक की जा रही है और इसे पूरा होने में कई दिन लग सकते हैं।",
    "linkStatusUpdating": "लिंक स्टेटस अपडेट किया जा रहा है",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "अपनी पहली एक्टिविटीज़ को जोड़ने के लिए बधाई हो!\n\nअगर आप चाहें, तो आज और दूसरे दिनों के लिए और एक्टिविटीज़ को जोड़ सकते हैं। आज की एक्टिविटीज़ पूरी होने पर, टैप करें",
            "description2": "अगली स्क्रीन पर जब आपके पास ट्रैक करने के लिए और कुछ न हों।"
        },
        "listTitle": "को ट्रैक की गई एक्टिविटीज़",
        "dots": {
            "tracked": "इस दिन को ट्रैक की गई एक्टिविटीज़",
            "added": "एक्टिविटीज़ जोड़ दी गई हैं और सबमिशन के लिए पेंडिंग हैं"
        },
        "trackedActivitiesFor": "%{date} के लिए ट्रैक की गई एक्टिविटीज़",
        "activityTracking": "एक्टिविटी ट्रैकिंग",
        "addedPending": "जोड़ा गया (पेंडिंग सबमिशन)",
        "search": {
            "description1": "टैप करें",
            "description2": "उपलब्ध एक्टिविटीज़ को देखने या किसी स्पेशल एक्टिविटी की खोज करने के लिए"
        },
        "addActivity": "एक्टिविटी को जोड़ें",
        "addAnotherActivity": "दूसरी एक्टिविटी को जोड़ें"
    },
    "rewardsBalance": "%{currencyName} बैलेंस: %{points}",
    "membershipIdentifierRequiredError": "लिंक करने के लिए आपका मेंबरशिप आइडेंटिफ़ायर जरूरी है",
    "incorrectValueInRange": "कृपया %{min} और %{max} के बीच की वैल्यू दाखिल करें",
    "joinTeam": {
        "title": "टीम को जॉइन करें",
        "createInsteadText": "इस चैलेंज में भाग लेने के लिए किसी टीम को जॉइन करें या कोई टीम बनाएं"
    },
    "teamRank": "टीम की रैंक",
    "teamScore": "टीम का स्कोर",
    "appsDevices": {
        "infoText": "ऐप या डिवाइस जोड़ते समय आपसे हमारे टेक्नोलॉजी पार्टनर Sprout Wellness Solutions, Inc. को आपके वेलबीइंग संबंधी डेटा को एक्सेस करने के लिए ऑथराइज़ करने के लिए कहा जाएगा।",
        "connectModal": {
            "title": "ऑथराइज़ेशन",
            "paragraph1Part1": "आपसे हमारे टेक्नोलॉजी पार्टनर को ऑथराइज़ करने के लिए कहा जाएगा",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "अपने वेलबीइंग डेटा को एक्सेस करने के लिए।",
            "paragraph2Desc1": "आपका ऑथराइज़ेशन इजाज़त देता है",
            "paragraph2Desc2": "Sprout को",
            "paragraph2Desc3": "सुरक्षित रूप से सिंक करने के लिए",
            "paragraph2Desc4": "के साथ",
            "paragraph2Desc5": ", और आपको ज़्यादा %{pointsName} कमाने में मदद करता है!"
        },
        "statusAlert": {
            "connectMessage": "किसी ऐप या एक्टिविटी ट्रैकिंग डिवाइस को कनेक्ट करें और एक्टिविटी सिंकिंग और ट्रैकिंग को आसान बनाएं",
            "connectAction": "ऐप या डिवाइस कनेक्ट करें",
            "errorMessage": "आपके कुछ कनेक्टेड ऐप या डिवाइस सिंक करने में असमर्थ हैं",
            "warningMessage": "आपके कुछ कनेक्टेड ऐप या डिवाइस में कनेक्शन संबंधी समस्या हो सकती है",
            "errorAction": "इस एरर को ठीक करें",
            "warningAction": "इस वार्निंग को ठीक करें",
            "syncingError": "सिंकिंग एरर",
            "syncingIssue": "सिंकिंग समस्या"
        },
        "deviceDetails": {
            "warningMessage": "इस ऐप या डिवाइस को सिंक करने में समस्या आ रही है",
            "errorMessage": "यह ऐप या डिवाइस सिंक करने में असमर्थ है",
            "warningAction": "वार्निंग को डिसमिस करें",
            "noActivities": "पिछले 7 दिनों में कोई भी %{deviceName} एक्टिविटी %{programName} से सिंक नहीं हुई है।\n\n%{deviceName} के साथ ट्रैक किए जाने के बाद एक्टिविटीज़ को यहां दिखने में एक घंटे तक का समय लग सकता है।\n\nअगर आपके पास कोई दूसरा ऐप या डिवाइस कनेक्ट है, और दूसरे ऐप या डिवाइस के ज़रिये ज़्यादा स्टेप्स ट्रैक किए गए हैं, तो आपको वहां एक्टिविटी दिखाई देगी। वरना, %{deviceName} को डिस्कनेक्ट करके दोबारा कनेक्ट करने की कोशिश करें। अगर आपसे प्रमाणीकरण करने या परमिशन देने के लिए कहा जाता है, तो सुनिश्चित करें कि आप एक्टिविटी डेटा इनेबल कर रहे हैं और प्रमाणीकरण के लिए उसी अकाउंट का इस्तेमाल कर रहे हैं जिसका इस्तेमाल एक्टिविटीज़ को ट्रैक करने के लिए किया गया था। और ज़्यादा जानकारी के लिए ट्रबलशूटिंग के स्टेप्स को देखें।"
        },
        "troubleshooting": "ट्रबलशूटिंग",
        "deviceItem": {
            "error": "कनेक्शन एरर",
            "warning": "कनेक्शन वार्निंग",
            "unableToSync": "सिंक करने में असमर्थ"
        },
        "platformDevice": {
            "defaultApp": "आपके डिवाइस का डिफ़ॉल्ट हेल्थ ऐप है",
            "continueMore": "और ज़्यादा ऐप्स और डिवाइस पर जारी रखें"
        }
    },
    "friendsAndFamily": {
        "learnMore": "दोस्तों और परिवार के बारे में ज़्यादा जानें",
        "learnModal": {
            "title": "दोस्तों और परिवार के बारे में",
            "description": "किसी व्यक्ति को अपने दोस्तों और परिवार में जोड़ने के बाद, आप %{programName} पर अपनी पोस्ट को सिर्फ़ उनके साथ शेयर करना चुन सकते हैं।\n\nआप %{programName} पर दिखाई देने वाले पोस्ट को सिर्फ़ अपने दोस्तों और परिवार की लिस्ट में शामिल लोगों तक ही सीमित रख सकते हैं, अगर उन्होंने सभी के लिए या आपके लिए पोस्ट किया है।",
            "description_line1": "जब आप किसी व्यक्ति को अपने दोस्तों और परिवार में जोड़ते हैं, तो आप %{programName} पर अपनी पोस्ट सिर्फ़ उनके साथ ही शेयर करना चुन सकते हैं।",
            "description_line2": "आप %{programName} पर दिखाई देने वाले पोस्ट को सिर्फ़ अपने दोस्तों और परिवार की लिस्ट में शामिल लोगों तक ही सीमित रख सकते हैं, अगर उन्होंने सभी के लिए या आपके लिए पोस्ट किया है।",
            "whatIconsMean": "आइकन का क्या मतलब है",
            "canAdd": "जोड़ें",
            "added": "जोड़ा गया"
        },
        "searchDescription1": "अपने दोस्तों और परिवार में जोड़ने के लिए लोगों को खोजें।",
        "searchDescription2": "क्या आपको वह व्यक्ति नहीं मिल रहा है जिसे आप ढूंढ रहे हैं? उन्हें ईमेल के ज़रिये जॉइन करने के लिए इन्वाइट करें।",
        "friends&Family": "दोस्त और परिवार",
        "managingTour": {
            "title": "दोस्तों और परिवार को मैनेज करना",
            "body": "अगर आप किसी को अपने दोस्तों और परिवार से हटाना चाहते हैं, तो आइकन पर टैप करें"
        },
        "removeOption": "दोस्तों और परिवार से हटाएं",
        "inviteDescription1": "अपने दोस्तों और परिवार को खोजें।",
        "inviteDescription2": "आप जिसे खोज रहे हैं वह व्यक्ति आपको दिखाई नहीं दे रहा?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "आपके द्वारा सिर्फ़ दोस्तों और परिवार के साथ शेयर की गई पोस्ट अब %{userFirstName} को विज़िबल नहीं होगी।"
        }
    },
    "skipAll": "सभी को स्किप करें",
    "smallMin": "मिनिमम",
    "eap": {
        "skipModal": {
            "title": "क्या आप वाकई यह करना चाहते है?",
            "description": "जब भी आपको जरूरत हो, आप हमेशा अपने प्रोफ़ाइल से कर्मचारी और परिवार सहायता प्रोग्राम से कॉन्टेक्ट कर सकते हैं।"
        },
        "contact": {
            "whatIsBestNumber": "आपसे कॉन्टेक्ट करने के लिए सबसे अच्छा नंबर कौन सा है?",
            "whatIsBestTime": "आपसे कॉन्टेक्ट करने का सबसे अच्छा वक्त क्या है?",
            "morning": "सुबह",
            "afternoon": "दोपहर",
            "evening": "शाम",
            "additionalDetails": "उस समय\/तारीख के बारे में और ज़्यादा जानकारी जब आप कॉन्टेक्ट करना चाहेंगे",
            "message": "%{weekDay} को %{phoneNumber} पर मुझसे कॉन्टेक्ट करें। और ज़्यादा जानकारी: %{additional}",
            "description": "नोट: हम दृढ़ता से रेकमेंड करते हैं कि आप अपने काम के घंटों के अलावा कोई दूसरा समय चुनें और ऐसी जगह चुनें जहाँ आप प्राइवेट बातचीत कर सकें। कृपया अपना टाइमज़ोनर शामिल करें।"
        },
        "phoneNumber": {
            "empty": "यह फ़ील्ड खाली नहीं हो सकता",
            "missingDigits": "फ़ोन नंबर में कम से कम 4 अंक होने चाहिए"
        },
        "myEAP": "मेरा कर्मचारी और परिवार सहायता प्रोग्राम"
    },
    "healthSurveySkipAllTitle": "वेलबीइंग सर्वे स्किप करें",
    "healthSurveySkipAllAlert": "क्या आप वाकई वेलबीइंग सर्वे के बाकी सभी सवालों को स्किप करना चाहेंगे?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "कर्मचारी और परिवार सहायता प्रोग्राम",
            "message": "कृपया अपना फ़ोन नंबर और कॉन्टेक्ट करने का सबसे अच्छा समय बताएं"
        }
    },
    "allMyChallenges": "मेरे चैलेंज",
    "invitedChallenges": "इन्विटेशन",
    "companyChallenges": "कंपनी के चैलेंजेस",
    "completedChallengesEmpty": "ऐसा लगता है कि आपने अभी तक किसी भी चैलेंज को पूरा नहीं किया है।",
    "myChallengesEmpty": "ऐसा लगता है कि आपने अभी तक किसी भी चैलेंज को जॉइन नहीं किया है।",
    "allChallengesEmpty": "कोई चैलेंज उपलब्ध नहीं।",
    "startsToday": "आज शुरू हो रहा है",
    "startedDaysAgo": "%{dayCount} दिन पहले शुरू किया गया",
    "startsInDays": "%{dayCount} दिन में शुरू हो रहा है",
    "privacyOn": "बंद",
    "privacyOff": "चालू",
    "dashboard": {
        "viewLeaderboard": "लीडरबोर्ड देखें",
        "timePeriodProgress": "इस %{period} में आपकी प्रोग्रेस",
        "howToEarn": "पॉइंट्स कैसे कमाएं"
    },
    "privacyChangeConfirmationMessage": "प्राइवेसी बदलें",
    "privacySettingsTitle": "प्राइवेसी",
    "privacySettingsDescription": "आप अपने पिक्चर, नाम और प्रोफ़ाइल को दूसरे यूज़र्स के लिए विज़िबल होना कंट्रोल कर सकते हैं।",
    "mainLeaderBoardSettingsTitle": "ओवरऑल लीडरबोर्ड",
    "challengeLeaderBoardSettingsTitle": "?चैलेंज लीडरबोर्ड",
    "managePrivacySettingUrlTitle": "प्राइवेसी सेटिंग्स मैनेज करें",
    "onboardingFamilyPrivacySettingsMessageOn": "आप दोस्तों और परिवार के खोज परिणामों में विज़िबल हैं। आप खोज परिणामों से खुद को छिपाने का विकल्प चुन सकते हैं।",
    "onboardingFamilyPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको दोस्तों और परिवार के खोज परिणामों में छिपा देती है।",
    "challengeInvitationPrivacySettingsMessageOn": "आप चैलेंज इन्विटेशन के खोज परिणामों में विज़िबल हैं। आप खोज परिणामों से खुद को छिपाने का विकल्प चुन सकते हैं।",
    "challengeInvitationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको चैलेंज इन्विटेशन के खोज परिणामों से छिपाती हैं।",
    "challengeParticipationPrivacySettingsMessageOn": "आप इस चैलेंज के सहभागी के रूप में लिस्ट किए गए हैं। आप अपनी चैलेंजेस से खुद को सहभागी के रूप में छिपाने का विकल्प चुन सकते हैं।",
    "challengeParticipationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको सहभागी के लिस्ट से छिपा देती है।",
    "communityInvitationPrivacySettingsMessageOn": "आप कम्युनिटी इन्विटेशन के खोज परिणामों में विज़िबल हैं। आप खोज परिणामों से खुद को छिपाने का विकल्प चुन सकते हैं।",
    "communityInvitationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको कम्युनिटी इन्विटेशन के खोज परिणामों से छिपाती हैं।",
    "communityParticipationPrivacySettingsMessageOn": "आप इस कम्युनिटी के मेंबर के रूप में लिस्ट किए गए हैं। आप अपनी कम्युनिटीज़ से खुद को मेंबर के रूप में छिपाने का विकल्प चुन सकते हैं।",
    "communityParticipationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको मेंबर के लिस्ट से छिपा देती है।",
    "eventInvitationPrivacySettingsMessageOn": "आप इवेंट इन्विटेशन के खोज परिणामों में विज़िबल हैं। आप खोज परिणामों से खुद को छिपाने का विकल्प चुन सकते हैं।",
    "eventInvitationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको ईवेंट इन्विटेशन के खोज परिणामों से छिपाती हैं।",
    "eventParticipationPrivacySettingsMessageOn": "आप इस इवेंट के सहभागी के रूप में लिस्ट किए गए हैं। आप अपने इवेंट से खुद को सहभागी के रूप में छिपाने का विकल्प चुन सकते हैं।",
    "eventParticipationPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको भाग लेने वाले व्यक्ति के लिस्ट से छिपा देती है।",
    "mainLeaderboardPrivacySettingsMessageOn": "आपको ओवरऑल लीडरबोर्ड पर दिखाया जाता है। आप खुद को छिपाने का विकल्प चुन सकते हैं, जिससे जब दूसरे लोग ओवरऑल लीडरबोर्ड देखेंगे तो आपकी रैंक, पिक्चर और नाम दूर हो जाएगा।",
    "mainLeaderboardPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको तब छिपा देती है जब दूसरे लोग ओवरऑल लीडरबोर्ड देखते हैं।",
    "challengeLeaderboardPrivacySettingsMessageOn": "आपको चैलेंज के लीडरबोर्ड पर दिखाया जाता है। आप खुद को छिपाने का विकल्प चुन सकते हैं, जिससे जब दूसरे लोग चैलेंज के लीडरबोर्ड देखेंगे तो आपकी रैंक, पिक्चर और नाम दूर हो जाएगा।",
    "challengeLeaderboardPrivacySettingsMessageOff": "अभी आपकी प्राइवेसी सेटिंग्स आपको तब छिपा देती है जब दूसरे लोग चैलेंज के लीडरबोर्ड देखते हैं।",
    "thumbsUpConfirmationTitle": "थंब्स अप",
    "thumbsUpConfirmationDescriptionline1": "बधाई हो, आप अपना पहला थंब्स अप देने और दूसरों को मोटिवेट करने जा रहे हैं!",
    "thumbsUpConfirmationDescriptionline2": "आप उन लोगों की लिस्ट में शामिल हो जाएंगे जिन्होंने इस पोस्ट को पसंद किया है और दूसरे लोग आपका पिक्चर, नाम और आपकी प्रोफ़ाइल देख सकते हैं।",
    "thumbsUpConfirmationButtonOk": "थंब्स अप",
    "commentToActionInfoTitle": "दूसरे लोग क्या देखते हैं?",
    "commentToActionMessage": "जब आप कमेंट करते हैं तो दूसरे लोग आपका पिक्चर, नाम और आपकी प्रोफ़ाइल देख सकते हैं।",
    "postToActionTitle": "यह पोस्ट कौन देखता है?",
    "postToActionMessageLine1": "जब आप कोई पोस्ट बनाते हैं, तो आप यह कंट्रोल कर सकते हैं कि उसे कौन देख सकता है और यहां तक कि आप सिर्फ़ अपने लिए भी पोस्ट कर सकते हैं।",
    "postToActionMessageLine2": "आप जो पोस्ट दूसरों के साथ शेयर करेंगे, उनमें आपका पिक्चर और नाम दिखाई देगा और दूसरे लोग आपकी प्रोफ़ाइल देख सकेंगे",
    "privateUsersDescriptionChallenge": "इन सहभागी(यों) ने खुद को लिस्ट से छिपा लिया है",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} प्राइवेट",
    "privateUsersLastNamePlaceHolderChallenge": "सहभागी",
    "privateUsersDescriptionEvent": "इन भाग लेने वाले व्यक्ति (लोगों) ने खुद को लिस्ट से छिपा लिया है",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} प्राइवेट",
    "privateUsersLastNamePlaceHolderEvent": "भाग लेने वाला(वाले) व्यक्ति",
    "privateUsersDescriptionCommunity": "इन मेंबर(र्स) ने खुद को लिस्ट से छिपा लिया है",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} प्राइवेट",
    "privateUsersLastNamePlaceHolderCommunity": "मेंबर(र्स)",
    "noPrivacySettings": "कोई प्राइवेसी सेटिंग्स नहीं",
    "linkToPartnerNameWebsite": "%{partner_name} वेबसाइट के ज़रिये लिंक करें",
    "linkToPartnerWebsiteUrl": "पार्टनर की वेबसाइट का URL",
    "start_end_time": "शुरू होने का और समाप्त होने का समय",
    "joinCreateTeamPrivacyDisclaimer": "आपकी पिक्चर, नाम और प्रोफ़ाइल हमेशा किसी भी व्यक्ति को आपकी टीम को किसी चैलेंज में देखने पर दिखाई देंगे, भले ही आपने अपनी गोपनीयता सेटिंग्स को प्राइवेट (Private) कर दिया हो।",
    "carouselInstructions": {
        "swipe": "अपने सभी गोल्स और चैलेंजेस को देखने के लिए कार्ड स्वाइप करें।",
        "click": "अपने सभी गोल्स और चैलेंजेस को देखने के लिए कार्ड पर क्लिक करें।"
    },
    "achieved": "हासिल किया जाना",
    "hours": "घंटे",
    "createCommunityFlow": {
        "navigatorTitle": "कम्युनिटी बनाएं",
        "stepType": {
            "title": "कम्युनिटी की विज़िबिलिटी",
            "subTitle": "कम्युनिटी को कौन देख पाएगा और जॉइन कर पाएगा?",
            "privateName": "प्राइवेट",
            "publicName": "पब्लिक",
            "privateDescription": "जिन्हें आप इन्वाइट करते हैं सिर्फ़़ वे ही लोग कम्युनिटी को देख पाएंगे या जॉइन हो सकेंगे",
            "publicDescription": "कोई भी इस कम्युनिटी को देख सकता है और जॉइन कर सकता है"
        },
        "stepName": {
            "title": "अपनी कम्युनिटी को नाम दें",
            "subTitle": "अपनी कम्युनिटी को ऐसा नाम दें जो लोगों को बताएं कि यह किस बारे में है।",
            "namePlaceholder": "कम्युनिटी का नाम",
            "noFieldsTitle": "नाम",
            "noFieldsMessage": "कोई नाम दिया नहीं गया है"
        },
        "stepDescription": {
            "title": "आपकी कम्युनिटी के बारे में",
            "subTitle": "दूसरों को बताएं कि आपकी कम्युनिटी किस बारे में है।",
            "descriptionPlaceholder": "डिस्क्रिप्शन (वैकल्पिक)",
            "noFieldsTitle": "डिस्क्रिप्शन",
            "noFieldsMessage": "कोई डिस्क्रिप्शन नहीं दिया गया है"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "फ़ोटो जोड़ें"
        },
        "stepJoin": {
            "title": "हमें समान कम्युनिटीज़ मिली",
            "subTitle": "क्या आप इसके बजाय इनमें से किसी एक कम्युनिटी को जॉइन करना चाहेंगे?"
        },
        "createNew": "नई कम्युनिटी बनाएं"
    },
    "challengeCard": {
        "allActivities": "में सभी एक्टिविटीज़",
        "category": "कैटेगरी"
    },
    "myLinkedPartners": "मेरे लिंक किए गए पार्टनर",
    "leaderboardPosition": "ओवरऑल लीडरबोर्ड पोज़ीशन",
    "remainingInChallenge": "चैलेंज में बाकी",
    "todays_progress": "आज की प्रोग्रेस",
    "this_weeks_progress": "इस हफ़्ते की प्रोग्रेस",
    "this_months_progress": "इस महीने की प्रोग्रेस",
    "achievement": "कामयाबियाँ",
    "challengeCardHeader": {
        "challenge": "चैलेंज",
        "recommended_personal_goals": "रेकमेंड किया गया पर्सनल गोल",
        "personal_goal": "पर्सनल गोल",
        "competition": "कॉम्पिटिशन",
        "recommended_goals": "रेकमेंड किया गया गोल",
        "team_competition": "टीम का कॉम्पिटिशन",
        "team": "टीम"
    },
    "MyMedibank": "मेरी Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "पूरा होने का समय, शुरू होने के समय से पहले नहीं हो सकता",
    "company": "कंपनी",
    "lessThan1DayRemain": "1 दिन से कम",
    "lessThan1HourRemain": "1 घंटे से कम",
    "remainingToday": "आज बाकी",
    "periodEndsDateAndTime": "अवधि समाप्त हो रही है %{date}, %{time}",
    "moreToGo": "%{n} और %{unit} और भी बाकी हैं",
    "reachedYourGoal": "आप अपने गोल %{period} तक पहुँच गए!",
    "reachedYourGoalToday": "आज आपने अपना गोल हासिल कर लिया!",
    "editProfileItemCorrectRange": "कृपया मिनिमम वैल्यू %{min} और मैक्सिमम वैल्यू %{max} के बीच एक मान्य %{itemName} वैल्यू दें",
    "invalidUrl": "अमान्य URL",
    "activityLogChanged": {
        "success": "इस एक्टिविटी में बदलाव सेव कर लिए गए हैं",
        "info": "कुछ गलत हुआ... कृपया दोबारा कोशिश करें।",
        "danger": "कुछ गलत हुआ... कृपया दोबारा कोशिश करें।"
    },
    "discardAlert": {
        "createChallenge": "क्या आप वाकई इस %{challengeType} को खारिज करना चाहते हैं?",
        "inviteByEmail": "क्या आप वाकई बदलावों को खारिज करना चाहते हैं?",
        "createTeam": "क्या आप वाकई इस टीम का क्रिएशन कैंसिल करना चाहते हैं?",
        "cancel": "कैंसिल करें",
        "confirm": "हां, खारिज करें"
    },
    "entityInvalidNameError": "%{entity} के नाम में सिर्फ़ नंबर स्ट्रिंग वैल्यू होनी चाहिए और यह खाली नहीं होना चाहिए",
    "accept": "स्वीकार करें",
    "sync_now": "अभी सिंक करें",
    "reconnect_device": "दोबारा कनेक्ट करें",
    "supported_activities": "सपोर्टेड एक्टिविटीज़",
    "recentlySynced_activity": "हाल ही में सिंक की गई एक्टिविटी",
    "noSyncedActivity_sevenDays": "पिछले 7 दिनों में कोई भी एक्टिविटी सिंक नहीं की गई है",
    "recentActivityLog": {
        "convertingActivityPoints": "एक्टिविटीज़ को सिंक किया जा रहा है...",
        "activityMinuteOrTwo": "इसमें एक या दो मिनट लग सकते हैं...",
        "noNewActivities": "कोई नई एक्टिविटीज़ नहीं जोड़ी गईं... नई एक्टिविटीज़ को सिंक होने में एक घंटे तक का समय लग सकता है।"
    },
    "deleteCommunityCheckbox": "मैं समझता हूं कि इसे वापस पहले जैसा नहीं किया जा सकता",
    "createEvent": {
        "type": {
            "company": "कंपनी का इवेंट",
            "user": "यूजर का इवेंट",
            "title": "इवेंट का प्रकार"
        },
        "privacy": "गोपनीयता (भाग लेने वाले लोगों को दिखाएं या नहीं)",
        "cost": "क़ीमत",
        "associated": {
            "location": "जुड़ा हुआ लोकेशन",
            "department": "जुड़ा हुआ डिपार्टमेंट \/ डिविजन"
        },
        "maxParticipants": "मैक्सिमम सहभागी (वैकल्पिक)",
        "errorMessage": {
            "limit": "%{maxValue} से ज़्यादा नहीं हो सकता",
            "negative": "नेगेटिव वैल्यू नहीं हो सकती",
            "selectedLocations": "कृपया एक या ज़्यादा लोकेशन चुनें"
        },
        "selectLocations": "चुने गए लोकेशन",
        "createNew": "नया इंवेट बनाएं"
    },
    "selected": "चुना गया",
    "deleteEventButton": "इस इवेंट को डिलीट करें",
    "notification": {
        "priorityNotification": {
            "title": "आपके पास बिना पढ़े हुए जरूरी अपडेट है",
            "subtitle": "इन्हें अभी पढ़ने के लिए टैप करें",
            "subtitleWeb": "इन्हें अभी पढ़ने के लिए क्लिक करें"
        },
        "sectionTitle": {
            "priorityUnread": "बिना पढ़े हुए जरूरी अपडेट",
            "all": "सभी नोटिफ़िकेशन्स"
        },
        "modalTitle": "आपके पास %{count} जरूरी अपडेट हैं",
        "priorityModalTitle": {
            "defaultTitle": "सभी अपडेट देखें"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "%{entity} %{actionType} को कैंसिल करें",
            "message": "क्या आप वाकई %{entity} %{actionType} को कैंसिल करना चाहते हैं?"
        },
        "action": {
            "creating": "बनाना",
            "editing": "एडिट करना"
        },
        "type": {
            "team": "टीम",
            "community": "कम्युनिटी",
            "event": "इवेंट",
            "challenge": "चैलेंज",
            "goal": "गोल"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "इसे पब्लिक करें?",
            "private": "इसे प्राइवेट रखें?"
        },
        "modalSubtitle": {
            "public": "इस %{entityType} को पब्लिक करने से यह सभी के लिए खुल जाएगा ताकि वे इसे खोज सकें और इसे जॉइन कर सकें। क्या आप वाकई इस %{entityType} को पब्लिक करना चाहते हैं?",
            "private": "इस %{entityType} को प्राइवेट बनाने से इसे कोई भी खोज नहीं पाएगा और इसे जॉइन नहीं कर पाएगा। क्या आप वाकई इस %{entityType} को पब्लिक बनाना चाहते हैं?"
        },
        "footerButton": {
            "makePublic": "हां, इसे पब्लिक करें",
            "makePrivate": "हां, इसे प्राइवेट रखें",
            "keepPrivate": "प्राइवेट रखें",
            "keepPublic": "पब्लिक करें"
        },
        "label": {
            "title": "इसे पब्लिक %{entityType} बनाएं",
            "subtitle": "हर कोई देख सकता है, और कोई भी जॉइन कर सकता है"
        }
    },
    "imageUploader": {
        "changeImageButton": "इमेज बदलें"
    },
    "copyright": "कॉपीराइट © Sprout 2019",
    "samsunghealth_not_available": "Samsung Health से कनेक्ट करने में असमर्थ। Health ऐप में, डेटा परमिशन के तहत, सुनिश्चित करें कि आपके पास स्टेप्स के लिए मिनिमम इनेबल की गई परमिशन है और कम से कम 1 स्टेप ट्रैक किया गया है।",
    "rewardsHowDoIEarn": "मैं %{currencyName} कैसे कमा सकता हूं?",
    "unlockAchievements": "कामयाबियाँ अनलॉक करें",
    "unlockAchievementsDescription": "एक्टिविटीज़ को ट्रैक करें, %{pointsName} कमाएँ, लेवल को अनलॉक करें और ज़्यादा %{currencyName} कमाएँ। आपको क्या करना है यह देखने के लिए हर कामयाबी पर टैप करें।",
    "myDay": "मेरा दिन",
    "myGoalsChallengesTasks": "मेरे गोल्स, चैलेंजेस और टास्क",
    "yourGoalsChallenges": "आपके गोल्स और चैलेंजेस",
    "mySocialStream": "कम्युनिटी पोस्ट",
    "viewAllAchievements": "सभी कामयाबियाँ देखें",
    "viewAllBonusChallenges": "सभी बोनस चैलेंजेस को देखें",
    "newVersionOfAppAvailable": "नया वर्ज़न उपलब्ध है! कृपया इस पेज को दोबारा लोड करें",
    "noBonusChallengesToDisplay": "फिलहाल कोई बोनस चैलेंज उपलब्ध नहीं है।",
    "bonusChallenges": "बोनस चैलेंज",
    "reloadAppVersion": "दोबारा लोड करें",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "क्या आप वाकई %{activity_name} को ट्रैक करना हटाना चाहते हैं?",
    "activity_tracker_instruction_header": "किसी दिन की एक्टिविटी को ट्रैक करने के लिए उस दिन पर टैप करें, या देखें कि पहले से क्या ट्रैक किया गया था।",
    "alertDashboardFunctionalityToBeAdded": "ट्रैकिंग अवधि क्या होती है, इसे समझाने के लिए यहाँ टेक्स्ट जोड़ा जाएगा, ठीक वैसे ही जैसे एयरलाइन लॉयल्टी प्रोग्रामों के लिए किया जाता है, जहां यूज़र्स को अगले साल के लिए स्टेटस पाने के लिए कैलेंडर साल में \"मील\" जमा करते रहना होता है।",
    "noNumberEntered": "एक्टिविटी की मात्रा दाखिल करें",
    "feed": "स्ट्रीम",
    "home": "होम",
    "challenges": "चैलेंजेस",
    "explore": "एक्सप्लोर करें",
    "rewards": "रिवॉर्ड्स",
    "reward": "रिवॉर्ड",
    "balance": "मेरा %{programName} रिवॉर्ड का बैलेंस",
    "profile": "प्रोफ़ाइल",
    "loading": "लोड हो रहा है...",
    "me": "में",
    "back": "वापस",
    "next": "अगला",
    "skip": "स्किप करें",
    "signup": "साइन अप करें",
    "signin": "लॉग इन करें",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Live Better में लॉग इन करें",
    "signup_with_medibank": "Medibank मेंबर के रूप में साइन अप करें",
    "signup_with_facebook": "Facebook से साइन अप करें",
    "signup_with_google": "Google से साइन अप करें",
    "signup_with_email": "ईमेल से साइन अप करें",
    "signin_with_medibank": "मेरी Medibank का इस्तेमाल करके लॉग इन करें",
    "signin_with_facebook": "Facebook से लॉग इन करें",
    "signin_with_google": "Google से लॉग इन करें",
    "signin_with_email": "ईमेल से लॉग इन करें",
    "signup_heading": "अकाउंट बनाएं",
    "not_a_medibank_member": "क्या आप Medibank मेंबर नहीं है?",
    "keep_me_signed_in": "मुझे लॉग इन हुआ रहने दें",
    "forgotpassword": "अपना पासवर्ड भूल गए?",
    "emailaddress": "ईमेल एड्रेस",
    "password": "पासवर्ड",
    "enterEmailAddress": "आपका ईमेल एड्रेस दाखिल करें",
    "enterYourPassword": "अपना पासवर्ड दाखिल करें",
    "password_for_error": "पासवर्ड",
    "reset_password": "पासवर्ड रीसेट करें",
    "passwordResetSuccess": "पासवर्ड रीसेट किया गया",
    "passwordResetEmailSent": "अगर हमारे सिस्टम में कोई मेल खाता ईमेल है तो पासवर्ड रीसेट करने के निर्देश आपको ईमेल कर दिए गए हैं।",
    "loginerror": "लॉग इन करते समय एक एरर आया:",
    "logincancelled": "लॉग इन करना कैंसिल किया गया",
    "part_of_corporate_program": "क्या आप किसी कॉर्पोरेट प्रोग्राम में साइन अप कर रहे हैं?",
    "continue_here": "यहाँ जारी रखें",
    "program_name": "प्रोग्राम का नाम",
    "error_provide_program_name": "कृपया प्रोग्राम का नाम दें।",
    "program_not_found": "प्रोग्राम नहीं मिला",
    "registration_field_email": "ईमेल",
    "employeeId": "कर्मचारी ID",
    "registration_field_firstName": "पहला नाम",
    "registration_field_lastName": "आखिरी नाम",
    "no_first_name": "कोई पहला नाम नहीं",
    "no_last_name": "कोई आखिरी नाम नहीं",
    "registration_field_password": "नया पासवर्ड",
    "no_disclaimer_available": "ओह, कोई समस्या हुई है... हम आपके ऑर्गनाइज़ेशन के नियम और शर्तें नहीं निकाल सके। कृपया बाद में दोबारा रजिस्ट्रेशन करने की कोशिश करें।",
    "registration_account_not_registered": "ऐसा लगता है कि आपने अभी तक अपना ईमेल एड्रेस वेरिफ़ाई नहीं किया हैं। क्या आप चाहेंगे कि हम ईमेल दोबारा भेजें?",
    "resend_verification_email": "ईमेल वेरिफ़िकेशन",
    "resend_verification_email_successful": "हमने आपका वेरिफ़िकेशन ईमेल दोबारा भेज दिया है।",
    "resend_verification_email_unsuccessful": "ओह, कोई समस्या हुई है... हम वेरिफ़िकेशन ईमेल पुनः भेजने में असमर्थ रहे। कृपया दोबारा कोशिश करें।",
    "not_supported": "इस पोस्ट को अभी नहीं दिखाया जा सकता। कृपया बाद में दोबारा कोशिश करें।",
    "policyAgreeError": "जारी रखने के लिए कृपया सेवा की शर्तों और गोपनीयता नीति से सहमत हों।",
    "challenge_completion_bonus": "पूरा करने पर बोनस",
    "me_tabs": {
        "activity": "एक्टिविटी",
        "bookmarks": "बुकमार्क"
    },
    "health_tab": {
        "my_health_score": "आपका वेलबीइंग स्कोर",
        "overall_health_score_description": "आपका वेलबीइंग स्कोर है",
        "health_score_explanation": "आपका वेलबीइंग स्कोर आपकी हेल्थ और आप कितने एक्टिव हैं से जुड़े जवाबों के आधार पर तय किया जाता है।\n\nआपकी एक्टिविटी के लेवल के आधार पर आपका स्कोर हर महीने अपडेट होता है। आप अपनी हेल्थ के स्कोर को बेहतर बनाने के लिए पर्सनल गोल्स सेट कर सकते हैं और उन्हें पूरा कर सकते हैं।",
        "health_score_calculation_failed_onboarding": "कुछ गलत हुआ और हमें आपका वेलबीइंग स्कोर नहीं मिल पाया हैं। आप अभी आगे बढ़ सकते हैं और जैसे ही समस्या ठीक हो जाएगी, हम आपका स्कोर अपडेट कर देंगे।"
    },
    "track_activity": "एक्टिविटी को ट्रैक करें",
    "track_an_activity": "एक्टिविटी को ट्रैक करें",
    "track": "ट्रैक करें",
    "unable_to_track": "ट्रैक करने में असमर्थ",
    "enter_before_track": "ट्रैक करने के लिए एक्टिविटी की मात्रा दाखिल करें",
    "what_to_share": "आप किस प्रकार का अपडेट शेयर करना चाहेंगे?",
    "remove": "हटाएं",
    "activity_tracking_description": "आप कितने %{units} को ट्रैक करना चाहेंगे?",
    "excessive_submission": "वाह! आप %{activity_name} के लिए 2,000 से ज़्यादा %{customPoints} ट्रैक करने वाले हैं। इसे सबमिट करने से पहले आपको यह सुनिश्चित करना चाहिए कि यह सही है।",
    "on": "को",
    "in": "में",
    "from": "से",
    "at": "पर",
    "no_activities": "आपकी खोज से कोई एक्टिविटी मेल नहीं खाती।",
    "activity_tracking_desc": "जारी रखने के लिए आपको नंबर जोड़ना होगा। कैंसिल करने के लिए बाएं कोने में X पर टैप करें।",
    "activity_tracking_desc2": "एडिट करने के लिए एक्टिविटी पर कहीं भी टैप करें, गोल को तुरंत रूप से ट्रैक करने के लिए + टैप करें",
    "vital_stats_title": "आपके बारे में",
    "invalid_numeric_response": "अमान्य",
    "invalid_numeric_response_range": "यह नंबर %{minimum} और %{maximum} के बीच होना चाहिए",
    "search_placeholder": "लाइब्रेरी में खोजें…",
    "search_activities": "एक्टिविटीज़ खोजें",
    "searching": "खोजा जा रहा है...",
    "searchEmpty": "कोई मैच नहीं मिले",
    "vital_stats_description": "हमें अपने बारे में थोड़ा बताएं",
    "health_survey_questions": "हेल्थ के सर्वे के सवाल",
    "health_survey_title": "हेल्थ का सर्वे पूरा करें",
    "health_survey_results": "हेल्थ के सर्वे के परिणाम",
    "health_survey_card_desc": "अपनी वेलबीइंग का स्नैपशॉट पाने और पर्सनलाइज़ गोल्स सेट करने के लिए सर्वे में भाग लें।",
    "apps_devices_title": "ऐप्स और डिवाइसिस को लिंक करें",
    "apps_devices_card_desc": "%{customPoints} आसानी से कमाने के लिए अपने ऐप्स और डिवाइस को सिंक करें।",
    "interests_title": "दिलचस्पियाँ",
    "interests_card_desc": "हमें अपनी दिलचस्पियों के बारे में बताएं। इससे हमें ऐसे गोल्स और कम्युनिटीज़ रेकमेंड करने में मदद मिलेगी जो आपकी पसंद के हो सकते हैं।",
    "interests_screen_desc": "आप किस चीज़ में दिलचस्पी रखते हैं?",
    "health_obj_title": "हेल्थ के ऑब्जेक्टिव्स",
    "health_obj_card_desc": "हम सोचते हैं कि कुछ गोल्स को सेट करने का समय आ गया है। एक बार जब हम आपके ऑब्जेक्टिव्स को जान लेंगे, तो हम आपके लिए बेहतर रेकमेंडेशन कर सकेंगे। चिंता न करें, अगर आप अपना मन बदलते हैं तो आप बाद में अपनी प्रोफ़ाइल में आसानी से बदलाव कर सकते हैं।",
    "health_obj_screen_desc": "आप किन एरिया में काम करना चाहेंगे?",
    "my_heatlh_obj": "मेरे वेलबीइंग ऑब्जेक्टिव्स",
    "health_topic_title": "हेल्थ के टॉपिक",
    "health_topic_card_desc": "अपने वेलबीइंग संबंधी टॉपिक निर्दिष्ट करके अपने एक्सपीरियंस को पर्सनलाइज़ करें।",
    "health_topic_screen_desc": "आप क्या जानने में दिलचस्पी रखते हैं?",
    "multi_select_check_error": "कृपया आगे बढ़ने के लिए कम से कम 1 विकल्प चुनें",
    "my_health_topics": "वेलबीइंग के टॉपिक",
    "build_your_profile": "अपनी प्रोफ़ाइल बनाएं",
    "personalize_title": "पर्सनलाइज़ करें",
    "personalize_desc": "कुछ फटा-फट सवालों के जवाब देकर अपने एक्सपीरियंस को पर्सनलाइज़ करें।",
    "set_goals_title": "रेकमेंड किए गए गोल देखें",
    "set_goals_desc": "अच्छी हेल्थ की राह पर आगे बढ़ने के लिए पर्सनलाइज़ गोल्स को सेट करें।",
    "set_this_goal": "यह गोल सेट करें",
    "goal_set": "गोल सेट किया",
    "required": "ज़रूरी है",
    "apps_devices_description": "ऑटोमैटिक रूप से %{customPoints} ज़्यादा कमाने के लिए किसी फ़िटनेस प्लेटफ़ॉर्म से जुड़ें।",
    "connected": "कनेक्ट किया गया",
    "num_connected": "(%{numDevices} कनेक्ट किया गया)",
    "available": "उपलब्ध",
    "inProgress": "चालू है...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "आखिरी बार सिंक किया",
    "last_synced_lc": "आखिरी बार सिंक किया",
    "no_connected_devices": "कोई कनेक्ट किए गए डिवाइस नहीं",
    "apps_devices_confirm_disconnect": "क्या आप वाकई डिसकनेक्ट करना चाहते हैं",
    "button_delete": "डिलीट करें",
    "button_disconnect": "डिसकनेक्ट करें",
    "button_cancel": "कैंसिल करें",
    "button_dismiss": "डिसमिस करें",
    "ok": "ओके",
    "waist_helper_text": "आपकी कमर का माप पसलियों के नीचे, आमतौर पर नाभि के लेवल पर, और खड़े होकर लिया जाना चाहिए। अगर आपको नहीं पाता तो अपने जींस के साइज़ का इस्तेमाल करें।",
    "apps_devices_manage": "मेरे ऐप्स और डिवाइसिस को मैनेज करें",
    "my_apps_devices": "मेरे ऐप्स और डिवाइसिस",
    "completeRegistration": "रजिस्ट्रेशन पूरा करें",
    "havingTrouble": "समस्या आ रही है?",
    "contactUs": "मदद के लिए support@sproutatwork.com का कॉन्टेक्ट करें",
    "done": "हो गया",
    "brand": "Sprout",
    "cannotTrackTitle": "एक्टिविटी को ट्रैक करने में असमर्थ",
    "cannotTrackPrior": "अरे वाह! एक्टिविटीज़ को सिर्फ़ शुरू होने की तारीख के बाद ही ट्रैक किया जा सकता है।",
    "cannotTrackFuture": "इतना तेज़ नहीं। एक्टिविटीज़ को सिर्फ़ मौजूदा दिन तक ही ट्रैक किया जा सकता है।",
    "cannotTrack": "एक्टिविटीज़ को शुरू होने की तारीख से पहले या भविष्य के किसी दिन तक ट्रैक नहीं किया जा सकता।",
    "disclaimer": "अस्वीकरण",
    "acceptTerms": "मुझे नियम और शर्तें स्वीकार हैं",
    "verificationEmailTitle": "अपना ईमेल वेरिफ़ाई करें",
    "email_not_yet_verified": "ऐसा लगता है कि आपने अभी तक अपना ईमेल एड्रेस वेरिफ़ाई नहीं किया हैं।",
    "email_successfully_verified_title": "स्वागत है",
    "email_successfully_verified": "आपने सफलतापूर्वक अपना ईमेल वेरिफ़ाई कर लिया है",
    "pleaseVerifyEmailMessage1": "आगे बढ़ने के लिए आपको अपना ईमेल एड्रेस वेरिफ़ाई करना पड़ेगा।",
    "pleaseVerifyEmailMessage2": "कृपया यहाँ भेजे गए निर्देश फॉलो करें:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "ईमेल दोबारा भेजें",
    "restart": "लॉगिन पर वापस जाएं",
    "firstName": "पहला नाम",
    "firstNamePlaceholder": "आपका पहला नाम",
    "lastName": "आखिरी नाम",
    "lastNamePlaceholder": "आपका आखिरी नाम",
    "email": "ईमेल",
    "emailPlaceholder": "आपका ईमेल एड्रेस",
    "employeId": "कर्मचारी ID",
    "employeIdPlaceholder": "कंपनी का कर्मचारी ID",
    "passwordPlaceholder": "नया पासवर्ड",
    "datePickerTitle": "अपनी जन्म तारीख चुनें",
    "datePickerConfirm": "कन्फ़र्म करें",
    "datePickerCancel": "कैंसिल करें",
    "termsOfUsePrivacyPreLinks": "मैं सहमत हूं",
    "sendMePromoCommunications": "मुझे प्रमोशनल कम्यूनिकेशन भेजें",
    "sendMePromoCommunicationsFromPartners": "मुझे पार्टनर्स की तरफ से प्रमोशनल कम्यूनिकेशन भेजें",
    "termsOfService": "सेवा की शर्तें",
    "legal": "कानूनी",
    "privacyPolicy": "गोपनीयता नीति",
    "and": "और",
    "programDomainLabel": "प्रोग्राम का नाम",
    "programDomainPlaceholder": "प्रोग्राम का नाम",
    "findProgramName": "मेरे प्रोग्राम का नाम ढूंढें",
    "findProgramNameButton": "प्रोग्राम का नाम ढूंढें",
    "findProgramNameTitle": "मेरे प्रोग्राम का नाम ढूंढें",
    "findProgramNameDescription": "कंपनी का ईमेल एड्रेस",
    "findProgramNamePlaceholder": "ईमेल एड्रेस",
    "findProgramSuccessMessage": "प्रोग्राम के नाम की खोज के परिणाम आपको ईमेल कर दिए गए हैं।",
    "findProgramSuccessTitle": "प्रोग्राम का नाम",
    "findProgramErrorTitle": "प्रोग्राम का नाम",
    "findProgramErrorMessage": "ओह, कोई समस्या हुई है... आपका प्रोग्राम नाम लाने की कोशिश करते समय हमें एक एरर मिला। कृपया दोबारा कोशिश करें।",
    "countryLabel": "देश चुनें",
    "countryName": "देश",
    "regionLabel": "क्षेत्र चुनें",
    "regionName": "क्षेत्र",
    "cityLabel": "शहर चुनें",
    "cityName": "शहर",
    "locationWorkLabel": "लोकेशन चुनें",
    "locationWorkName": "लोकेशन",
    "locationLabel": "लोकेशन चुनें",
    "locationName": "लोकेशन",
    "departmentLabel": "डिपार्टमेंट \/ डिवीजन चुनें",
    "departmentName": "डिपार्टमेंट \/ डिवीजन",
    "no_department": "कोई डिपार्टमेंट \/ डिविजन नहीं",
    "enterPIN": "कृपया अपनी कंपनी का PIN दाखिल करें",
    "verifyEmailTitle": "ईमेल वेरिफ़िकेशन",
    "verifyEmailMsg": "ऐसा लगता है कि आपने अभी तक अपना ईमेल एड्रेस वेरिफ़ाई नहीं किया हैं",
    "resendEmailTitle": "ईमेल वेरिफ़िकेशन",
    "resendEmailMsg": "%{userEmail} को दोबारा भेजा गया",
    "select_date": "तारीख चुनें",
    "changePasswordTitle": "पासवर्ड बदलें",
    "currentPassword": "मौजूदा पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "confirmNewPassword": "नया पासवर्ड कन्फ़र्म करें",
    "passwordChangeError": {
        "currentPasswordMissing": "अपना मौजूदा पासवर्ड दाखिल करें",
        "newPasswordMissing": "अपना नया पासवर्ड दाखिल करें",
        "confirmPasswordMissing": "अपना नया पासवर्ड कन्फ़र्म करें",
        "passwordsMatch": "पासवर्ड मेल नहीं खाते हैं",
        "passwordIncorrect": "गलत पासवर्ड। कृपया दोबारा कोशिश करें।"
    },
    "settings": "सेटिंग्स",
    "signOut": "साइन आउट करें",
    "updateApp": "ऐप अपडेट करें",
    "updateAppRight": "मौजूदा: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "मदद पाएं",
    "feedback": "फीडबैक",
    "feedback_success_title": "फीडबैक सबमिट किया गया",
    "feedback_success_msg": "अपना फीडबैक सबमिट करने के लिए शुक्रिया, हम तहे दिल से इसकी सराहना करते हैं!",
    "feedback_failure_title": "एरर",
    "feedback_failure_msg": "माफ़ करें... आपका फ़ीडबैक सबमिट करने में एरर आया, कृपया दोबारा कोशिश करें।",
    "submit": "सबमिट करें",
    "feedback_char_limit": "आपने अक्षरों की सीमा पार कर ली है।",
    "feedback_char_limit_toast_title": "मैसेज बहुत लंबा है",
    "feedback_char_limit_toast_msg": "आपका मैसेज मैक्सिमम 2000 अक्षर सीमा से ज़्यादा है।",
    "feedback_char_length_msg_1": "आपने टाइप किया है",
    "feedback_char_length_msg_2": "\/2000 अक्षर।",
    "feedback_empty_toast_title": "मैसेज खाली है",
    "feedback_empty_toast_msg": "ऐसा लगता है कि आपने अभी तक कुछ भी टाइप नहीं किया है। सबमिट करने से पहले कोई मैसेज टाइप करें।",
    "feedback_email_message": "मैसेज:",
    "feedback_email_user_id": ", यूज़र ID:",
    "feedback_email_device": ", डिवाइस:",
    "feedback_email_os_version": ", OS वर्ज़न:",
    "feedback_email_app_version": ", ऐप वर्ज़न:",
    "savingUserToast": {
        "success": {
            "title": "बदलावों को सेव करें",
            "message": "प्रोफ़ाइल के बदलाव सेव किए गए"
        },
        "danger": {
            "title": "एरर मिला",
            "message": "ओह... आपके बदलावों को सेव करने की कोशिश करते समय हमे एरर मिला, कृपया दोबारा कोशिश करें।"
        }
    },
    "edit_profile_user_error_msg": "कृपया अपने बदलावों को सेव करने से पहले एरर्स को रिव्यू करें",
    "edit_profile_location_error": "आपको अपनी लोकेशन निर्दिष्ट करनी होगी",
    "edit_profile_department_error": "आपको अपना डिपार्टमेंट \/ डिविजन निर्दिष्ट करना होगा",
    "edit_profile_unspecified_value": "आपको एक वैल्यू निर्दिष्ट करनी होगी",
    "edit_profile_value_too_low": "वैल्यू इससे से ज़्यादा होनी चाहिए",
    "edit_profile_value_too_high": "वैल्यू इससे से कम होनी चाहिए",
    "choose_gender": "लिंग चुनें",
    "activity_tracked_successfuly": "आपकी एक्टिविटी ट्रैक की जा रही है",
    "multi_activity_tracked_successfully": "आपकी एक्टिविटीज़ ट्रैक की जा रही है",
    "no_activities_tracked": "कोई एक्टिविटी ट्रैक नहीं की गई",
    "track_activity_to_submit": "किसी एक्टिविटी को ट्रैक करने के लिए कैलेंडर पर कोई तारीख चुनें",
    "last_day": "आखिरी",
    "days_remaining": "बाकी दिन",
    "day_remaining": "बाकी दिन",
    "days_remaining_this_week": "इस हफ़्ते बाकी दिन",
    "day_remaining_this_week": "इस हफ़्ते बाकी दिन",
    "days_remaining_this_month": "इस महीने बाकी दिन",
    "day_remaining_this_month": "इस महीने बाकी दिन",
    "earned_today": "आज कमाया गया",
    "earned_this_week": "इस हफ़्ते कमाया गया",
    "earned_this_month": "इस महीने कमाया गया",
    "earned_in_total": "कुल मिलाकर कमाया गया",
    "goal_completed": "गोल पूरा हुआ,",
    "see_results": "परिणाम देखें",
    "pts": "%{customPoints}",
    "of": "का",
    "daily_goal": "रोज़ के गोल",
    "weekly_goal": "हफ्ते के गोल",
    "monthly_goal": "महीने के गोल",
    "total_goal": "कुल गोल",
    "weeks": "हफ़्ते",
    "today": "आज",
    "this_week": "इस हफ़्ते",
    "this_month": "इस महीने",
    "overall": "ओवरऑल",
    "level": "लेवल",
    "days_remaining_in_period": "%{remainingDays} दिन बाकी है",
    "days_left_in_period": "ट्रैक करने के लिए %{remainingDays} दिन बचे हैं",
    "pointsToLevel": "%{levelName} की ओर प्रोग्रेस करें",
    "levelCompleted": "%{levelName} पूरा हुआ",
    "keepTrackingUntil": "तक ट्रैकिंग करते रहें",
    "activityLevelTitle": "मेरा एक्टिविटी लेवल",
    "activityLevelDescription": "आप हफ़्ते में कम से कम एक्टिव रहने में कितना समय बिताते हैं - यह तब होता है जब आप इतनी मेहनत करते हैं कि आपकी हार्ट रेट बढ़ जाए और पसीना आ जाए?",
    "activityLevelUnder60": "60 मिनट से कम",
    "activityLevelUnder150": "60 से 150 मिनट",
    "activityLevelOver150": "150 मिनट से ज़्यादा",
    "gender_male": "पुरुष",
    "gender_female": "महिला",
    "gender_rather_not_say": "जवाब देना पसंद नहीं",
    "date_of_birth": "जन्म दिन",
    "height": "ऊंचाई",
    "Height": "ऊंचाई",
    "weight": "वजन",
    "waistCircumference": "कमर का माप",
    "bloodPressureHg": "ब्लड प्रेशर सिस्टोलिक",
    "bloodPressureMm": "ब्लड प्रेशर डायस्टोलिक",
    "bloodCholesterol": "कुल ब्लड कोलेस्ट्रॉल",
    "ldl": "लो डेंसिटी लिपोप्रोटीन (LDL)",
    "hdl": "हाई डेंसिटी लिपोप्रोटीन (HDL)",
    "restingHeartRate": "आराम के समय की हार्ट रेट",
    "percentageBodyFat": "प्रतिशत शरीर की चर्बी",
    "hipCircumference": "कूल्हे का माप",
    "bloodGlucose": "ब्लड ग्लूकोज",
    "triglycerides": "ट्राइग्लिसराइड्स",
    "error_401_signed_out_message": "आपका सेशन एक्सपायर हो गया है। कृपया दोबारा लॉगिन करें।",
    "first_name": "पहला नाम",
    "last_name": "आखिरी नाम",
    "preferred_name": "पसंदीदा नाम",
    "notifications": "नोटिफ़िकेशन्स",
    "notificationsMarkAllReadButton": "सभी नोटिफिकेशन्स को पढ़ा हुआ के रूप में मार्क करें",
    "notificationsSettingsButton": "सेटिंग्स",
    "notificationsSettingsTitle": "नोटिफ़िकेशन्स और ईमेल",
    "notificationEmptyMessage": "आपके सभी नोटिफ़िकेशन अपडेटेड हैं",
    "priorityModalTitle": "मेरे प्रायोरिटी वाले नोटिफ़िकेशन",
    "remindMeLater": "बाद में याद दिलाएं",
    "priorityAdminTitle": "आपके एडमिनिस्ट्रेटर की तरफ से नोटिफ़िकेशन",
    "markAsRead": "पढ़ा गया के रूप में मार्क करें",
    "expand": "एक्सपैंड करने के लिए टैप करें",
    "collapse": "कोलैप्स करने के लिए टैप करें",
    "takePhoto": "नई फ़ोटो लें",
    "choosePhoto": "फ़ोटो चुनें",
    "deletePhoto": "फ़ोटो को डिलीट करें",
    "profileImageChangeErrorTitle": "एरर आया",
    "profileImageChangeErrorMessage": "उफ़...आपकी फ़ोटो को एडिट करते समय कुछ गलत हुआ। कृपया दोबारा कोशिश करें।",
    "editProfile": "प्रोफ़ाइल को एडिट करें",
    "postButton": "पोस्ट करें",
    "shareYourDayName": "आप क्या कर रहे हैं?",
    "greeting": "नमस्ते, %{firstNameDisplay}!",
    "shareAnUpdate": "आप क्या कर रहे हैं?",
    "shareYourDaySubtitle": "आप क्या कर रहे हैं?",
    "shareAPost": "पोस्ट शेयर करें",
    "postVisibleTo": "को विज़िबल है",
    "link": "लिंक",
    "photo": "फ़ोटो",
    "insertLink": "अपनी पोस्ट में लिंक जोड़ें",
    "save": "सेव करें",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "आपको सबमिट करने से पहले अपनी पोस्ट में कंटेंट जोड़ना होगा।",
    "generalErrorTitle": "पोस्ट खाली है",
    "generalSuccessTitle": "सफलता",
    "simplePlaceholder": "आप क्या कर रहे हैं?",
    "likesCountLabel": "थंब्स अप",
    "likesReceivedLabel": "थंब्स अप मिला",
    "commentsCountLabel": "कमेंट",
    "commentsCountLabelSingular": "कमेंट करें",
    "likeButton": "थंब्स अप",
    "commentButton": "कमेंट करें",
    "seePreviousComments": "पिछले कमेंट्स देखें",
    "addCommentPlaceholder": "कमेंट जोड़ें",
    "postCommentButton": "पोस्ट करें",
    "seeMoreLongComment": "ज़्यादा देखें",
    "activityPoints": "%{customPoints}",
    "activityLog": "एक्टिविटी लॉग",
    "discardPost": "खारिज करें",
    "discardPostMessage": "क्या आप वाकई अपनी पोस्ट को खारिज करना चाहते हैं?",
    "stream_filter_title": "स्ट्रीम",
    "stream_filter_screen_desc": "उन पोस्ट को चुनें जिन्हें आप स्ट्रीम में देखना चाहते हैं",
    "stream_filter_selection": "दिखाया जा रहा है:",
    "moderate": "अनुचित के रूप में मार्क करें",
    "moderateDescription": "इस आइटम को अनुचित के रूप में मार्क करने से इसे हटा दिया जाएगा और किसी एडमिनिस्ट्रेटर को सूचित किया जाएगा।",
    "editPost": "पोस्ट को एडिट करें",
    "deletePost": "पोस्ट को डिलीट करें",
    "deleteComment": "कमेंट को डिलीट करें",
    "editComment": "कमेंट को एडिट करें",
    "visibleOnlyToMe": "सिर्फ़ मुझे विज़िबल है",
    "joinEvent": "इवेंट के लिए RSVP",
    "joinEventDetail": "इवेंट को जॉइन करें",
    "joinedEvent": "मैं जा रहा हूं",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "आपने इवेंट को जॉइन कर लिया है",
            "message": "आपने सफलतापूर्वक इस इवेंट को जॉइन कर लिया है"
        }
    },
    "joinChallenge": "चैलेंज को जॉइन करें",
    "viewChallenge": "चैलेंज देखें",
    "joinedChallenge": "चैलेंज को जॉइन किया",
    "joinCommunity": "कम्युनिटी को जॉइन करें",
    "joinedCommunity": "कम्युनिटी को जॉइन किया",
    "joinProgress": "जॉइन हो रहे है",
    "joinSuccess": "जॉइन किया",
    "invitePeopleToCommunity": "लोगों को कम्युनिटी में इन्वाइट करें",
    "numberOfMembers": "%{num} मेंबर्स",
    "joinToView": "दूसरे मेंबर्स को देखने और पोस्ट करने के लिए इस कम्युनिटी को जॉइन करें",
    "numberOfAttendees": "%{num}1 भाग लेने वाला(वाले) व्यक्ति",
    "numberOfParticipants": "%{num} सहभागी",
    "numberOfMembersWithUser": "आप और %{num} और मेंबर्स",
    "numberOfAttendeesWithUser": "आप और %{num} और भाग लेने वाला(वाले) व्यक्ति",
    "numberOfParticipantsWithUser": "आप और %{num} और सहभागी",
    "communityMembers": "%{numberOfMembers} मेंबर(र्स)",
    "communityEvents": "%{numberOfEvents} आगामी इवेंट",
    "myEvents": "मेरे इवेंट्स",
    "seeAll": "सभी देखें",
    "noUpcomingEvents": "कोई आगामी इवेंट्स नहीं हैं। चलिए कोई एक इवेंट जॉइन करते है!",
    "myCommunities": "मेरी कम्युनिटीज़",
    "invitedCommunities": "इन्वाइट किया गया",
    "invitationSendingMessage": "इन्वाइट भेजे जा रहे है...",
    "invitationReceivedMessage": "आपको इसे जॉइन करने के लिए इन्वाइट किया",
    "invitationMessage": "हम आपको अपनी कम्युनिटी में शामिल करना पसंद करेंगे!",
    "recommendedCommunities": "आपके लिए रेकमेंड किया हुआ",
    "leaveCommunity": "इस कम्युनिटी को छोड़ें",
    "leaveTeam": "क्या आप वाकई टीम को छोड़ना चाहते है?",
    "leaveTeamLastMember": "इस चैलेंज में? टीम के आखिरी मेंबर के रूप में, चैलेंज को छोड़ने से टीम डिलीट हो जाएगी।",
    "leaveTeamChallenge": "इस चैलेंज में?",
    "Oops": "उफ़, कुछ गलत हुआ",
    "editCommunity": "कम्युनिटी को एडिट करें",
    "deleteCommunity": "इस कम्युनिटी को डिलीट करें",
    "leaveCommunityDescription": "क्या आप वाकई इस कम्युनिटी को छोड़ना चाहते है?",
    "inviteToCommunity": "कम्युनिटी में इन्वाइट करें",
    "inviteByMembers": "नाम के अनुसार इन्वाइट करें",
    "inviteByEmail": "ईमेल के अनुसार इन्वाइट करें",
    "select_person": "कृपया इन्वाइट करने के लिए कम से कम एक व्यक्ति को चुनें",
    "no_users_found": "हम्म... हमें इस नाम का कोई भी नहीं मिल रहा है।",
    "promptJoinCommunities": "ऐसा लगता है कि आपने किसी कम्युनिटी को जॉइन नहीं किया हैं। दूसरों के साथ जुड़ने और अपना सफ़र शेयर करने के लिए कम्युनिटीज़ को जॉइन करें।",
    "exploreCommunities": "कम्युनिटीज़ को एक्सप्लोर करें",
    "sendInviteByMembers": "%{num} लोगों को इन्वाइट करें",
    "sendInviteByEmail": "ईमेल इन्विटेशन भेजें",
    "createNewCommunity": "नई कम्युनिटी बनाएं",
    "createCommunity": "कम्युनिटी बनाएं",
    "uploadCover": "फ़ोटो जोड़ें",
    "cover": "कवर",
    "nameOfCommunity": "कम्युनिटी का नाम",
    "whatCommunityAbout": "यह कम्युनिटी किस बारे में है",
    "companyMembersOnly": "सिर्फ़ कंपनी के मेंबर्स",
    "viewAllButton": "सभी को देखें",
    "communities": "कम्युनिटीज़",
    "contentLibrary": "लाइब्रेरी",
    "events": "इवेंट्स",
    "past_events": "पिछले इवेंट्स",
    "invitationCommunity": "कम्युनिटी",
    "searchPeople": "लोगों को खोजें",
    "enterEmail": "ईमेल दाखिल करें",
    "personalMessageToNewInvitees": "नये इन्वाइट्स के लिए पर्सनल मैसेज",
    "dangerToastTitle": "एरर",
    "dangerToastMessage": "कुछ गलत हुआ। कृपया दोबारा कोशिश करें।",
    "successToastTitle": "सफलता",
    "successToastMessage": "एक्शन पूरा हुआ",
    "joiningToast": {
        "success": {
            "message": "आपने जॉइन किया"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "कमेन्ट को डिलीट कर दिया"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "कमेंट को अनुचित के रूप में मार्क किया गया"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "कमेंट को अपडेट किया गया"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "कमेंट को अपडेट किया गया"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "प्रोफ़ाइल फ़ोटो अपडेट की गई"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "प्रोफ़ाइल फोटो डिलीट कर दी गई"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "स्ट्रीम करने के लिए पोस्ट करें",
            "message": "आपकी पोस्ट को बना दिया गया है"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "पोस्ट को एडिट करें",
            "message": "आपकी पोस्ट एडिट कर दी गई है"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "पोस्ट को डिलीट करें",
            "message": "आपकी पोस्ट डिलीट कर दी गई है"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "अनुचित के रूप में मार्क करें",
            "message": "पोस्ट को अनुचित के रूप में मार्क किया गया"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "पढ़ा गया के रूप में मार्क करें",
            "message": "सभी नोटिफिकेशन्स पहले ही पढ़ा हुआ के रूप में मार्क कर दिये गए"
        },
        "info": {
            "title": "पढ़ा गया के रूप में मार्क करें",
            "message": "सभी नोटिफिकेशन्स पहले ही पढ़ा हुआ के रूप में मार्क कर दिये गए हैं।"
        },
        "danger": {
            "title": "पढ़ा गया के रूप में मार्क करें"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "नोटिफ़िकेशन को पढ़ा हुआ मार्क करने में असमर्थ"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "पासवर्ड अपडेट किया गया",
            "message": "अपने नए पासवर्ड से साइन इन करें"
        },
        "danger": {
            "title": "पासवर्ड अपडेट करें",
            "message": "उफ़...जब हमने आपका पासवर्ड अपडेट करने की कोशिश की उस समय कुछ गलत हुआ। कृपया दोबारा कोशिश करें।"
        }
    },
    "joining": {
        "success": {
            "message": "आपने %{name} जॉइन किया"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "इन्विटेशन",
            "message": "इन्विटेशन भेज दिय गया (दिये गए) है"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "कम्युनिटी बनाएं",
            "message": "आपकी नई कम्युनिटी बना दी गई है"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "आपका गोल दोबारा शुरू कर दिया गया है"
        },
        "danger": {
            "message": "गोल को दोबारा शुरू करने में असमर्थ"
        }
    },
    "quit": "बाहर निकलें",
    "wellbeing_survey_completed": "वेलबीइंग सर्वे पूरा हुआ",
    "wellbeing_survey_completed_message": "सर्वे पूरा करने के लिए शुक्रिया। हमें उम्मीद है कि इससे आपको अपनी  वेलबीइंग के बारे में कुछ जानकारी हासिल करने में मदद मिली होगी।",
    "update_wellbeing_score": "मेरे सर्वे के जवाबों को अपडेट करें",
    "get_wellbeing_score": "अपना वेलबीइंग स्कोर पाएं",
    "stats": "स्टैटिस्टिक्स",
    "my_wellbeing_score": "मेरा वेलबीइंग स्कोर",
    "see_details": "जानकारी देखें",
    "how_score_calculated": "मेरा स्कोर कैसे कैलकुलेट किया जाता है?",
    "contentTitle": "लाइब्रेरी",
    "promoted": "फ़ीचर्ड",
    "recommended": "रेकमेंड किया गया",
    "recommendedForMe": "मेरे लिए रेकमेंड किया हुआ",
    "recent": "हाल ही में जोड़ा गया",
    "view": "देखें",
    "added": "जोड़ा गया",
    "more": "और ज़्यादा",
    "openLibrary": "मुझे लाइब्रेरी पर ले जाएं",
    "readToEarn": "पढ़ें और कमाएं",
    "readArticle": "लिंक खोलें",
    "see_more": "और ज़्यादा (%{num}) देखें",
    "see_more_activities": "%{num} और ज़्यादा",
    "my_achievements": "मेरी कामयाबियाँ",
    "achievements": "कामयाबियाँ",
    "achievement_earned_date": "कमाया गया: %{date}",
    "achievement_start_date": "शुरू किया गया: %{date}",
    "achievement_end_date": "समाप्त हो रहा है: %{date}",
    "achievement_earned": "कमाया गया",
    "achievement_start": "शुरू होगा",
    "achievement_end": "समाप्त हो रहा है",
    "achievement_earned_times": "%{num} बार",
    "achievement_earned_time": "%{num} बार",
    "in_progress": "चालू है",
    "date_earned": "तारीख को कमाया गया",
    "earned": "कमाया गया",
    "past_dates_earned_heading": "पिछली तारीखों पर कमाई की गई",
    "all": "सभी",
    "eat": "खाना खाएं",
    "move": "चलें-फिरें",
    "feel": "महसूस करें",
    "profile_completion": "प्रोफ़ाइल की पूर्णता: %{percentage}",
    "complete_my_profile": "अपनी प्रोफ़ाइल पूरी करें",
    "do_following_tasks": "अपनी प्रोफ़ाइल पूरी करने के लिए नीचे दिये गए %{num} टास्क करें।",
    "improve_my_score": "अपने स्कोर में सुधार करें",
    "see_which_goals": "खाने, चलने-फिरने और बेहतर महसूस करने के लिए आपने जो गोल सेट किए हैं, उन पर गौर करें।",
    "havent_set_goal": "आपने अभी तक कोई गोल सेट नहीं किया है।",
    "set_a_goal": "गोल सेट करें",
    "set_another_goal": "एक और गोल सेट करें",
    "set_another_goal_here": "यहाँ एक और गोल सेट करें।",
    "my_recently_tracked_activities": "मेरी हाल की एक्टिविटीज़",
    "a_few_seconds_ago": "कुछ सेकंड पहले",
    "a_day_ago": "एक दिन पहले",
    "yesterday": "कल",
    "earn": "कमाएं",
    "delete_activity_confirmation": "क्या आप वाकई इस एक्टिविटी को हटाना चाहते है?",
    "delete_activity_title": "%{activity_name} में से %{measurement} हटाएं?",
    "reached_daily_goal": "आज आपने अपना गोल हासिल कर लिया। बहुत बढ़िया!",
    "multiple_activity_non_daily_instruction": "ट्रैकिंग शुरू करने और %{customPoints} कमाने के लिए किसी एक्टिविटी रो पर टैप करें!",
    "multiple_activity_daily_instruction": "अपने गोल तक पहुँचने के लिए जरूरी एक्टिविटी की मात्रा को ट्रैक करने के लिए प्लस साइन पर टैप करें। उस एक्टिविटी की किसी भी मात्रा को ट्रैक करने के लिए एक्टिविटी रो पर कहीं भी टैप करें।",
    "only_automatic_activities": "इस गोल में योगदान देने वाली एक्टिविटीज़ को सिर्फ़ ऑटोमैटिक रूप से ही ट्रैक किया जा सकता है",
    "only_automatic_activity": "इस गोल में योगदान देने वाली एक्टिविटी को सिर्फ़ ऑटोमैटिक रूप से ही ट्रैक किया जा सकता है",
    "earn_pts_and_reach_goal": "%{pts} पॉइंट कमाएं करें और %{qty} को ट्रैक करके अपना गोल हासिल करें",
    "earn_pts_for_every": "हर एक के लिए %{pts} पॉइंट कमाएं",
    "you_track": "आप ट्रैक करते है!",
    "you_have_tracked": "आपने %{qty} को ट्रैक किया है",
    "so_far": "अब तक!",
    "start_goal": "यह गोल सेट करें",
    "about_this_goal": "इस गोल के बारे में",
    "start_date": "शुरू होने की तारीख",
    "end_date": "समाप्त होने की तारीख",
    "activities": "एक्टिविटीज़",
    "goal": "गोल",
    "instructions": "निर्देश",
    "daily": "हर दिन",
    "weekly": "हर हफ़्ते",
    "monthly": "हर महीने",
    "total": "कुल",
    "week": "हफ़्ता",
    "day": "दिन",
    "days": "दिन",
    "month": "महीना",
    "months": "महीने",
    "progress": "प्रोग्रेस",
    "about": "बारे में",
    "days_remaining_to_track": "आपके पास किसी भी मिस की हुई एक्टिविटी को ट्रैक करने के लिए %{num} दिन है",
    "number_days": "%{num} दिन",
    "one_day": "1 दिन",
    "points_earned_this_week": "इस हफ़्ते कमाए हुए पॉइंट्स",
    "points_earned_year": "साल से अब तक के कमाए हुए पॉइंट्स",
    "completed": "पूरा हुआ",
    "what_you_need_to_do": "आपको क्या करने की जरूरत है",
    "see_all_num": "%{num} सभी देखें",
    "my_week_progress": "आपकी हफ़्ते की प्रोग्रेस",
    "my_day_progress": "आपकी रोज़ाना प्रोग्रेस",
    "my_month_progress": "आपकी महीने की प्रोग्रेस",
    "my_total_progress": "आपकी कुल प्रोग्रेस",
    "my_overall_progress": "ओवरऑल प्रोग्रेस",
    "you_earned": "आपने कमाई की है",
    "of_this_week": "इस हफ़्ते %{num} का",
    "of_this_day": "आज %{num} का",
    "of_this_month": "इस महीने %{num} का",
    "of_this_total": "कुल मिलाकर %{num} का",
    "of_this_overall": "%{num} ओवरऑल का",
    "remaining_this_week": "इस हफ़्ते बाकी",
    "remaining_this_month": "इस महीने बाकी",
    "remaining_this_total": "बाकी",
    "remaining_this_overall": "ओवरऑल बाकी",
    "view_history": "हिस्ट्री देखें",
    "this_goal_is": "यह गोल",
    "will_run_for": "के लिए चलेगा",
    "button_unset_goal": "गोल को अनसेट करें",
    "button_leave_challenge": "चैलेंज को छोड़ें",
    "leaveChallenge": {
        "menu": "%{challengeName} को छोड़ें"
    },
    "deleteChallenge": {
        "menu": "%{challengeName} डिलीट करें"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "आपने इस पर्सनल गोल को अनसेट कर दिया है।"
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "आपने चैलेंज को छोड़ दिया है"
        }
    },
    "activities_tracked": "ट्रैक की गई एक्टिविटीज़",
    "recently_tracked_activities": "हाल ही में ट्रैक की गई एक्टिविटीज़",
    "add": "जोड़ें",
    "change_before_track": "ऐसा लगता है कि आपने कोई बदलाव नहीं किया है। इस दिन के लिए एक्टिविटी की मात्रा को एडिट करें या बिना कोई बदलाव किए बाहर निकलें।",
    "havent_tracked_today": "ऐसा लगता है कि आपने अभी तक इस दिन के लिए कोई एक्टिविटी ट्रैक नहीं की है। किसी एक्टिविटी को खोजकर शुरू करें।",
    "cancel_tracking_quantity": "%{activity_name} की %{quantity} का ट्रैकिंग कैंसिल करें",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "बाहर निकलने से आपकी एक्टिविटी हिस्ट्री में किए गए एडिट खारिज हो जाएंगे। क्या आप वाकई यह करना चाहते हैं?",
    "discard_activity_edits_confirmation_date": "बाहर निकलने से %{date} के लिए आपकी एक्टिविटी हिस्ट्री में किए गए एडिट खारिज हो जाएंगे। क्या आप वाकई यह करना चाहते हैं?",
    "yes_discard_edits": "हां, बाहर निकलें और एडिट को खारिज करें",
    "createGoal": {
        "navigatorTitle": "पर्सनल गोल बनाएं",
        "navigatorSubtitle": "4 में से स्टेप %{step}"
    },
    "allCommunities": "सब कुछ",
    "deleteCommunityDescription": "क्या आप वाकई इस कम्युनिटी को डिलीट करना चाहते है?",
    "remaining": "बाकी",
    "recommended_goal": "रेकमेंड किया गया गोल",
    "pinError": "PIN %{pin} मान्य नहीं है। कृपया दोबारा कोशिश करें।",
    "previousPersonalGoals": "मेरे पूरे किए गए पर्सनल गोल्स",
    "previousGoalsTitle": "मेरे पिछले गोल्स",
    "endedOn": "को समाप्त हुआ",
    "achievedOfGoal": "आपने गोल का %{num}% हासिल किया",
    "previousGoalsEmptyMessage": "आपके पास कोई पिछले गोल नहीं हैं",
    "emptyListDefaultMessage": "आपके पास यहां कोई आइटम नहीं हैं",
    "myCommunitiesEmpty": "ऐसा लगता है कि आपने किसी कम्युनिटी को जॉइन नहीं किया हैं। दूसरों के साथ जुड़ने और अपनी सफ़र शेयर करने के लिए कम्युनिटीज़ को जॉइन करें।",
    "discoverMoreCommunities": "और ज़्यादा कम्युनिटीज़ को खोजें",
    "howLong": "अवधि",
    "frequency": "फ्रीक्वेंसी",
    "discard": "खारिज करें",
    "description": "डिस्क्रिप्शन",
    "optional": "वैकल्पिक",
    "instruction": "निर्देश",
    "name": "नाम",
    "create": "बनाएं",
    "categories": "कैटेगरीज़",
    "uploadPhoto": "फ़ोटो जोड़ें",
    "delete_goal": "%{name} को डिलीट करें",
    "delete_goal_confirmation": "क्या आप वाकई इस गोल को डिलीट करना चाहते है?",
    "leave_goal_confirmation": "क्या आप वाकई इस चैलेंज को छोड़ना चाहते हैं?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "आपका गोल बना दिया गया है।"
        }
    },
    "defaultSelectMessage": "कृपया एक विकल्प चुनें",
    "search": "खोजें",
    "inTotal": "कुल मिलाकर",
    "State": "राज्य",
    "Business unit": "बिजनेस यूनिट",
    "Work location": "वर्क लोकेशन",
    "whenStart": "आप कब शुरू करना चाहते है?",
    "every": "हर",
    "acceptChallenge": "चैलेंज को स्वीकार करें",
    "activity_history_challenge": "चैलेंज के लिए एक्टिविटी हिस्ट्री",
    "havent_tracked_challenge": "आपने अभी तक इस चैलेंज के लिए कोई एक्टिविटीज़ ट्रैक नहीं की हैं",
    "earned_lowercase": "कमाया गया",
    "noone_tracked_yet": "अभी तक किसी ने कुछ भी ट्रैक नहीं किया है। इस कॉम्पिटिशन में लीड करने के लिए ट्रैकिंग शुरू करें!",
    "you": "आप",
    "your_team": "मेरी टीम",
    "congrats_first_place": "बधाई हो आप पहले स्थान पर हैं! ऐसे ही मेहनत करते रहें।",
    "leader": "लीडर",
    "average": "एवरेज",
    "show_leader": "लीडर दिखाएं",
    "show_me": "मुझे दिखाएं",
    "show_my_team": "मेरी टीम दिखाएं",
    "leaderboard": "लीडरबोर्ड",
    "my_team": "मेरी टीम",
    "remaining_to_track": "ट्रैक करना बाकी है",
    "avg": "एवरेज",
    "invite": "इन्वाइट करें",
    "team_members": "टीम मेंबर्स",
    "daysLeft": "बाकी बचे दिन",
    "regionNameLiveBetter": "राज्य",
    "locationNameLiveBetter": "वर्क लोकेशन",
    "departmentNameLiveBetter": "बिजनेस यूनिट",
    "regionLabelLiveBetter": "राज्य चुनें",
    "locationLabelLiveBetter": "वर्क लोकेशन चुनें",
    "departmentLabelLiveBetter": "बिजनेस यूनिट चुनें",
    "companyLocation": "वर्क लोकेशन",
    "no_location": "कोई लोकेशन नहीं",
    "connect": "कनेक्ट करें",
    "syncing": "सिंक किया जा रहा है",
    "sync": "सिंक करें",
    "havent_tracked_in_a_while": "हाल ही में कोई ट्रैक की गई एक्टिविटी नहीं",
    "contact": "कॉन्टेक्ट करें",
    "manage": "मैनेज करें",
    "creator": "क्रिएटर",
    "allow_notifications": "नोटिफ़िकेशन्स मैनेज करें",
    "enable_notifications": "नोटिफ़िकेशन्स चालू करें",
    "appload": "{app_name} अपडेट होने तक बस थोड़ा समय रुकें...",
    "sendResetEmail": "ईमेल रीसेट करें भेजें",
    "min": "मिनिमम",
    "max": "मैक्सिमम",
    "error_joining_team": "टीम को जॉइन करने में असमर्थ",
    "cannot_add_to_team": "उफ… जब हमने आपको इस टीम में जोड़ने की कोशिश की तो कुछ गड़बड़ हो गई। हो सकता है कि टीम ने अपने मेंबर्स की मैक्सिमम संख्या को पार कर लिया हो या अब मौजूद न हो। अगर कोई दूसरा एरर आया है, तो कृपया दोबारा कोशिश करें।",
    "members_needed": "%{num} मेंबर्स की जरूरत है",
    "member_needed": "%{num} मेंबर की जरूरत है",
    "spots_left": "%{num} स्पॉट बाकी है",
    "join": "जॉइन करें",
    "no_teams_create": "अभी आपके पास जॉइन करने के लिए कोई टीम नहीं है। आप एक टीम क्यों नहीं बनाते?",
    "number_teams": "%{num} टीम",
    "youLowercase": "आप",
    "joined_challenge_on_team": "आपने टीम %{team_name} पर एक चैलेंज को जॉइन कर लिया हैं।",
    "join_team": "टीम को जॉइन करें",
    "former_members": "पहले रह चुके मेंबर",
    "letsGo": "चलिए शुरू करते है",
    "invite_to_team": "टीम में इन्वाइट करें",
    "connectingDeviceToast": {
        "success": {
            "title": "ऐप या डिवाइस कनेक्ट करें",
            "message": "सफलता! आपका ऐप या डिवाइस कनेक्ट हो गया है।"
        },
        "danger": {
            "title": "ऐप या डिवाइस कनेक्ट करें",
            "message": "उफ़... हमें इस सर्विस को कनेक्ट करने में समस्या हुई। कृपया दोबारा कोशिश करें।"
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "ऐप या डिवाइस डिस्कनेक्ट करें",
            "message": "आपने सफलतापूर्वक %{name} को डिस्कनेक्ट कर दिया है।"
        },
        "danger": {
            "title": "ऐप या डिवाइस डिस्कनेक्ट करें",
            "message": "उफ़... हमें %{name} को डिस्कनेक्ट करने में समस्या हुई। कृपया दोबारा कोशिश करें।"
        }
    },
    "leave_entity_question": "%{name} को छोड़ें?",
    "delete_entity_question": "%{name} को डिलीट करें?",
    "leave_team_challenge_confirmation": "क्या आप वाकई %{name} को इस चैलेंज में छोड़ना चाहते हैं?",
    "leave_last_team_member": "टीम के आखिरी मेंबर के रूप में, इस चैलेंज को छोड़ने से टीम डिलीट हो जाएगी।",
    "oops_msg": "उफ़... इस एक्शन को पूरा करने में कोई एरर आया। कृपया दोबारा कोशिश करें।",
    "has_been_created": "आपने टीम %{name} पर चैलेंज को जॉइन कर लिया हैं।",
    "specify_team_name": "कृपया टीम का नाम निर्दिष्ट करें",
    "invite_members": "मेंबर्स को इन्वाइट करें",
    "upload_photo_no_question": "फ़ोटो जोड़ें",
    "my_progress": "मेरी प्रोग्रेस",
    "rewardsPointsAdditionalInfo": "हर %{period} पर पहुँचने वाले हर लेवल के लिए %{reward_currency} कमाएँ। आपके %{customPoints} और लेवल हर %{period} पर नए सिरे से शुरू होते हैं, इसलिए आपके पास %{reward_currency} कमाना जारी रखने का मौका है, भले ही आप पिछली अवधि में सबसे ऊंचे लेवल पर पहुँच गए हों।",
    "rewardsPointsInfo": "आपके %{customPoints} और प्रोग्रेस हर %{period} पर रीसेट हो जाते हैं।",
    "departments": "डिपार्टमेंट \/ डिविजन",
    "regions": "क्षेत्र",
    "noItemsSelected": "कोई आइटम्स चुने नहीं गए",
    "pleaseSelectOne": "कृपया लिस्ट से कम से कम एक आइटम चुनें",
    "tracked": "ट्रैक किया गया",
    "starts": "शुरू होता है",
    "duration": "अवधि",
    "bonus": "बोनस",
    "invited_by": "द्वारा इन्वाइट किया गया",
    "create_team": "टीम बनाएं",
    "discardConfirmation": "क्या आप वाकई बाहर निकलना चाहते हैं?",
    "discardYes": "हाँ",
    "discardStay": "वापस जाएं",
    "create_team_toast_title": "टीम बनाएं",
    "edit_team": "टीम को एडिट करें",
    "team_edits_submitted": "आपकी टीम को अपडेट कर दिया गया है।",
    "challenge_ended_still_trackable": "यह %{type} समाप्त हो गया है, सौभाग्य से आपके पास ट्रैक करने के लिए %{num} दिन बाकी हैं!",
    "tracking_period_ended": "इस %{type} के लिए ट्रैकिंग अवधि समाप्त हो गई है।",
    "unlimited": "असीमित",
    "ends_in": "में समाप्त हो रहा है",
    "challenge_toast": {
        "success": {
            "join": "सफलता!",
            "message": "आपने सफलतापूर्वक चैलेंज को जॉइन कर लिया है"
        },
        "danger": {
            "error": "एरर",
            "message": "कुछ गलत हुआ। थोड़ी देर बाद दोबारा चैलेंज को जॉइन करने की कोशिश करें।"
        }
    },
    "members_to_invite": "इन्वाइट किए जाने वाले मेंबर",
    "members_to_remove": "हटाने जाने वाले मेंबर",
    "myChallenges": "कॉम्पिटिशन",
    "upcoming": "आगामी",
    "myPersonalGoals": "गोल्स",
    "companyCompetitions": "कंपनी के कॉम्पिटिशन",
    "communityCompetitions": "कम्युनिटी के कॉम्पिटिशन",
    "edit_your_team": "अपनी टीम को एडिट करें",
    "emails": "ईमेल",
    "CompletedOverall": "ओवरऑल पूरा हुआ",
    "TotalEarned": "कुल कमाया हुआ",
    "notify_header": "मै चाहता हूं कि मुझे नोटिफ़िकेशन मिले:",
    "AdditionalBonus": "और ज़्यादा बोनस",
    "goalEndedNotification": "गोल समाप्त हुआ, अपने आप को आगे बढ़ाते रहें!",
    "compEndedNotification": "कॉम्पिटिशन समाप्त हुआ, अपने आप को आगे बढ़ाते रहें!",
    "congrats_tracking_first": "अपनी पहली एक्टिविटी को ट्रैक करने के लिए बधाई हो!",
    "keep_tracking": "गोल हासिल करने और लेवल को बढ़ाने के लिए अपनी एक्टिविटी को ट्रैक करें।",
    "understanding_tracking": "ट्रैकिंग को समझना",
    "cannot_track_this_day": "आप इस दिन ट्रैक नहीं कर सकते हैं।",
    "nothing_tracked_this_day": "आपने अभी तक इस दिन को ट्रैक नहीं किया है।",
    "tracked_something_this_day": "आपने इस दिन के लिए कुछ ट्रैक किया है।",
    "reached_goal_this_day": "आपने इस दिन के लिए अपना गोल हासिल कर लिया है (सिर्फ़ रोज़ाना गोल्स के लिए)।",
    "got_it": "ठीक है!",
    "notDismissedMultiTitle": "चैलेंज समरी",
    "notDismissedMultiSubtitle": "कुछ चैलेंजेस पूरे हो गए हैं। यह जानने के लिए कि आपने कैसा परफ़ॉर्म किया, हर चैलेंज पर विस्तार से नज़र डालें।",
    "daySummary": "%{userName}, यहां आपके दिन की अब तक की समरी है",
    "goals": "गोल्स",
    "competitions": "कॉम्पिटिशन",
    "totalAccumulated": "कुल एकत्रित",
    "tracking_for_date": "%{date} के लिए ट्रैकिंग",
    "activity_tracker_instruction": "मैन्युअल रूप से ट्रैक की गई एक्टिविटी को एडिट करने या हटाने के लिए टैप करें",
    "ended": "समाप्त हुआ",
    "notYetAvailableBeta": "बीटा में अभी उपलब्ध नहीं है",
    "suggestedGoal": "सुझाया गया गोल",
    "singleFor": "के लिए",
    "seeLessLongComment": "कम देखें",
    "synced_data": "डेटा सिंक किया गया:",
    "doThisLater": "मैं इसे बाद में करूंगा",
    "inviteUsers": "दूसरों को जॉइन करने के लिए इन्वाइट करें",
    "cannotTrackAfterDeadline": "आप चैलेंज की समय-सीमा के बाद की तारीख के लिए किसी एक्टिविटी को ट्रैक करने की कोशिश कर रहे हैं।",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} बोनस %{customPoints} इस गोल के लिए उपलब्ध हैं!",
            "titleNotCompleted": "आपने %{potentialBonusPoints} बोनस %{customPoints} को %{activitytCompletedPercentage}% से मिस कर दिया।",
            "titleCompleted": "बधाई हो! आपने कमाई की है",
            "titleCompletedBold": "%{potentialBonusPoints} बोनस %{customPoints}!",
            "subtitle": "बोनस %{customPoints} के बारे में और ज़्यादा जानें"
        },
        "modal": {
            "title": "बोनस %{customPoints}",
            "desc1": "हम जानते हैं कि कोई भी परिपूर्ण नहीं है और हर समय अपने गोल्स को 100% पूरा नहीं कर सकता है।",
            "desc2": "इसीलिए हम बोनस %{customPoints} देते हैं जब आपकी ओवरऑल प्रोग्रेस 85% या उससे ज़्यादा होती है।",
            "desc3": "सभी बोनस %{customPoints} गोल के पूरे होने के बाद दिये जाते हैं और अगर आपकी सभी ट्रैकिंग किसी कनेक्टेड ऐप या डिवाइस से की गई थी, तो आपको डबल बोनस %{customPoints} मिलेगा!",
            "desc4": "आपको उन गोल्स के लिए बोनस %{customPoints} नहीं मिलेंगे जिन्हें आप जल्दी छोड़ देते हैं।"
        },
        "msg": {
            "title": "यह गोल पूरा हो गया है",
            "subtitle": "%{goalEndedDate} को गोल समाप्त हुआ"
        },
        "msgEnded": {
            "title": "समय पूरा हुआ! आपके गोल समाप्त हो गया है",
            "subtitle": "आपके पास अपनी एक्टिविटी को ट्रैक करने के लिए %{daysNum} %{daysOrDay} हैं।"
        }
    },
    "finish": "पूरा करें",
    "personalGoal": {
        "all_goals": {
            "selected": "सभी %{maxGoals} गोल सेट किए गए!",
            "description": "क्या यह आपकी पसंद के हिसाब से है? अगर आप अपना मन बदलते हैं तो आप किसी भी गोल को बदल सकते हैं। चिंता न करें, आप बाद में अपना गोल अनसेट कर सकेंगे।",
            "set": "सारे गोल सेट कर दिये गए है!",
            "action": "सब ठीक है, अब आगे बढ़ सकते हैं!",
            "error": "चलिए, ज़्यादा नहीं सोचते! एक समय में ज़्यादा से ज़्यादा 3 स्ट्रक्चर्ड गोल्स पर फ़ोकस करने से आपके सफ़ल होने की की संभावना बढ़ जाएगी।",
            "errorHeading": "गोल्स सेट कर रहे है"
        },
        "set_more": "आप %{maxGoals} और एक्टिव गोल सेट कर सकते हैं",
        "select_goal": {
            "heading": "रेकमेंड किया गया गोल या अपना खुद का गोल सेट करें"
        },
        "set_more_1": "आप 1 और एक्टिव गोल सेट कर सकते हैं"
    },
    "restartPersonalGoal": "नए टार्गेट के साथ गोल को दोबारा शुरू करें",
    "delete_challenge_confirmation": "क्या आप वाकई इस चैलेंज को डिलीट करना चाहते है?",
    "personal_goal_unit": "गोल",
    "personal_goal_units": "गोल्स",
    "day_summary": {
        "steps_taken": "चले गए स्टेप्स",
        "calories_in": "कैलोरी अंदर",
        "calories_out": "कैलोरी बाहर",
        "avg_daily": "रोज़ाना एवरेज",
        "most_earned_daily": "एक दिन में सबसे ज़्यादा कमाई"
    },
    "invitedBy": "%{person} द्वारा इन्वाइट किया गया",
    "resetPasswordMissingField": "कृपया ईमेल दाखिल करें",
    "resetPasswordInvalidValue": "कृपया एक मान्य ईमेल एड्रेस दाखिल करें",
    "resetPasswordNotFound": "आपका ईमेल नहीं मिल सकता",
    "resetPasswordNotCompleted": "आपकी रिक्वेस्ट पूरी नहीं की जा सकी",
    "resetGoalInstructions": {
        "start": "%{activity} की %{quantity} %{units} करें",
        "additional": ", %{activity} की %{quantity}%{units}",
        "end": "%{frequency} और कमाएं %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "एक गोल सेट किया है। देखें",
        "two": "दो गोल सेट किए है। देखें",
        "three": "तीन गोल सेट किए है। देखें",
        "none": "कोई गोल सेट नहीं है। गोल सेट करें"
    },
    "searchCommunitiesEmpty": "कोई कम्युनिटीज़ नहीं मिली",
    "searchCommunitiesPlaceholder": "कम्युनिटीज़ को खोजें",
    "updating": "अपडेट हो रहा है...",
    "pts_tracked": "%{activityName} - %{num} %{customPoints} को ट्रैक किया गया",
    "improving_wellbeing_score": "शानदार काम कर रहे हैं, आपका वेलबीइंग स्कोर बेहतर होता जा रहा है।",
    "progressHistory": "प्रोग्रेस की हिस्ट्री",
    "privateCommunity": "यह एक प्राइवेट कम्युनिटी है",
    "do_combo_of_activities": "नीचे दिये गए में से कोई भी कॉम्बिनेशन करें।",
    "noActivitiesTracked": "कोई एक्टिविटी ट्रैक नहीं की गई",
    "trackingWithFollowingApps": "नीचे दिये गए ऐप्स\/डिवाइस के साथ ट्रैकिंग",
    "recommendedApps": "इस %{challengeType} के लिए रेकमेंड किए गए ऐप्स\/डिवाइस",
    "collapseWord": "कोलैप्स करें",
    "started": "शुरू किया गया",
    "ends": "समाप्त हो रहा है",
    "do_activities": "एक्टिविटी करें",
    "rewards_placeholder": "स्टोर से एग्ज़ैम्पल रिवॉर्ड, प्लेसहोल्डर। यूजर्स कई प्रॉडक्ट्स देखेंगे जिन्हें वे खरीद सकते हैं और क़ीमत %{rewardName} में।",
    "personalGoals": {
        "top": {
            "label": "टॉप"
        },
        "allGoals": "सभी गोल",
        "seeMoreCard": {
            "heading": "क्या आपको वह नहीं दिख रहा जिसे आप ढूंढ रहे हैं?",
            "description": "रेकमेंड किए गए गोल पर एक नज़र डालें",
            "button": "गोल्स को एक्सप्लोर करें"
        }
    },
    "rewardsNotAvailable": "इस बीटा में रिवॉर्ड अभी उपलब्ध नहीं हैं। उपलब्ध होने पर, आप कैटलॉग देख सकेंगे और रिडेम्पशन पूरा कर सकेंगे।",
    "editProfileProvideRestingHeartRate": "कृपया कम से कम 40 का मान्य आराम की स्थिति वाली हार्ट रेट की वैल्यू दें",
    "liveBetterHealthInfo": "हम कई प्रोग्राम चलाते हैं और हमारे पास हेल्थ संबंधी कई तरह के कंटेंट हैं जो हेल्थ संबंधी बहुत सारी ज़रूरतों को पूरा करने और आपकी हेल्थ को बेहतर करने में मदद करने के लिए डिज़ाइन किए गए है। हमारे पास अभी तक हर तरह की हेल्थ कंडीशन और उसकी ज़रूरत के लिए प्रोग्राम नहीं हैं - लेकिन हम इस पर काम कर रहे हैं! - हालाँकि अगर आप नीचे दिये गए सवालों के जवाब देते हैं, तो हम आपसे संपर्क करेंगे अगर हमें कोई हेल्थ के प्रोग्राम या सर्विस मालूम पड़ती  है जिसमें भाग लेने से आपको फ़ायदा मिल सकता है और\/या आपको सबूत-आधारित जानकारी भेजेंगे जो आपकी हेल्थ की ज़रूरतों को बेहतर ढंग से समझने और मेनेज करने में आपकी मदद करेगी। कृपया ध्यान दें, हम इस जानकारी का इस्तेमाल आपकी पॉलिसी की योग्यता का आकलन करने के लिए नहीं करते हैं। अगर आप जानना चाहते हैं कि आप किस चीज़ के लिए कवर हैं या आपकी पॉलिसी के बारे में कोई सवाल है, तो आप हमारी कस्टमर कनेक्ट टीम को 132 331 पर कॉल कर सकते हैं।",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "आपने गोल को डिलीट कर दिया है"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "आपने चैलेंज को डिलीट कर दिया है"
        }
    },
    "invitations": "इन्विटेशन",
    "learnMorePeriods": "अवधि के बारे में ज़्यादा जानें",
    "tracked_by_app_name": "%{app_name} द्वारा ट्रैक किया गया",
    "device_required": {
        "text": "इस %{challengeType} के लिए ऐप या डिवाइस की जरूरत है",
        "button": "ऐप या डिवाइस कनेक्ट करें"
    },
    "editingCommunityToast": {
        "success": {
            "title": "कम्युनिटी को एडिट करें",
            "message": "कम्युनिटी को एडिट कर दिया गया है"
        }
    },
    "competition": "कॉम्पिटिशन",
    "close": "बंद करें",
    "only_automatic_activities_with_device": "इस %{goal_or_competition} की एक्टिविटीज़ को आपके कनेक्टेड ऐप्स\/डिवाइस के साथ ऑटोमैटिक रूप से ट्रैक किया जाता है।",
    "only_automatic_activity_with_device": "इस %{goal_or_competition} की एक्टिविटी आपके कनेक्टेड ऐप्स\/डिवाइस के साथ ऑटोमैटिक रूप से ट्रैक की जाती है।",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "कम्युनिटी को डिलीट कर दिया"
        }
    },
    "teamSizeMessage": "चैलेंज के लिए %{customPoints} कमाने के लिए आपकी टीम को कम से कम %{min} लोगों की जरूरत है।",
    "captain": "कप्तान",
    "inviteOthersToTeam": "दूसरों को मेरी टीम में इन्वाइट करें",
    "loadingMetrics": "अपने दिन को अपडेट करने के लिए सोर्स से कनेक्ट किया जा रहा है...",
    "aboutTeamSize": {
        "title": "टीम साइज़",
        "text": "%{min} से %{max}"
    },
    "pointsOverview": "%{customPoints} ओवरव्यू",
    "deepLinks": {
        "requestCouldNotBeCompleted": "आपकी रिक्वेस्ट पूरी नहीं की जा सकी",
        "error": "एरर"
    },
    "required_lc": "ज़रूरी",
    "personal": "पर्सनल जानकारी",
    "biometrics": "बायोमेट्रिक्स",
    "makeSelection": "चुनाव करें",
    "ask_question_success_msg": "शुक्रिया। हम जल्द से जल्द जवाब देंगे।",
    "report_issue_success_msg": "शुक्रिया। हम जल्द से जल्द जवाब देंगे।",
    "ask_question_success_title": "सवाल समस्या सबमिट किया गया",
    "report_issue_success_title": "तकनीकी समस्या सबमिट की गई",
    "ask_question_failure_msg": "माफ़ करें... आपका सवाल सबमिट करने में एरर आया, कृपया दोबारा कोशिश करें।",
    "report_issue_failure_msg": "माफ़ करें... आपकी समस्या की रिपोर्ट करते समय एक एरर आया, कृपया दोबारा कोशिश करें।",
    "notTrackedActivities": "आपने इस अवधि के लिए कोई एक्टिविटीज़ ट्रैक नहीं की हैं",
    "learn": "जानें",
    "Balance": "बैलेंस",
    "details": "जानकारी",
    "Reward": "रिवॉर्ड",
    "levelsReset": "लेवल %{remainingDays} दिनों में रीसेट हो जाएंगे",
    "redeem": "रिडीम करें",
    "redeemAt": "%{points} पर रिडीम करें",
    "needPointsToRedeem": "आपको %{points} और %{rewardName} की जरूरत है।",
    "learnEarnMore": "जानें की ज़्यादा कैसे कमाएं",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "टीम को जॉइन करें",
            "message": "आपने सफलतापूर्वक टीम को जॉइन कर लिया है!"
        },
        "danger": {
            "message": "हमें एक एरर मिला है और हम टीम को नहीं ढूंढ पाए। हो सकता है कि यह अब मौजूद न हो।"
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "एक्शन उपलब्ध नहीं है",
            "message": "आपकी रिक्वेस्ट पूरी नहीं की जा सकी।"
        }
    },
    "transactionLog": "ट्रांजैक्शन",
    "orderHistory": "ऑर्डर",
    "pointsAvailableToEarn": "कमाने के लिए %{points} उपलब्ध हैं",
    "missedYTD": "%{missed} मिस किया हुआ YTD",
    "rewardsDetails": "रिवॉर्ड्स",
    "successfullyRedeemedItem": "आपने सफलतापूर्वक इस आइटम को रिडीम कर लिया है।",
    "orderNumber": "ऑर्डर नंबर",
    "amountSpent": "खर्च की गई रकम",
    "status": "स्टेटस",
    "dateRedeemed": "रिडीम की गई तारीख",
    "additionalInformation": "और ज़्यादा जानकारी",
    "shipToAddress": "इस एड्रेस पर भेजें",
    "pointMissedYearToDate": "%{rewardCurrencyName} को इस साल मिस किया",
    "pointMissedYearToDateDescription": "जब आप अवधि पूरा होने से पहले कोई लेवल हासिल नहीं करते हैं, तो आपके द्वारा कमाई किए जा सकने वाले संबंधित %{rewardCurrencyName} को मिस किया हुआ माना जाता है।",
    "NoLibraryContentToast": {
        "info": {
            "title": "आर्टिकल नहीं मिला",
            "message": "आर्टिकल नहीं मिल सका। हो सकता है कि इसे हटा दिया गया हो या अब उपलब्ध न हो।"
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "कम्युनिटी नहीं मिली",
            "message": "कम्युनिटी नहीं मिल सकी। हो सकता है कि इसे हटा दिया गया हो या अब उपलब्ध न हो।"
        }
    },
    "shippingAddress": "शिपिंग \/ बिलिंग एड्रेस",
    "enterShippingAddress": "अपना शिपिंग \/ बिलिंग एड्रेस दाखिल करें",
    "streetLine": "स्ट्रीट लाइन %{num}",
    "stateProvince": "राज्य\/प्रदेश",
    "postcodePostalcodeZip": "पोस्टकोड\/पोस्टल कोड\/ZIP कोड",
    "phoneNumber": "फ़ोन नंबर",
    "order": "ऑर्डर",
    "redemptionConfirmation": "रिडेम्प्शन कन्फ़र्मेशन",
    "edit": "एडिट करें",
    "processing": "प्रोसेस हो रहा है...",
    "checkIsYouFirst": "हमें बस पहले यह चेक करना है कि क्या यह आप ही हैं",
    "discardSomeGoals": "आपने कुछ गोल्स सेट किए हैं। अगर आप आगे बढ़ेंगे तो ये गोल्स खारिज कर दिए जाएँगे।",
    "settingGoalsToast": {
        "success": {
            "message": "आपके नए गोल सेट कर दिये गए है!"
        }
    },
    "one_team": "1 टीम",
    "noAchievementsToEarnMessage": "ऐसा लगता है कि इस अवधि में %{rewardCurrencyName} कमाने के लिए कोई और बैज उपलब्ध नहीं है।",
    "shopRewards": "शॉप रिवॉर्ड्स",
    "validateShippingAddressToast": {
        "danger": {
            "title": "शिपिंग \/ बिलिंग एड्रेस",
            "message": "कृपया आगे बढ़ने से पहले सभी फ़ील्ड भरें।"
        }
    },
    "viewDetails": "जानकारी देखें",
    "potential": "संभावित",
    "missed": "मिस किया",
    "rewardsStoreNotAvailable": "इस समय आपके लिए रिवॉर्ड स्टोर उपलब्ध नहीं है।",
    "havent_tracked_in_a_while_date": "%{currentDate} के लिए कोई एक्टिविटी ट्रैक नहीं की गई",
    "challengeNotFoundToast": {
        "danger": {
            "title": "चैलेंज नहीं मिला",
            "message": "चैलेंज नहीं मिल सका। हो सकता है कि इसे हटा दिया गया हो या अब उपलब्ध न हो।"
        }
    },
    "shareYourDaySubtitleActivity": "इस एक्टिविटी के बारे में पिक्चर जोड़ें या कुछ कहें!",
    "goal_ended": "गोल पूरा हुआ",
    "challenge_ended": "चैलेंज पूरा हुआ",
    "day_remaining_to_track": "आपके पास किसी भी मिस की हुई एक्टिविटी को ट्रैक करने के लिए 1 दिन है",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} %{endDate} को पूरा हुआ",
    "goalEndedModal": {
        "title": "भूली हुई एक्टिविटी को पूरा करें",
        "message": "किसी पर्सनल गोल या चैलेंज के पूरा होने के बाद आपके पास आखिरी तारीख से तीन दिन का समय होता है ताकि आप उन एक्टिविटीज़ को ट्रैक कर सकें जिन्हें आप भूल गए हों। इस ग्रेस पीरियड के बाद, आप गोल या चैलेंज में योगदान देने वाली किसी भी दूसरी एक्टिविटी को ट्रैक नहीं कर सकते।"
    },
    "summary": "समरी",
    "placedRank": "आपको %{total}में से %{rank} पर रखा गया है",
    "rank": {
        "first": "पहला",
        "second": "दूसरा",
        "third": "तीसरा",
        "n": "%{rank}ला"
    },
    "event_name": "इवेंट का नाम",
    "this_is": "यह है...",
    "location_info": "लोकेशन और जानकारी",
    "what_event": "यह इवेंट किस बारे में है",
    "event_is": "यह इवेंट है",
    "start_on": "शुरू करें:",
    "end_on": "समाप्त करें:",
    "location": "लोकेशन",
    "chooseLeaderboard": "लीडरबोर्ड चुनें",
    "filterOneOfFollowing": "नीचे में से किसी एक को फ़िल्टर करें",
    "showChallengeInstead": "इसके बजाय चैलेंज दिखाएं",
    "showActivityInstead": "इसके बजाय एक्टिविटी दिखाएं",
    "showAll": "सभी दिखाएं",
    "activitiesShowSame": "एक्टिविटीज़: %{activityName}",
    "challengeShowSame": "चैलेंज: %{challengeName}",
    "chooseTimePeriod": "एक समय अवधि चुनें",
    "youCanFilterOneAtTime": "एक समय में एक ही फ़िल्टर चुना जा सकता है",
    "saveHealthTopicsToast": {
        "success": {
            "message": "हेल्थ के टॉपिक सेव किए गए",
            "title": "सफलता!"
        },
        "info": {
            "message": "सेव करने में असमर्थ"
        },
        "danger": {
            "title": "एरर!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "हेल्थ के ऑब्जेक्टिव्स सेव किए गए",
            "title": "सफलता!"
        },
        "info": {
            "message": "सेव करने में असमर्थ"
        },
        "danger": {
            "title": "एरर!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "दिलचस्पियाँ सेव की गई",
            "title": "सफलता!"
        },
        "info": {
            "message": "सेव करने में असमर्थ"
        },
        "danger": {
            "title": "एरर!"
        }
    },
    "edit_event": "इवेंट को एडिट करें",
    "leave": "छोड़ें",
    "delete_event": "इवेंट को डिलीट करें",
    "no_events": "कोई इवेंट्स नहीं",
    "no_events_placeholder": "आप फिलहाल किसी भी भविष्य के प्रोग्राम में भाग लेने की प्लानिंग नहीं कर रहे हैं। आप किसी प्रोग्राम को जॉइन क्यों नहीं करते?",
    "event": "इवेंट",
    "challenge": "चैलेंज",
    "invited_you": "आपको इन्वाइट किया",
    "public": "पब्लिक",
    "private": "प्राइवेट",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "इवेंट को सफलतापूर्वक डिलीट कर दिया गया है।"
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "आपने इवेंट को छोड़ दिया है"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "इवेंट को सफलतापूर्वक अपडेट किया गया।"
        }
    },
    "createEventToast": {
        "success": {
            "message": "इवेंट को सफलतापूर्वक बनाया गया।",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "आप जिस कंटेंट को देखने की कोशिश कर रहे हैं वह अभी उपलब्ध नहीं है। हो सकता है कि इसे ऑथर द्वारा डिलीट कर दिया गया हो या अनुचित के रूप में मार्क किया गया हो।",
    "start_time": "शुरू होने का समय",
    "end_time": "समाप्त होने का समय",
    "event_type": "%{eventType} इवेंट",
    "leave_event_modal": {
        "title": "अगर आप इस इवेंट को छोड़ेंगे तो",
        "message": "इसे डिलीट कर दिया जाएगा"
    },
    "leave_event ": "क्या आप वाकई इस इवेंट को छोड़ना चाहते है?",
    "create_event": "इंवेट बनाएं",
    "created_by": "द्वारा बनाया गया",
    "eventActionToast": {
        "danger": {
            "title": "एरर",
            "message": "कुछ गलत हुआ।"
        }
    },
    "continue": "जारी रखें",
    "wantExitTour": "क्या आप वाकई सफ़र पूरा करना चाहते है?",
    "exitTour": "सफ़र पूरा करें",
    "deleveEventPopup": "क्या आप वाकई इस इवेंट को डिलीट करना चाहते है?",
    "attendeesTitle": "भाग लेने वाले लोग",
    "userEvents": "%{name} के इवेंट",
    "createEventIndicator": "इवेंट बनाया जा रहा है",
    "inviteToEvent": "इवेंट में इन्वाइट करें",
    "noDescription": "कोई डिस्क्रिप्शन नहीं है।",
    "leaderboardIsEmpty": "यह लीडरबोर्ड खाली है या इसे देखने के लिए आपको चुनी गई समय अवधि के अंदर एक्टिविटी को ट्रैक करने की जरूरत हो सकती है",
    "notParticipantingInAnyChallenges": "आप कोई भी चैलेंज में भाग नहीं ले रहे हैं",
    "buttonLeaveEvent": "इवेंट को छोड़ें",
    "leaveEvent ": "%{name} को छोड़ें?",
    "canceledCreatingChallenge": "%{challengeType} का क्रिएशन सफलतापूर्वक कैंसिल कर दिया गया",
    "swipeReadNotification": "पढ़ा गया",
    "productTour": {
        "initialScreen": {
            "title": "%{programName} में आपका स्वागत है!",
            "body": "चलिये सफ़र शुरू करते है और कुछ ही समय में आपको बेसिक बातें पता चल जाएंगी।"
        },
        "dashboard": {
            "title": "डैशबोर्ड",
            "body": "देखें कि आपके पास कितने %{pointsName} हैं और लेवल की ओर आपकी प्रोग्रेस क्या है। फिर लीडरबोर्ड देखें कि आप कहां हैं।"
        },
        "rewards": {
            "title": "रिवॉर्ड्स",
            "body": "देखें कि आपके पास कितने %{rewardPointName} हैं और उन्हें स्टोर में रिडीम करें।"
        },
        "goals": {
            "title": "गोल्स और चैलेंजेस",
            "body": "आपके एक्टिव पर्सनल गोल्स, दूसरों के साथ चैलेंजेस और स्पेशल टास्क यहां देखे जा सकते हैं।"
        },
        "explore": {
            "title": "एक्सप्लोर करें",
            "body": "दूसरों के साथ चैलेंजेस खोजें, अपनी दिलचस्पियों पर चर्चा करने के लिए कम्युनिटी को जॉइन करें और वेलबीइंग लाइब्रेरी में नया आर्टिकल खोजें।"
        },
        "me": {
            "title": "में",
            "body": "यहां अपना वेलबीइंग स्कोर देखें, अपने स्टैटिस्टिक्स देखें और अपनी प्रोफ़ाइल और सेटिंग्स को एडिट करें।"
        },
        "finishScreen": {
            "title": "अब आप सेट है!",
            "body": "सफ़र को पूरा करने के लिए शुक्रिया।",
            "button": "चलिये शुरू करते है"
        },
        "skip": {
            "title": "क्या आप वाकई इस सफ़र को स्किप करना चाहते हैं?",
            "body": "इससे सफ़र पूरा हो जाएगा और आप तुरंत शुरू कर सकते हैं।"
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "प्रमाणीकरण विफलता",
            "message": "रिवॉर्ड रिडीम करने की प्रोसेस आगे नहीं बढ़ सकी। रिवॉर्ड प्रोवाइडर के साथ प्रमाणीकरण करते समय एक एरर आया।"
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "रिडेम्प्शन विफल रहा",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "आपके शुरू करने से पहले",
    "disclamerSectionMessage": "कोई भी नया एक्सरसाइज प्रोग्राम शुरू करने या जीवनशैली में बदलाव लाने से पहले अपने हेल्थ केयर प्रोफेशनल से सलाह जरूर लें ताकि वह बता सकें कि वे आपके लिए मुनासिब हैं।",
    "noEarchedAchievements": "आपने अभी तक कोई कामयाबियाँ हासिल नहीं की है। शुरू करने के लिए किसी एक्टिविटी को ट्रैक करें।",
    "noInProgressAchievements": "आपकी कोई कामयाबियाँ प्रोग्रेस पर नहीं हैं।",
    "discardCreatingEventMessage": "चेक करें कि सभी जरूरी फ़ील्ड दाखिल कर दिए गए हैं",
    "discardCreatingEventTitle": "इवेंट को बनाया नहीं जा सकता",
    "discardEditedEventTitle": "इवेंट को एडिट नहीं किया जा सकता",
    "errorEventNameMessage": "नाम जरूरी है",
    "errorEventStartDateMessage": "शुरू होने की तारीख जरूरी है",
    "errorEventEndDateMessage": "समाप्त होने की तारीख जरूरी है",
    "errorEventDateMessage": "पूरा होने की तारीख, शुरू होने की तारीख से पहले नहीं हो सकती",
    "noAccountsToLink": "%{program_name} से लिंक करने के लिए कोई अकाउंट उपलब्ध नहीं है।",
    "accountLinkEmailChanged": "आपका ईमेल एड्रेस अपडेट कर दिया गया है। आगे बढ़ते हुए, अपने लिंक किए गए अकाउंट से लॉग इन करें।",
    "accountLinkSuccessful": "आपका अकाउंट सफलतापूर्वक लिंक हो गया।",
    "edit_profile_nan_value": "वैल्यू एक संख्या होनी चाहिए",
    "advancedLogIn": "एडवांस्ड लॉग इन",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "रिडेम्प्शन विफल रहा",
            "message": "ऑर्डर सेशन एक्सपायर हो गया है। कृपया दोबारा ऑर्डर देने की कोशिश करें।"
        }
    },
    "left": "बाकी",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "ऐसा लगता है कि इस समय जॉइन करने के लिए कोई इवेंट उपलब्ध नहीं है। आप कोई इवेंट क्यों नहीं बनाते?"
        }
    },
    "reachedHighestLevel": "आपने सबसे ऊंचे लेवल को पार कर लिया है!",
    "error": "एरर",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "रिवॉर्ड रिडेम्प्शन",
            "message": "आपका ऑर्डर दे दिया गया है"
        }
    },
    "redeemRewardComplete": "आपका रिडेम्प्शन पूरा हुआ",
    "trackActivityTitle": {
        "oneUnit": "ट्रैक: %{date} पर %{activity} का %{unit}",
        "nUnit": "ट्रैक: %{date} के लिए %{activity}"
    },
    "ssoAuthenticationFailure": "प्रमाणीकरण विफलता",
    "earnEvery": "हर %{frequency} कमाएं",
    "earnOnce": "सिर्फ़ एक बार कमाएं",
    "goalSettings": {
        "maximumSet": "आपने अभी मैक्सिमम 3 गोल्स सेट किए हैं।",
        "learnMore": "गोल सेट करने के बारे में और ज़्यादा जानें"
    },
    "allowMarketingComms": "मुझे प्रमोशनल कम्यूनिकेशन भेजें",
    "allowPartnerMarketingComms": "मुझे पार्टनर्स की तरफ से प्रमोशनल कम्यूनिकेशन भेजें",
    "noUpcomingAchievements": "कोई आगामी कामयाबियाँ नहीं हैं।",
    "settingGoalToast": {
        "success": {
            "message": "आपका नया गोल सेट कर दिया गया है!"
        }
    },
    "authentication": {
        "saml": {
            "error": "सर्विस फिलहाल उपलब्ध नहीं है",
            "signin": "इंटीग्रेटेड साइन इन",
            "signup": "इंटीग्रेटेड साइन अप"
        }
    },
    "monthName": {
        "january": "जनवरी",
        "february": "फ़रवरी",
        "march": "मार्च",
        "april": "अप्रैल",
        "may": "मई",
        "june": "जून",
        "july": "जुलाई",
        "august": "अगस्त",
        "september": "सितंबर",
        "october": "अक्टूबर",
        "november": "नवंबर",
        "december": "दिसंबर"
    },
    "promotedForMe": "फ़ीचर्ड",
    "appRating": {
        "enjoying": "हमारी ऐप एंजॉय कर रहे है?",
        "feedback": "क्या आप कुछ फीडबैक देना चाहेंगे?",
        "appStore": "App Store पर हमें रेटिंग दें?",
        "googlePlay": "Google Play पर हमें रेटिंग दें?",
        "notReally": "ज़रूरी नहीं",
        "yes": "हाँ!",
        "sure": "वाकई",
        "noThanks": "नहीं, शुक्रिया",
        "notNow": "अभी नहीं"
    },
    "getMobileApp": "अपने स्मार्टफोन पर %{programName} का इस्तेमाल करने के लिए, App Store या Google Play से %{appStoreName} डाउनलोड करें।",
    "newAppsDevicesDesign": {
        "getMobileApp": "%{programName} ऐप डाउनलोड करें",
        "searchInAppStore": "अपने डिवाइस के App Store में %{programName} खोजें",
        "getMobileAppNoName": "मोबाइल ऐप पाएं"
    },
    "editorAlert": {
        "discardChanges": "बदलावों को खारिज करें",
        "saveAndContinue": "सेव करें और जारी रखें",
        "title": "सेव नहीं किए हुए बदलाव",
        "text": "आपने कुछ बदलाव किए हैं जो सेव नहीं किए गए हैं। आप क्या करना चाहेंगे?"
    },
    "resources": "रिसोर्स",
    "noResources": "कोई रिसोर्स नहीं मिले",
    "viewAllResources": "सभी रिसोर्स देखें",
    "language": "भाषा",
    "eventStarted": "इवेंट शुरू हुआ। रजिस्ट्रेशन बंद हुआ।",
    "Gender": "जन्म के समय असाइन किया हुआ लिंग",
    "show": "दिखाएं",
    "hide": "छुपाएं",
    "timeoutError": "उफ़! कुछ काम में बहुत समय लग रहा है। कृपया बाद में दोबारा कोशिश करें।",
    "SOT": {
        "sample_task": "सैंपल टास्क"
    },
    "cache": {
        "new_version": "नया वर्ज़न उपलब्ध है!",
        "refresh_browser": "अपने ब्राउज़र को रिफ्रेश करने के लिए यहां क्लिक करें।"
    },
    "welcomeUser": "स्वागत है, %{userFirstName}!",
    "quarter": "क्वार्टर",
    "completionReward": "पूरा करने पर रिवॉर्ड",
    "bronzeLevel": "ब्रॉन्ज़ लेवल",
    "deviceAppSyncingOk": "डिवाइस \/ ऐप सिंकिंग ओके",
    "deviceAppSyncingIssue": "डिवाइस \/ ऐप सिंकिंग समस्या",
    "deviceAppSyncingError": "डिवाइस \/ ऐप सिंकिंग एरर",
    "lastSync": "आखिरी बार सिंक किया",
    "period": "अवधि",
    "yourDaySummary": "आपका अब तक का दिन",
    "steps": "स्टेप्स",
    "gender_non_binary": "नॉन-बाइनरी और नॉन-कन्फॉर्मिंग",
    "take_survey": "सर्वे लें",
    "social": "सोशल",
    "finalDay": "आखिरी दिन",
    "leaderboard_position": "लीडरबोर्ड पोज़ीशन",
    "signUp": {
        "apple": {
            "disconnectSettings": "साइन अप जारी रखने के लिए फ़ोन सेटिंग्स में ‘Apple ID पासवर्ड और सुरक्षा’ से %{appName} को डिस्कनेक्ट करें"
        }
    },
    "earnPoints": "%{customPoints} कमाएं। लेवल को बढ़ाएं।",
    "getReward": "%{rewardName} पाएं।",
    "buildHealthyHabits": "हेल्थी आदतें बनाएं।",
    "highestLevelIndicator": "आपने सबसे ऊंचे लेवल को पार कर लिया है!",
    "highestLevelIndicatorNew": "आपने हर लेवल को पूरा कर लिया है!",
    "trackYourActivity": "%{customPoints} पाने के लिए, अपनी एक्सरसाइज़ और हेल्थ एक्टिविटी को ट्रैक करें।",
    "levelUpToGetRewarded": "जैसे-जैसे आपका लेवल ऊपर जाएगा, आपको %{rewardName} रिवॉर्ड से नवाज़ा जाएगा।",
    "levelUpAndEarn": "आपकी प्रोग्रेस हर %{period} पर रीसेट हो जाती है, इसलिए आप बार-बार लेवल बढ़ा सकते हैं और कमाई कर सकते हैं।",
    "levelUp": "आपकी प्रोग्रेस हर %{period} पर रीसेट हो जाती है, इसलिए आप बार-बार लेवल बढ़ा सकते हैं।",
    "goToLibrary": "लाइब्रेरी में जाएं",
    "updateEventIndicator": "इवनेट अपडेट हो रहा है",
    "meTour": {
        "healthSurveyDisabled": "यहां अपने स्टैटिस्टिक्स देखें और अपनी प्रोफ़ाइल और सेटिंग्स को एडिट करें।"
    },
    "createNewGoal": "नया गोल बनाएं",
    "later": "बाद में",
    "bonusChallenge": "बोनस चैलेंज",
    "bonusChallengeInfo": {
        "withReward": "इस %{challengeType} का कम से कम 85% पूरा करने पर आप %{amount} बोनस %{points} कमाएंगे।",
        "noReward": "इस चैलेंज का कम से कम 85% पूरा करने पर आप बोनस कमाएंगे।",
        "boldText": "%{amount} बोनस %{points}",
        "noRewardChallengeType": "इस %{challengeType} का कम से कम 85% पूरा करने पर आप बोनस कमाएंगे।"
    },
    "defaultApp": "आपका डिफ़ॉल्ट हेल्थ का ऐप",
    "bonusGoal": {
        "additionalInfo": "अगर आपकी सभी एक्टिविटीज़ को किसी कनेक्टेड ऐप या डिवाइस का इस्तेमाल करके ट्रैक किया गया था, तो आपको डबल बोनस %{points} मिलेंगे!",
        "additionalInfoNew": {
            "paragraph2": "बोनस %{points} गोल पूरा होने के बाद दिए जाते हैं। आपको उन गोल्स के लिए बोनस %{points} नहीं मिलेंगे जिन्हें आप पूरा होने से पहले जल्दी छोड़ देते हैं।"
        },
        "boldText": "डबल बोनस %{points}!",
        "markTitle": "बोनस गोल"
    },
    "notify_me": "मुझे सूचित करें",
    "bonusChallengeReward": "बोनस चैलेंज रिवॉर्ड",
    "forCompletingChallenge": "%{challengeName} पूरा करने के लिए",
    "notifications_text": "नोटिफ़िकेशन आपको अपने गोल्स पर टिके रहने और बातचीत जारी रखने में मदद करते हैं।",
    "type_here": "यहाँ टाइप करें",
    "bonusEarned": "बोनस कमाया गया",
    "youEarnedBonus": "आपने यह बोनस कमाया है!",
    "inviteOthersToChallenge": "दूसरों को चैलेंज जॉइन करने के लिए इन्वाइट करें",
    "inviteOthersToYourTeam": "दूसरों को आपकी टीम में इन्वाइट करें",
    "manageTeam": "टीम को मैनेज करें",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "कम्युनिटी",
    "chooseActivity": "एक्टिविटी चुनें",
    "Recent": "नया",
    "noActivities": "कोई मेल खाती हुई एक्टिविटीज़ नहीं",
    "photoChooseText": "पसंद करें",
    "photoCancelText": "कैंसिल करें",
    "signIn": {
        "missingEmail": "मिसिंग ईमेल एड्रेस",
        "missingPassword": "कृपया सुनिश्चित करें कि पासवर्ड दिया गया है",
        "invalidLogin": "गलत ईमेल या पासवर्ड",
        "accountLocked": "आपका अकाउंट लॉक कर दिया गया है। कृपया अपने एडमिनिस्ट्रेटर से कॉन्टेक्ट करें",
        "accountMayNotExist": "हमारे पास इस ईमेल एड्रेस के लिए कोई अकाउंट नहीं है। अकाउंट बनाने के लिए साइन अप करें।",
        "wrongPassword": "पासवर्ड ग़लत है। इसे रीसेट करने के लिए दोबारा कोशिश करें या पासवर्ड भूल गए पर क्लिक करें।"
    },
    "deleteGoalBonusPoints": "अगर आपने अभी तक जुड़ा हुआ बोनस नहीं कमाया है, तो आप अब ऐसा नहीं कर पाएंगे।",
    "havent_tracked_goal": "आपने अभी तक इस गोल के लिए कोई एक्टिविटीज़ ट्रैक नहीं की हैं",
    "trackActivity": {
        "search": "एक्टिविटीज़ खोजें...",
        "text": "एक्टिविटी को ट्रैक करें",
        "done": "हो गया",
        "discardChanges": "बदलावों को खारिज करें?",
        "discardMessage": "क्या आप वाकई बाहर निकालना चाहते है और अपनी प्रोग्रेस को खारिज करना चाहते हैं?",
        "discard": "खारिज करें",
        "limitMessage": "आप एक बार में ज़्यादा से ज़्यादा सात दिनों तक ही ट्रैक कर सकते हैं।",
        "inputDescription": "%{date} के लिए %{activity} की मात्रा",
        "gracePeriod": "आपके पास किसी भी मिस की हुई एक्टिविटी को ट्रैक करने के लिए %{n} %{text} है"
    },
    "dates": "तारीखें",
    "pickDates": "दूसरी तारीखें चुनें",
    "selectDates": "तारीखें चुनें",
    "limitReached": "आप सीमा पार कर ली है",
    "activity": "एक्टिविटी",
    "keepUpTheGoodWork": "अच्छा काम करते रहें!",
    "activityTracked": "एक्टिविटी ट्रैक की गई",
    "new": "नया",
    "newFeatureTitle": "आसान और तेज़ एक्टिविटी ट्रैकिंग",
    "newFeatureText": "चाहे आप आज की, पिछली या कई दिनों की एक्टिविटीज़ ट्रैक कर रहे हों, लेकिन हमें लगता है कि आपको नया एक्सपीरियंस बहुत पसंद आएगा।",
    "gotIt": "ठीक है!",
    "frequencyViewHistory": "%{frequency} ब्रेकडाउन को देखें",
    "challengeDetails": {
        "trackTheseActivities": "इनमें से किसी भी एक्टिविटीज़ को ट्रैक करें ताकि आप इस %{challengeType} की ओर प्रोग्रेस कर सकें।"
    },
    "member": "मेंबर",
    "weeklyBreakdown": "हर हफ़्ते का ब्रेकडाउन",
    "setGoals": {
        "earnPointsText": {
            "start": "कमाएं",
            "end": "आपका पहला गोल सेट करने के लिए!"
        }
    },
    "weeklyGoalEnded": "को हफ़्ता समाप्त हुआ",
    "weekFinished": "का हफ़्ता आपने पूरा किया",
    "restartGoal": {
        "daysLeftToTrack": "आपके पास अभी भी पिछले हफ़्ते से किसी भी भूले हुए प्रोग्रेस को ट्रैक करने के लिए %{quantity} %{days} हैं।",
        "weekEnded": "यह हफ़्ता समाप्त हो गया है।",
        "timesUp": "समय पूरा हुआ!",
        "period": {
            "title": "गोल की अवधि",
            "text": "सोमवार से रविवार, हर हफ़्ते"
        }
    },
    "membersPlural": "मेंबर्स",
    "startedADayAgo": "1 दिन पहले शुरू किया गया",
    "goalRestarted": "आपने इस गोल को दोबारा शुरू किया",
    "weeklyGoals": "हफ्ते के गोल",
    "weeklyGoalsDescription": "हफ्ते के गोल हर सोमवार को रिन्यू होते हैं, ताकि आप लंबे समय तक एक हेल्थी आदत बनाए रख सकें।",
    "challengeEnded": "यह %{challengeType} समाप्त हो गया है",
    "goalEndedModalTitle": "समय पूरा हुआ! आपका %{challengeType} समाप्त हो गया है!",
    "yourProgress": "आपकी प्रोग्रेस",
    "earn_withRewards": "अपनी हेल्थी एक्टिविटी को ट्रैक करके (%{pts}) कमाएं और लेवल पार करें। जब आप लेवल बढ़ाएँगे, तो आपको %{currency} मिलेंगे।",
    "earn_noRewards": "अपनी एक्सरसाइज़ और वेलबीइंग एक्टिविटी को ट्रैक करें ताकि (%{pts}) कमा सकें और लेवल को बढ़ा सकें।",
    "currentPeriod": "मौजूदा अवधि",
    "currentScore": "मौजूदा स्कोर",
    "viewActivityLog": "एक्टिविटी लॉग देखें",
    "balanceHistory": "मेरे बैलेंस की हिस्ट्री",
    "mymedibank": {
        "underAge": {
            "error": "Live Better ऐप सिर्फ़ 18 साल और उससे ज़्यादा उम्र के यूज़र्स के लिए उपलब्ध है, ज़्यादा जानकारी के लिए कृपया Live Better के नियम और शर्तें देखें।"
        }
    },
    "enhancedHomePageInfo": "हमने होम पेज को बेहतर बना दिया है! अब आपके चैलेंज और गोल्स को देखना आसान हो गया है। ट्रैकिंग शुरू करने का समय आ गया है!",
    "levelUpTitle": "लेवल अप करें",
    "levelUpDescription": "एक्टिविटीज़ को ट्रैक करके और गोल्स और चैलेंजेस को पूरा करके लेवल पास करें। जैसे-जैसे आप लेवल बढ़ाएँगे, तब तब आपको %{currency} रिवार्ड्स दिए जाएंगे!",
    "achievementsDescription": "इन स्पेशल बैजों को अनलॉक करके %{currency} कमाएं। यह देखने के लिए कि आपको क्या करना है, किसी बैज पर क्लिक करें।",
    "bonusChallengesDescription": "चैलेंजेस को जॉइन करें और उन्हें पूरा करें जिनमें %{currency} बोनस है।",
    "earnWithPartners": {
        "title": "पार्टनर के साथ कमाएं",
        "description": "हॉस्पिटल या एक्स्ट्रा कवर वाले Medibank मेंबर, पार्टनर्स के साथ की गई योग्य खरीदारी\/एक्टिविटी पर पॉइंट्स कमा सकते हैं।"
    },
    "browseAllPartners": "सभी पार्टनर्स को ब्राउज़ करें",
    "resetsIn": "%{daysNumber} दिनों में रीसेट होगा",
    "thisIsALot": "यह बहुत ज़्यादा है!",
    "areYouSure": "क्या आप वाकई यह करना चाहते है?",
    "trackingALotMessage": {
        "days": "आप %{daysNum} दिनों में 2,000 से ज़्यादा %{customPoints} ट्रैक कर रहे हैं। यह काफ़ी ज़्यादा है!",
        "day": "आप 1 दिन में 2,000 से ज़्यादा %{customPoints} ट्रैक कर रहे हैं। यह काफ़ी ज़्यादा है!"
    },
    "amSure": "हां, मैं वाकई यह करना चाहता हूं",
    "activeMinutesAndSleep": {
        "title": "एक्टिव मिनटों और नींद के लिए डिवाइस ट्रैकिंग",
        "description": "आपका डिवाइस मध्यम या ऊंची मॉडरेट वाली शारीरिक एक्टिविटी के दौरान एक्टिविटी मिनटों को रिकॉर्ड करता है—यह अच्छी क्वॉलिटी वाली एक्सरसाइज़ है! अपनी नींद को ट्रैक करने के लिए डिवाइस का इस्तेमाल कर रहे हैं? आपको उसके लिए भी %{points} मिलेंगे!"
    },
    "hourShort": "घंटा",
    "hoursShort": "घंटे",
    "secondsShort": "सेकंड",
    "watchToEarn": "देखें और कमाएं",
    "oneParticipant": "1 सहभागी",
    "oneTeam": "1 टीम",
    "numberOfTeams": "%{num} टीम",
    "inviteToYourTeam": "आपकी टीम में इन्वाइट करें",
    "inviteToThisChallenge": "इस चैलेंज के लिए इन्वाइट करें",
    "challengeInstructionText": "इस एक्टिविटी को ट्रैक करें ताकि आप अपने %{challengeType} की दिशा में प्रोग्रेस कर सकें।",
    "showLess": "कम दिखाएं",
    "startsTomorrow": "कल से शुरू होता है",
    "deadlineDayLeft": "बाकी बचा दिन",
    "deadlineDaysLeft": "बाकी बचे दिन",
    "deviceBonus": "डिवाइस बोनस",
    "appsAndDevices": {
        "header": "ऐप्स और डिवाइसिस",
        "linked": "ये लिंक किए गए ऐप्स और डिवाइस इस %{challengeType} की ओर ट्रैक कर रहे हैं:",
        "noLinked": "कोई लागू ऐप्स या डिवाइस लिंक नहीं किए गए",
        "link": "अपने फ़ोन, वॉच या ऐप को ऑटोमैटिक रूप से ट्रैक करने के लिए लिंक करें।"
    },
    "yourGoals": "आपके गोल्स",
    "yourChallenges": "आपके चैलेंजेस",
    "position": "पोज़ीशन",
    "team_success": "टीम की सफलता",
    "starts_in": "को शुरू होता है",
    "team_challenge": "टीम चैलेंज",
    "your_progress_today": "आपकी आज की प्रोग्रेस",
    "your_daily_avarage": "आपकी डेली एवरेज है",
    "this_week_progress": "इस हफ़्ते की प्रोग्रेस",
    "this_month_progress": "इस महीने की प्रोग्रेस",
    "overall_progress": "ओवरऑल प्रोग्रेस",
    "complete": "पूर्ण",
    "overallSuccess": "ओवरऑल सफलता",
    "teamSuccessAverage": "टीम सफलता की एवरेज",
    "progressDetails": "प्रोग्रेस की जानकारी",
    "dayStreak": "%{n}-दिन की स्ट्रीक!",
    "weekStreak": "%{n}-हफ़्ते की स्ट्रीक!",
    "dailyProgress": "डेली प्रोग्रेस",
    "participantsSuccessCount": {
        "overall": "%{total} में से %{amount} सहभागियों ने टार्गेट हासिल किया है",
        "day": "%{total} में से %{amount} सहभागियों ने आज टार्गेट हासिल किया है",
        "week": "%{total} में से %{amount} सहभागियों ने इस हफ़्ते टार्गेट हासिल किया है",
        "month": "%{total} में से %{amount} सहभागियों ने इस महीने टार्गेट हासिल किया है"
    },
    "doubleBonusShort": "डबल बोनस!",
    "doubleBonusLong": "आपने डबल बोनस कमाया है!",
    "recommendedGoalDescription": "गोल्स आपको अपनी प्रोग्रेस पर नज़र रखने और मोटीवेट रहने में मदद करते हैं!",
    "noParticipation": "कोई सहभागिता नहीं",
    "nothingToShow": "ऐसा लगता है कि अभी दिखाने के लिए कुछ नहीं है",
    "yourTeam": "आपकी टीम",
    "no_activity_title": "कोई एक्टिविटी नहीं",
    "brandSupport": {
        "description": "हमने Polar और Withings स्मार्टवॉच के साथ एक्टिविटी सिंकिंग के लिए सपोर्ट जोड़ा है। आगे बढ़ने का समय आ गया है!"
    },
    "no_tracked_activities": "आपने अभी तक कोई एक्टिविटीज़ ट्रैक नहीं की हैं।",
    "button_leave_community": "कम्युनिटी को छोड़ें",
    "button_delete_challenge": "%{challengeType} डिलीट करें",
    "button_delete_community": "कम्युनिटी डिलीट करें",
    "button_delete_activity": "एक्टिविटी को डिलीट करें",
    "library_header_description": "आपकी हेल्थ के सफ़र में आपको शिक्षित करने, जोड़ने और मोटिवेट करने के लिए ओरिजिनल कंटेंट।",
    "library_searchbar": "लाइब्रेरी में खोजें…",
    "library_page_header": "आपकी हेल्थ के सफ़र में आपको जानकारी देने, जोड़ने और मोटिवेट करने के लिए ओरिजिनल कंटेंट।",
    "onboarding_button_title": "मैंने कर लिया है",
    "refresh_bar": "अपडेट करने के लिए यहां क्लिक करें",
    "content": {
        "min_read": "%{readingTime} मिनट पढ़ा गया"
    },
    "noMembers": "कोई मेंबर नहीं",
    "saved": "सेव किया गया",
    "forYou": "आपके लिए",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "द्वारा %{badgeInstruction}",
    "youCanEarnThisBadge": "आप यह बैज हर %{period} में एक बार कमा सकते हैं",
    "emailPreferences": "ईमेल की प्राथमिकताएँ",
    "unsubscribeText": "सभी ईमेल अपडेट से ऑप्ट आउट करें",
    "savingText": "सेव किया जा रहा है...",
    "wrongTryLater": "कुछ गलत हुआ। कृपया बाद में दोबारा कोशिश करें।",
    "preferencesSaved": "प्राथमिकताएँ सेव की गईं",
    "recommendedForYou": "आपके लिए रेकमेंड किया हुआ",
    "formerMember": {
        "label": "पहले रह चुका मेंबर"
    },
    "selectionsFromLibrary": "हमारी लाइब्रेरी से आपके लिए खासतौर पर चुनी गई किताबें",
    "goalsInfo": {
        "desc1": "अपनी वेलबीइंग बेहतर बनाने पर फ़ोकस करने के लिए",
        "desc2": "आपने मैक्सिमम संख्या में गोल्स सेट कर लिए हैं।"
    },
    "createMyOwn": "मेरा खुद का बनाएं",
    "isAllSet": "सब सेट है!",
    "undoLabel": "अनडू करें",
    "terms": "शर्तें",
    "placeOrder": "ऑर्डर करें",
    "item": "आइटम",
    "redeemFor": "के लिए रिडीम करें",
    "confirmYourOrder": "अपना ऑर्डर कन्फ़र्म करें",
    "orderComplete": "ऑर्डर पूरा हुआ",
    "redeemedFor": "के लिए रिडीम किया गया",
    "orderDetails": "ऑर्डर की जानकारी",
    "bonusGoalReward": "बोनस गोल रिवॉर्ड",
    "orderSummary": "ऑर्डर समरी",
    "logoutSSO": {
        "title": "आपने %{programName} से साइन आउट कर दिया है।",
        "description": "दोबारा जल्दी मिलेंगे!",
        "signinAgain": "साइन इन करने के लिए यहां क्लिक करें"
    },
    "nothing_to_show": "अभी दिखाने के लिए कुछ नहीं",
    "no_saved_content": "आपके पास कोई सेव किया हुआ कंटेंट नहीं है",
    "restarts_every_week": "हर हप्ते रीस्टार्ट होता है",
    "myGoals": "मेरे गोल्स",
    "goalGallery": "गोल गैलरी",
    "share_smth": "कुछ शेयर करें...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "हमारा स्टेप गोल अब और भी स्मार्ट हो गया है!",
            "description": "जैसे आपके हफ़्ते बदलते हैं, वैसे ही अब आपके गोल्स भी बदलेंगे!\nस्मार्ट मोड के साथ, आपका स्टेप गोल आपकी असली ज़िंदगी की एक्टिविटी के आधार पर खुद को अपने आप एडजस्ट करेगा।\nयह आपकी सफलता और वेलबीइंग को ध्यान में रखकर सेट किया गया है।",
            "action": "इसे देखें!"
        },
        "mePage": {
            "title": "नया मैं",
            "description": "हमने आपके लिए जरूरी चीज़ों को आसानी से खोजने के लिए मैं सेक्शन को फिर से डिज़ाइन किया है – इसे देखें!",
            "letsSeeBtn": "चलिए देखते है!",
            "llaterBtn": "शायद बाद में"
        },
        "bellEAP": {
            "title": "आपके कर्मचारी और परिवार सहायता प्रोग्राम के ऑनलाइन प्लेटफॉर्म में आपका स्वागत है!",
            "description": "आपको और आपके परिवार के सदस्यों के लिए उपलब्ध वेलबीइंग और ज़िंदगी के चैलेंजेस को सपोर्ट करने के लिए टूल्स और सर्विसेज़ को एक्सप्लोर करें",
            "button": "अभी कनेक्ट करें या किसी भी समय क्विक लिंक्स पेज पर जाएं"
        },
        "quickActivityLogView": {
            "title": "अपनी मौजूदा एक्टिविटी को देखने का एक तेज़ तरीका",
            "description": "अब आप अपना एक्टिविटी लॉग देखने के लिए प्रोग्रेस बार पर क्लिक कर सकते हैं।"
        }
    },
    "goalSmartMode": {
        "title": "स्मार्ट मोड",
        "description": "अपनी मौजूदा एक्टिविटी लेवल के आधार पर पर्सनलाइज़ किए हुए हर हफ़्ते के टार्गेट पाएं।",
        "status": "स्मार्ट मोड इस गोल के लिए %{status} है।",
        "infoModal": {
            "descriptionOne": "जब स्मार्ट मोड चालू किया जाएगा, तो इस गोल का टार्गेट आपकी मौजूदा एक्टिविटी लेवल के आधार पर हफ़्ते-दर-हफ़्ते बदलता रहेगा।",
            "descriptionTwo": "हम आपको बिल्कुल सही मात्रा में चैलेंज देंगे ताकि आप सफलता के लिए सेट हो सकें।",
            "instructions": "आप अपने %{settings} में स्मार्ट मोड को चालू या बंद कर सकते हैं"
        },
        "settings": {
            "switch": "मेरे स्टेप गोल के लिए स्मार्ट मोड इनेबल करें",
            "description": "जब स्मार्ट मोड चालू किया जाएगा, तो आपको हर हफ़्ते की शुरुआत में एक नया स्टेप टार्गेट मिलेगा।"
        },
        "enableSmartMode": "स्मार्ट मोड इनेबल करें",
        "settingsModal": {
            "descriptionTurnOn": "आपका स्टेप गोल टार्गेट हफ़्ते आपकी एक्टिविटी के आधार पर बदलेगा",
            "descriptionTurnOff": "आपका स्टेप गोल टार्गेट अब हर हफ़्ते पर्सनलाइज़ नहीं जाएगा"
        }
    },
    "On": "चालू",
    "Off": "बंद",
    "top_posts": "टॉप के पोस्ट",
    "most_recent": "सबसे नया",
    "browseByTopic": "टॉपिक के अनुसार ब्राउज़ करें",
    "video": "वीडियो",
    "enable": "इनेबल करें",
    "turnOff": "बंद करें",
    "new_post": "नई पोस्ट",
    "new_post_in": "में नई पोस्ट",
    "dailyTarget": "डेली टार्गेट",
    "dailyTargetForWeek": "हफ़्ते का डेली टार्गेट",
    "showMyActivityLog": "मेरी एक्टिविटी लॉग दिखाएं",
    "usersReacted": {
        "oneOther": "%{userName} और 1 दूसरा व्यक्ति",
        "multipleOthers": "%{userName} और %{count} दूसरे लोग"
    },
    "reactionsModal": {
        "title": "खुशियाँ मनाने के और तरीके",
        "description": "नई सोशल पोस्ट रिएक्शन के जरिए अपने सहयोगियों का हौसला बढ़ाएं!"
    },
    "account": "अकाउंट",
    "myWellbeingProfile": "मेरी वेलबीइंग प्रोफ़ाइल",
    "physicalDetailsDescription": "यह जानकारी आपके वेलबीइंग स्कोर को कैलकुलेट करने के लिए जरूरी है",
    "wellbeingInterests": "वेलबीइंग दिलचस्पियाँ",
    "myWellbeingInterests": "मेरी वेलबीइंग दिलचस्पियाँ",
    "preferredNameOptional": "पसंदीदा नाम (वैकल्पिक)",
    "basicPhysicalDetails": "बेसिक शारीरिक जानकारी",
    "notRegistered": {
        "infoModal": {
            "title": "हम आपको नहीं ढूंढ पा रहे हैं",
            "notInSystem": "हमारे सिस्टम में नहीं है।",
            "correctEmail": "सही अकाउंट का इस्तेमाल करें (आमतौर पर कंपनी का ईमेल एड्रेस) और टाइपो गलतियां चेक करें।",
            "emailHelp": "ज़्यादा सहायता के लिए, हमारी सहायता टीम को यहां ईमेल करें"
        }
    },
    "dontHaveAccount": "क्या आपके पास अकाउंट नहीं है?",
    "wasThisHelpful": "क्या इससे आपको मदद मिली?",
    "healthScoreFeedbackModal": {
        "emojiSection": "यह पेज और आपका वेलबीइंग स्कोर कितना मददगार है?",
        "commentSectionText": "उन्हें कैसे सुधारा जा सकता है?",
        "commentSectionPlaceholder": "कमेंट जोड़ें...",
        "thankYouModal": "आपके फीडबैक के लिए शुक्रिया!"
    },
    "number_connected": "%{numDevices} कनेक्ट किया गया",
    "searchPlaceHolder": "खोजें...",
    "noTeamsFound": "कोई टीम नहीं मिली",
    "join_a_challenge": "चैलेंज को जॉइन करें",
    "me_page_titles": {
        "goal": {
            "singular": "गोल",
            "plural": "गोल्स"
        },
        "challenge": {
            "singular": "चैलेंज",
            "plural": "चैलेंजेस"
        }
    },
    "seeMoreText": "…ज़्यादा देखें",
    "adjust_entry": "कृपया एंट्री को एडजस्ट करें",
    "overTracking": {
        "title": "ज़्यादा ट्रैकिंग करने की चेतावनी",
        "desc1": {
            "singular": "इस एंट्री को ऑडिट किया जाएगा।",
            "plural": "इन एंट्रीज़ को ऑडिट किया जाएगा।"
        },
        "desc2": "जानबूझकर ज़्यादा ट्रैकिंग करने से अकाउंट सपस्पेंड किया जा सकता है।",
        "button_edit": "मेरी एंट्रीज़ एडिट करें",
        "button_confirm": "जैसा है वैसा ही सबमिट करें"
    },
    "oneEventAttendee": "1 भाग लेने वाला व्यक्ति",
    "multipleEventAttendees": "%{num} भाग लेने वाले लोग",
    "to": "को",
    "eventBonusFull": "इस इवेंट में भाग लेने पर आपको %{number} बोनस %{points} मिलेंगे।",
    "eventBonusBold": "%{number} बोनस %{points}",
    "didYouLikeArticle": "क्या आपको यह आर्टिकल पसंद आया?",
    "didYouLikeVideo": "क्या आपको यह वीडियो पसंद आया?",
    "tellUsMore": "हमें और ज़्यादा बताएं...",
    "thanksForFeedback": "आपके फीडबैक के लिए शुक्रिया!",
    "challengesSubtitle": "अन्य सहभागियों के साथ मिलकर टार्गेट हासिल करें - या जीतने के लिए खेलें!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "आपका पासवर्ड आपके %{telusVC} अकाउंट के ज़रिए मैनेज किया जाता है।",
            "button": "मेरा %{virtualCare} पासवर्ड बदलें"
        }
    },
    "actions": "एक्शन",
    "onAndUpcoming": "चालू और आगामी",
    "termsAndPrivacyPolicyNew": "जारी रखने पर, आप सहमत होते हैं",
    "invitedToTeam": "%{firstName} %{lastName} की टीम में इन्वाइट किया गया",
    "decline": "इंकार करें",
    "invitedToChallenge": "%{firstName} %{lastName} द्वारा इन्वाइट किया",
    "goalsCard": {
        "emptyStateTitle": "आपके पास कोई गोल सेट नहीं है"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "आप किसी भी चैलेंज में नहीं हैं",
        "buttonLabel": "चैलेंज एक्सप्लोर करें"
    },
    "menu": "मेनू",
    "everyone": "सब",
    "confirmEmployeeID": "कर्मचारी ID कन्फ़र्म करें",
    "employeeIDNoMatch": "ये ID अभी तक मेल नहीं खाती हैं",
    "hidePost": "%{ownerName} अनुसार पोस्ट छिपाएं",
    "hidingUserPostToast": {
        "success": {
            "title": "यूज़र छिपाया गया",
            "message": "अब आप इस यूज़र की पोस्ट नहीं देखेंगे।"
        }
    },
    "moderateHideUserDescription": "इस यूज़र के लिए पोस्ट छुपाने से स्ट्रीम से यूज़र से जुड़ा कंटेंट हटा दिया जाएगा।",
    "startsInOneDay": "1 दिन में शुरू हो रहा है",
    "endsInOneDay": "1 दिन में समाप्त हो रहा है",
    "endsToday": "आज समाप्त हो रहा है",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "हमारे सिस्टम में नहीं है। क्या आपने उसे सही तरीके से दाखिल किया है?",
            "administrator": "अगर आप एक नए कर्मचारी हैं, तो शायद हमारे पास अभी तक आपका कर्मचारी ID नहीं हो सकता है। कृपया अपने एडमिनिस्ट्रेटर से पूछें कि दोबारा कोशिश कब करें।",
            "emailNotInSystem": "अगर आप नए कर्मचारी हैं, तो शायद आपकी ईमेल अभी तक हमारे सिस्टम में नहीं जोड़ी गई हो। कृपया अपने एडमिनिस्ट्रेटर से पूछें कि दोबारा कोशिश कब करें।",
            "eligibleEmail": "यह ईमेल एड्रेस सही नहीं है। क्या आपने इसे सही तरीके से दाखिल किया है?"
        }
    },
    "oneMember": "1 मेंबर",
    "programCode": {
        "infoModal": {
            "unique": "आपकी कंपनी का एक यूनिक प्रोग्राम कोड होता है जो आमतौर पर आपको ईमेल के ज़रिये दिया जाता है।",
            "support": "अगर आपको अपना कोड नहीं मिल रहा है, तो अपने वेलनेस प्रोग्राम एडमिनिस्ट्रेटर से कॉन्टेक्ट करें या अपनी कंपनी के नाम के साथ support@sproutatwork.com पर ईमेल करें।"
        },
        "instructions": "शुरू करने के लिए अपने एम्प्लॉयर द्वारा दिया गया प्रोग्राम कोड दाखिल करें"
    },
    "whatsMyProgramCode": "मेरा प्रोग्राम कोड क्या है?",
    "enjoyApp": "अपनी मोबाइल ऐप पर एंजॉय करें",
    "programCodeLabel": "प्रोग्राम कोड",
    "createdByMembersChallenges": "मेंबर द्वारा बनाया गया",
    "invites": "इन्वाइट",
    "recommendedContentTitle": "लाइब्रेरी की आपके लिए पसंदीदा किताबें",
    "amountExchanged": "एक्सचेंज की गई रकम",
    "orderStatus": "ऑर्डर का स्टेटस",
    "orderSuccessfulyyItemForConfirmation": "ऑर्डर सफल! %{email} पर एक कन्फ़र्मेशन भेज दिया गया है।",
    "orderedOnDateText": "%{orderCreatedTime} को ऑर्डर किया गया",
    "personalize": {
        "communities": {
            "title": "कम्युनिटीज़ को जॉइन करें",
            "description": "कम्युनिटीज़ समान दिलचस्पियों वाले लोगों को जोड़ते हैं। आप किसी भी समय कम्युनिटी को जॉइन कर सकते हैं या उसे छोड़ सकते हैं।"
        },
        "objectives": {
            "title": "मेरे ऑब्जेक्टिव्स",
            "description": "हम आपको क्या शुरू करने या बनाए रखने में मदद कर सकते हैं? हम अपनी रेकमेंडेशन्स को बेहतर बनाने के लिए इसका इस्तेमाल करेंगे।"
        },
        "topics": {
            "title": "मेरे वेलबीइंग टॉपिक",
            "description": "आपको इन सिलेक्शन के बारे में ज़्यादा टिप्स और कैसे करें कंटेन्ट दिखाई देगा।"
        }
    },
    "recommendedCardDesc": "अपनी वेलबीइंग को बेहतर बनाने पर फ़ोकस करने के लिए 3 गोल्स सेट करें",
    "accessibility": {
        "track_activity": "एक्टिविटी को ट्रैक करें",
        "cardbody": "कार्ड बॉडी",
        "cardcontainer": "कार्ड कंटेनर",
        "cardfooter": "कार्ड फूटर",
        "unstartedChallengeHeader": "शुरू न की गई चैलेंज",
        "activeOrEndedChallengeWrapper": "चैलेंज रैपर",
        "activeOrEndedChallengeHeader": "चैलेंज हेडर",
        "goalHeader": "गोल हेडर",
        "openOptions": "विकल्प खोलें"
    },
    "teams": {
        "teamInvites": "टीम के इन्वाइट",
        "findTeam": "टीम खोजें",
        "teamFull": "टीम पूरी हो चुकी है"
    },
    "deleteAccountText": "अपने Sprout At Work अकाउंट और उसके सभी डेटा को स्थायी रूप से डिलीट करें",
    "deleteAccountButtonTitle": "मेरा अकाउंट डिलीट करें",
    "joinTeamActionSheetText": "इस चैलेंज में भाग लेने के लिए किसी टीम को जॉइन करें या कोई टीम बनाएं",
    "frequencyNone": "कोई नहीं",
    "quickLinkTitle": "क्विक लिंक",
    "moreTab": "और ज़्यादा",
    "addedBy": "%{companyName} द्वारा जोड़ा गया",
    "teamsTitle": "टीम",
    "helpAndSupport": "ऐप हेल्प और सपोर्ट",
    "feedbackTitle": "फ़ीडबैक दें",
    "feedbackDescription": "हमें बताएं कि आपको ऐप में क्या पसंद है, और हम कहाँ इसे बेहतर कर सकते हैं।",
    "leaveTeamAction": "टीम छोड़ें",
    "teamActions": "टीम एक्शन",
    "leaveTeamLeaveChallenge": "इस टीम को छोड़ने का मतलब है कि आप चैलेंज छोड़ रहे हैं। भाग लेना जारी रखने के लिए आपको किसी टीम को जॉइन करना होगा।",
    "familyMembers": "परिवार के सदस्य",
    "familyMembersDescription": "परिवार के सदस्यों की उम्र 16 साल से ज़्यादा होनी चाहिए। उन्हें पूरे प्लेटफॉर्म पर पूरा एक्सेस और विजिबिलिटी मिलेगी।",
    "learnMoreButton": "ज़्यादा जानें",
    "thvcSelection": {
        "signUpUsingTelus": "अपने TELUS Health Virtual Care अकाउंट का इस्तेमाल करके साइन अप करें",
        "loginGetStarted": "शुरू करने के लिए Virtual Care में लॉग इन करें",
        "haveAccount": "क्या आपके पास Virtual Care अकाउंट है?",
        "emailHelp": "मदद चाहिए? हमारी सहायता टीम से कॉन्टेक्ट करें",
        "yes": "हाँ",
        "signMeUp": "नहीं, मुझे साइन अप करें"
    },
    "inviteFamilyMember": {
        "label": "परिवार के सदस्य को इन्वाइट करें",
        "btn": "इन्विटेशन भेजें",
        "email": "ईमेल एड्रेस*",
        "firstName": "पहला नाम*",
        "lastName": "आखिरी नाम*",
        "approval": "मैं कन्फ़र्म करता हूं कि मुझे इस परिवार के सदस्य को %{company} में इनवाइट करने की इजाज़त है",
        "multiSelect1": "क्या यह परिवार का सदस्य आपके क्षेत्र में बालिग उम्र से ज़्यादा है?",
        "multiSelect2": "क्या यह परिवार का सदस्य कम से कम 16 साल का है?",
        "confirmTermsPolicy": "मैं कन्फ़र्म करता हूँ कि मैं इस व्यक्ति का कानूनी अभिभावक हूँ। मेरे विचार से, आश्रित व्यक्ति प्लेटफ़ॉर्म के इस्तेमाल के लिए सहमत होने के लिए पूरे तरीके से बालिग है, और मैं उन्हें इसमें शामिल होने की इजाज़त देता हूँ। मैं आश्रित व्यक्ति को प्लेटफ़ॉर्म पर जिम्मेदार व्यवहार की जरूरत और प्लेटफ़ॉर्म द्वारा उनके डेटा को कलेक्ट करने और इस्तेमाल करने के तरीके के बारे में समझाऊँगा।",
        "onTheirBehalf": "उनकी ओर से.",
        "confirm": "हाँ, मैं ऊपर बताए गए को कन्फ़र्म करता हूं",
        "warning": "साइन अप करने के लिए परिवार के सदस्य की उम्र कम से कम 16 साल होनी चाहिए",
        "errorMsg": "कृपया आगे बढ़ने से पहले एरर्स को रिव्यू करें"
    },
    "deleteFamilyMember": {
        "desc": "परिवार के किसी सदस्य का अकाउंट डिलीट करना स्थायी होता है।",
        "btn": "परिवार के सदस्य को डिलीट करें",
        "confirmation": {
            "title": "परिवार के सदस्य को डिलीट कर दिया गया",
            "desc": "%{fullName} का अकाउंट डिलीट कर दिया गया"
        },
        "areYouSure": "क्या आप वाकई %{fullName} के अकाउंट को डिलीट करना चाहते है?"
    },
    "familyInvitationStatus": {
        "active": "एक्टिव",
        "sent": "इन्विटेशन भेजा गया"
    },
    "familyInvitationSent": {
        "title": "इन्विटेशन ईमेल भेजा गया",
        "desc": "%{fullName} को इन्वाइट भेजा गया"
    },
    "programCodeSignup": "कृपया '%{signUpLabel}' पर क्लिक करने के बाद %{programCodeLabel} %{programCode} का इस्तेमाल करें",
    "notJoinedCommunityLabel": "इस कम्युनिटी को जॉइन करके देखें कि मेंबर क्या शेयर कर रहे हैं",
    "moda": {
        "installApp": {
            "title": "कृपया ध्यान दें: Moda Health के मेंबर सिर्फ़ अपने मेंबर डैशबोर्ड के ज़रिये ही Sprout at Work को एक्सेस कर सकते हैं।",
            "subtitle": "अपने स्मार्टफोन पर Sprout at Work का इस्तेमाल करने के लिए:",
            "stepOneA": "1. Sprout at Work मोबाइल ऐप इंस्टॉल करें।",
            "stepOneB": "मोबाइल ऐप पर साइन अप या लॉग इन न करें।",
            "stepTwo": "2. अपने मोबाइल फोन पर मेंबर डैशबोर्ड में लॉग इन करें",
            "stepThree": "3. Sprout वेलनेस प्रोग्राम ब्राउज़ करें और उस लिंक को फॉलो करें - इससे Sprout at Work मोबाइल ऐप खुल जाएगा।"
        }
    },
    "HRISLocationSelection": {
        "title": "आप किस देश से काम करते हैं?"
    },
    "visibilitySettings": {
        "title": "विज़िबिलिटी सेटिंग्स",
        "desc1": "क्या यह ठीक है कि आपकी कंपनी के दूसरे वेलबीइंग ऐप मेंबर्स को आप दिखाई दें?",
        "desc2": "आप इसे बाद में कभी भी बदल सकते हैं।",
        "moreTextQ1": "दूसरे लोग क्या देख सकते हैं?",
        "moreTextAnswer1": "आपका नाम, प्रोफ़ाइल फ़ोटो और बेसिक प्रोफ़ाइल की जानकारी (जैसे डिपार्टमेंट और लोकेशन) आपकी कंपनी के लोगों द्वारा देखे जा सकते हैं। यह ऐप को ज़्यादा सोशल और मज़ेदार बनाता है।",
        "moreTextQ2": "मैं कहाँ दिखाई देता हूँ?",
        "moreTextAnswer2": "आप जिन चैलेंजेस, कम्युनिटीज़ और इवेंट्स को जॉइन करेंगे, उनमें लीडरबोर्ड में और खोज परिणामों में आपको सहभागी के रूप में दिखाया जाएगा। आप इसे बाद में बदल सकते हैं।",
        "moreTextAnswer3": "हम आपकी पर्सनल हेल्थ से जुड़ी जानकारी, जैसे आपकी ऊँचाई, वज़न या आपकी ट्रैक की गई एक्टिविटीज़ किसी को नहीं दिखाते और न ही शेयर करते हैं।",
        "btnAgree": "आप मुझे दिखा सकते हैं",
        "btnDisagree": "दूसरे मेंबर को मुझे देखने न दें"
    },
    "privacyPolicyReadMore": "ज़्यादा जानकारी के लिए हमारी गोपनियता नीति पढें",
    "tellMeMore": "मुझे और ज़्यादा बताएं",
    "helpUsImprove": {
        "title": "बेहतर होने में हमारी मदद करें",
        "desc1": "हम ऐसे टूल का इस्तेमाल करते हैं जो अनजान इस्तेमाल के डेटा को रिकॉर्ड करते हैं। लोग क्या देखते हैं और क्या क्लिक करते हैं, इसके ट्रेंड को देखकर हमें ऐप को बेहतर बनाने में मदद मिलती है।",
        "desc2": "आप इसे किसी भी समय बंद कर सकते हैं।",
        "moreTextQ1": "हम क्या देखते हैं",
        "moreTextAnswer1": "हम ओवरऑल ट्रेंड और स्टैटिस्टिक्स में दिलचस्पी रखते हैं, इसलिए हम पर्सनल लेवल पर डेटा नहीं देखते हैं।",
        "moreTextQ2": "हम आपका डेटा शेयर नहीं करते",
        "moreTextAnswer2": "यह डेटा सिर्फ़़ उन लोगों के लिए उपलब्ध है जो इस ऐप को बेहतर बनाने में मदद करने के लिए इसे बनाते हैं। हम इसे आपके एम्प्लॉयर सहित दूसरी कंपनियों के साथ शेयर नहीं करते हैं।",
        "moreTextQ3": "आपका डेटा अनजान है",
        "moreTextAnswer3": "हमारे टूल्स आपका नाम, सटीक लोकेशन या कोई भी पर्सनल हेल्थ की जानकारी रिकॉर्ड नहीं करते हैं।",
        "btnAgree": "मेरे इस्तेमाल\/यूसेज को अनजान रूप से ट्रैक करें",
        "btnDisagree": "मैं ट्रैकिंग के लिए इजाज़त नहीं देता हूं"
    },
    "deleteAccountTextAppName": "अपने %{appName} अकाउंट और उसके सभी डेटा को स्थायी रूप से डिलीट करें",
    "anonymousMember": "अनजान मेंबर",
    "activitiesToTrack": {
        "title": "ट्रैक करने के लिए एक्टिविटीज़"
    },
    "includedInMembership": "आपके मेम्बरशिप में शामिल है",
    "invalidDate": "अमान्य तारीख",
    "discardsStreamPost": {
        "discardTitle": "पोस्ट को खारिज करें?",
        "discardChangesTitle": "बदलावों को खारिज करें?",
        "discardPostText": "क्या आप वाकई अपनी पोस्ट को खारिज करना चाहते हैं?",
        "discardPostChangesText": "क्या आप वाकई अपने बदलावों को खारिज करना चाहते हैं?"
    },
    "trackActivityModalTitle": "%{date} के लिए ट्रैक करें",
    "noPosts": "कोई पोस्ट देखने के लिए नहीं है",
    "goalIcon": "गोल का आइकन",
    "resetsOn": "%{date} को रीसेट होगा",
    "clickForHelp": "सहायता के लिए यहां क्लिक करें",
    "trackActivityInputLabel": "%{unit} %{activityName} %{dateFormat} दाखिल करें",
    "itemsFound": "आइटम्स मिले",
    "tagState": {
        "active": "एक्टिव",
        "notActive": "एक्टिव नहीं"
    },
    "bonusCheckmarkLabel": "पूरा करने पर %{bonusLabel} बोनस पॉइंट मिले",
    "searchBar": {
        "searching": "%{term} को खोजा जा रहा है",
        "result": "खोज परिणाम"
    },
    "activityProgress": "एक्टिविटी प्रोग्रेस - %{levelName} %{percentFilled}% - %{daysLeft} दिनों में रीसेट हो जाएगी",
    "bookmark": {
        "remove": "सेव किए गए आइटम में से हटाएं",
        "save": "इस आइटम को सेव करें"
    },
    "bonusMark": {
        "earn": "%{qty} %{points} कमाएं",
        "earned": "आपने %{qty} %{points} कमाएं"
    },
    "tabToTrackActivity": "एक्टिविटी ट्रैक करने के लिए टैप करें",
    "videoElementLabel": "%{title}, अवधि %{duration}, वीडियो चलाने के लिए डबल टैप करें",
    "updatedPoliciesPopup": {
        "title": "हमने अपनी शर्तें अपडेट कर दी हैं",
        "details": "हम आपको नीचे दी गई हमारी अपडेट की हुई नीतियों को पढ़ने की सलाह देते हैं:",
        "disclaimer": "नीचे दिए गए बटन पर क्लिक करके आप अपडेटेड नीतियों से सहमत होते हैं और उन्हें स्वीकार करते हैं।",
        "agree": "मैं सहमत हूं"
    },
    "editActivityLog": {
        "canNotEditItem": "आप यह एंट्री एडिट नहीं कर सकते",
        "canNotEditItemDescription": "डिवाइस या ऐप से सिंक की गई एक्टिविटीज़ के लिए एडिट करना उपलब्ध नहीं है।",
        "updatedItem": "एक्टिविटी को अपडेट किया गया",
        "updatedItemDescription": "आपके बदलाव सेव कर लिए गए हैं।"
    },
    "login_with_email": "ईमेल से लॉग इन करें",
    "healthconnect_not_available": "Health Connect से कनेक्ट करने में असमर्थ। Health Connect ऐप में, कृपया सुनिश्चित करें कि परमिशन इनेबल की गई हैं।",
    "registrationField": {
        "required": {
            "firstName": "कृपया अपना पहला नाम दाखिल करें",
            "lastName": "कृपया अपना आखिरी नाम दाखिल करें",
            "email": "कृपया एक मान्य ईमेल एड्रेस दाखिल करें",
            "password": "कृपया एक मान्य पासवर्ड दाखिल करें"
        }
    },
    "settingsErrorMessage": {
        "firstName": "कृपया अपना पहला नाम दाखिल करें",
        "lastName": "कृपया अपना आखिरी नाम दाखिल करें"
    },
    "requiredValidValue": "कृपया अपने %{value} के लिए एक मान्य वैल्यू दाखिल करें",
    "passwordHidden": "पासवर्ड छिपा हुआ है, पासवर्ड दिखाने के लिए टैप करें",
    "passwordShown": "पासवर्ड दिखाया गया है, पासवर्ड छिपाने के लिए टैप करें",
    "libraryHeaderContent": {
        "category": "यह आइटम %{category} कैटेगरी में आता है।",
        "points": "%{points} पॉइंट्स कमाएं।"
    },
    "scoreCurrentPeriod": "%{text} %{startDate} से %{endDate} तक है",
    "scoreCurrent": "%{text} के %{points} पॉइंट्स हैं",
    "abbotResetPasswordModal": {
        "title": "क्या आप पिछले साल के किसी अकाउंट को एक्सेस करने की कोशिश कर रहे हैं?",
        "text": "अगर आपने पिछले साल चैलेंज के लिए साइन अप किया था, तो वह अकाउंट अब काम नहीं करेगा। आपको इस साल के लिए अलग से साइन अप करना होगा।",
        "goToResetPasswordBtn": "मैंने %{currentYear} में साइन अप किया था",
        "goToSignupBtn": "मैंने %{currentYear} में साइन अप नहीं किया है"
    },
    "challengeRegistrationClosed": "रजिस्ट्रेशन बंद हुआ - चैलेंज शुरू हो चुका है"
};